
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired2d1"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired2d1"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.2.6";

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_427) {
            var $dca0ddb82b882518$var$element$jscomp$inline_428 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_428.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = $dca0ddb82b882518$var$isSupported$jscomp$inline_427;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$66);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$69 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$69, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useEffectEvent = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            nextProps = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps));
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextPrimaryChildren.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $dca0ddb82b882518$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $dca0ddb82b882518$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, suspenseContext);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, props[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(props, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, props.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $dca0ddb82b882518$var$now(), current.sibling = null, renderLanes = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        };
        $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0;
        timeoutOffset = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$170, root$170 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1577 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1577 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1577++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1578 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1577], $dca0ddb82b882518$var$domEventName$jscomp$inline_1579 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1578.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1579, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $dca0ddb82b882518$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$243 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$243 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $dca0ddb82b882518$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$249)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $acw62.version;
if ("19.2.6" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.6"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.6",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.2.6"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2348.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2348.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2348.inject($dca0ddb82b882518$var$internals$jscomp$inline_2347), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.2.6";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});

parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.2.6";

});



parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});


var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));


const $854f95049fa434c4$var$C = {
    stringify: (t)=>t ? "true" : "false",
    parse: (t)=>/^[ty1-9]/i.test(t)
}, $854f95049fa434c4$var$O = {
    stringify: (t)=>t.name,
    parse: (t, e, c)=>{
        const n = (()=>{
            if (typeof window < "u" && t in window) return window[t];
            if (typeof $parcel$global < "u" && t in $parcel$global) return $parcel$global[t];
        })();
        return typeof n == "function" ? n.bind(c) : void 0;
    }
}, $854f95049fa434c4$var$j = {
    stringify: (t)=>JSON.stringify(t),
    parse: (t)=>JSON.parse(t)
};
function $854f95049fa434c4$var$k(t) {
    return t.replace(/([a-z0-9])([A-Z])/g, (e, c, n)=>`${c}-${n.toLowerCase()}`);
}
function $854f95049fa434c4$var$N(t) {
    return t.replace(/[-:]([a-z])/g, (e, c)=>`${c.toUpperCase()}`);
}
const $854f95049fa434c4$var$S = /* @__PURE__ */ Symbol.for("r2wc.bound"), $854f95049fa434c4$var$P = {
    parse: (t, e, c)=>{
        const n = $854f95049fa434c4$var$N(e), u = c;
        if (typeof u < "u" && n in u && typeof u[n] < "u") {
            let a = u[n];
            return $854f95049fa434c4$var$S in u[n] || (a = a.bind(u), Object.defineProperty(a, $854f95049fa434c4$var$S, {
                value: !0
            })), a;
        } else return;
    }
}, $854f95049fa434c4$var$x = {
    stringify: (t)=>`${t}`,
    parse: (t)=>parseFloat(t)
}, $854f95049fa434c4$var$E = {
    stringify: (t)=>t,
    parse: (t)=>t
}, $854f95049fa434c4$var$w = {
    string: $854f95049fa434c4$var$E,
    number: $854f95049fa434c4$var$x,
    boolean: $854f95049fa434c4$var$C,
    function: $854f95049fa434c4$var$O,
    method: $854f95049fa434c4$var$P,
    json: $854f95049fa434c4$var$j
}, $854f95049fa434c4$var$b = /* @__PURE__ */ Symbol.for("r2wc.render"), $854f95049fa434c4$var$y = /* @__PURE__ */ Symbol.for("r2wc.connected"), $854f95049fa434c4$var$h = /* @__PURE__ */ Symbol.for("r2wc.context"), $854f95049fa434c4$var$p = /* @__PURE__ */ Symbol.for("r2wc.props");
function $854f95049fa434c4$export$2e2bcd8739ae039(t, e, c) {
    e.props || (e.props = t.propTypes ? Object.keys(t.propTypes) : []), e.events || (e.events = []);
    const n = Array.isArray(e.props) ? e.props.slice() : Object.keys(e.props), u = Array.isArray(e.events) ? e.events.slice() : Object.keys(e.events), a = {}, A = {}, d = {}, m = {};
    for (const r of n){
        a[r] = Array.isArray(e.props) ? "string" : e.props[r];
        const s = $854f95049fa434c4$var$k(r);
        d[r] = s, m[s] = r;
    }
    for (const r of u)A[r] = Array.isArray(e.events) ? {} : e.events[r];
    class v extends HTMLElement {
        static get observedAttributes() {
            return Object.keys(m);
        }
        [$854f95049fa434c4$var$y] = !0;
        [$854f95049fa434c4$var$h];
        [$854f95049fa434c4$var$p] = {};
        container;
        constructor(){
            super(), e.shadow ? this.container = this.attachShadow({
                mode: e.shadow
            }) : this.container = this, this[$854f95049fa434c4$var$p].container = this.container;
            for (const s of n){
                const l = d[s], o = this.getAttribute(l), i = a[s], f = i ? $854f95049fa434c4$var$w[i] : null;
                f?.parse && (o || i === "method") && (this[$854f95049fa434c4$var$p][s] = f.parse(o, l, this));
            }
            for (const s of u)this[$854f95049fa434c4$var$p][s] = (l)=>{
                const o = s.replace(/^on/, "").toLowerCase();
                this.dispatchEvent(new CustomEvent(o, {
                    detail: l,
                    ...A[s]
                }));
            };
        }
        connectedCallback() {
            this[$854f95049fa434c4$var$y] = !0, this[$854f95049fa434c4$var$b]();
        }
        disconnectedCallback() {
            this[$854f95049fa434c4$var$y] = !1, this[$854f95049fa434c4$var$h] && c.unmount(this[$854f95049fa434c4$var$h]), delete this[$854f95049fa434c4$var$h];
        }
        attributeChangedCallback(s, l, o) {
            const i = m[s], f = a[i], g = f ? $854f95049fa434c4$var$w[f] : null;
            i in a && g?.parse && (o || f === "method") && (this[$854f95049fa434c4$var$p][i] = g.parse(o, s, this), this[$854f95049fa434c4$var$b]());
        }
        [$854f95049fa434c4$var$b]() {
            this[$854f95049fa434c4$var$y] && (this[$854f95049fa434c4$var$h] ? c.update(this[$854f95049fa434c4$var$h], this[$854f95049fa434c4$var$p]) : this[$854f95049fa434c4$var$h] = c.mount(this.container, t, this[$854f95049fa434c4$var$p]));
        }
    }
    for (const r of n){
        const s = d[r], l = a[r];
        Object.defineProperty(v.prototype, r, {
            enumerable: !0,
            configurable: !0,
            get () {
                return this[$854f95049fa434c4$var$p][r];
            },
            set (o) {
                this[$854f95049fa434c4$var$p][r] = o;
                const i = l ? $854f95049fa434c4$var$w[l] : null;
                if (i?.stringify) {
                    const f = i.stringify(o, s, this);
                    this.getAttribute(s) !== f && (f == null ? this.removeAttribute(s) : this.setAttribute(s, f));
                } else r in a && i?.parse && (o || l === "method") && (this[$854f95049fa434c4$var$p][r] = i.parse(o, s, this)), this[$854f95049fa434c4$var$b]();
            }
        });
    }
    return v;
}


function $b8cd6b83d6b11fb7$var$f(t, e, r) {
    const n = (0, $7e96a608cb33bf79$exports.createRoot)(t), u = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(e, r);
    return n.render(u), {
        root: n,
        ReactComponent: e
    };
}
function $b8cd6b83d6b11fb7$var$i({ root: t, ReactComponent: e }, r) {
    const n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(e, r);
    t.render(n);
}
function $b8cd6b83d6b11fb7$var$a({ root: t }) {
    t.unmount();
}
function $b8cd6b83d6b11fb7$export$2e2bcd8739ae039(t, e = {}) {
    return (0, $854f95049fa434c4$export$2e2bcd8739ae039)(t, e, {
        mount: $b8cd6b83d6b11fb7$var$f,
        update: $b8cd6b83d6b11fb7$var$i,
        unmount: $b8cd6b83d6b11fb7$var$a
    });
}


var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));



var $acw62 = parcelRequire("acw62");
var $1ec499c2dc139e6f$exports = {};
!function(e, t) {
    t($1ec499c2dc139e6f$exports);
}($1ec499c2dc139e6f$exports, function(e) {
    "use strict";
    function _arrayLikeToArray(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for(var n = 0, r = Array(t); n < t; n++)r[n] = e[n];
        return r;
    }
    function _assertThisInitialized(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
    }
    function _classCallCheck(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(e, t) {
        for(var n = 0; n < t.length; n++){
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, _toPropertyKey(r.key), r);
        }
    }
    function _createClass(e, t, n) {
        return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), Object.defineProperty(e, "prototype", {
            writable: !1
        }), e;
    }
    function _createForOfIteratorHelper(e, t) {
        var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (!n) {
            if (Array.isArray(e) || (n = _unsupportedIterableToArray(e)) || t && e && "number" == typeof e.length) {
                n && (e = n);
                var r = 0, F = function() {};
                return {
                    s: F,
                    n: function() {
                        return r >= e.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: e[r++]
                        };
                    },
                    e: function(e) {
                        throw e;
                    },
                    f: F
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var a, o = !0, i = !1;
        return {
            s: function() {
                n = n.call(e);
            },
            n: function() {
                var e = n.next();
                return o = e.done, e;
            },
            e: function(e) {
                i = !0, a = e;
            },
            f: function() {
                try {
                    o || null == n.return || n.return();
                } finally{
                    if (i) throw a;
                }
            }
        };
    }
    function _createSuper(e) {
        var t = _isNativeReflectConstruct();
        return function() {
            var n, r = _getPrototypeOf(e);
            if (t) {
                var a = _getPrototypeOf(this).constructor;
                n = Reflect.construct(r, arguments, a);
            } else n = r.apply(this, arguments);
            return _possibleConstructorReturn(this, n);
        };
    }
    function _defineProperty(e, t, n) {
        return (t = _toPropertyKey(t)) in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n, e;
    }
    function _get() {
        return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, n) {
            var r = function _superPropBase(e, t) {
                for(; !({}).hasOwnProperty.call(e, t) && null !== (e = _getPrototypeOf(e)););
                return e;
            }(e, t);
            if (r) {
                var a = Object.getOwnPropertyDescriptor(r, t);
                return a.get ? a.get.call(arguments.length < 3 ? e : n) : a.value;
            }
        }, _get.apply(null, arguments);
    }
    function _getPrototypeOf(e) {
        return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e);
        }, _getPrototypeOf(e);
    }
    function _inherits(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
            constructor: {
                value: e,
                writable: !0,
                configurable: !0
            }
        }), Object.defineProperty(e, "prototype", {
            writable: !1
        }), t && _setPrototypeOf(e, t);
    }
    function _isNativeReflectConstruct() {
        try {
            var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        } catch (e) {}
        return (_isNativeReflectConstruct = function() {
            return !!e;
        })();
    }
    function ownKeys(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
        }
        return n;
    }
    function _objectSpread2(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ownKeys(Object(n), !0).forEach(function(t) {
                _defineProperty(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ownKeys(Object(n)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
        }
        return e;
    }
    function _possibleConstructorReturn(e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return _assertThisInitialized(e);
    }
    function _setPrototypeOf(e, t) {
        return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
            return e.__proto__ = t, e;
        }, _setPrototypeOf(e, t);
    }
    function _slicedToArray(e, t) {
        return function _arrayWithHoles(e) {
            if (Array.isArray(e)) return e;
        }(e) || function _iterableToArrayLimit(e, t) {
            var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
            if (null != n) {
                var r, a, o, i, u = [], s = !0, l = !1;
                try {
                    if (o = (n = n.call(e)).next, 0 === t) {
                        if (Object(n) !== n) return;
                        s = !1;
                    } else for(; !(s = (r = o.call(n)).done) && (u.push(r.value), u.length !== t); s = !0);
                } catch (e) {
                    l = !0, a = e;
                } finally{
                    try {
                        if (!s && null != n.return && (i = n.return(), Object(i) !== i)) return;
                    } finally{
                        if (l) throw a;
                    }
                }
                return u;
            }
        }(e, t) || _unsupportedIterableToArray(e, t) || function _nonIterableRest() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function _toConsumableArray(e) {
        return function _arrayWithoutHoles(e) {
            if (Array.isArray(e)) return _arrayLikeToArray(e);
        }(e) || function _iterableToArray(e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || _unsupportedIterableToArray(e) || function _nonIterableSpread() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function _toPropertyKey(e) {
        var t = function _toPrimitive(e, t) {
            if ("object" != typeof e || !e) return e;
            var n = e[Symbol.toPrimitive];
            if (void 0 !== n) {
                var r = n.call(e, t || "default");
                if ("object" != typeof r) return r;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" == typeof t ? t : t + "";
    }
    function _typeof(e) {
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e;
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, _typeof(e);
    }
    function _unsupportedIterableToArray(e, t) {
        if (e) {
            if ("string" == typeof e) return _arrayLikeToArray(e, t);
            var n = ({}).toString.call(e).slice(8, -1);
            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _arrayLikeToArray(e, t) : void 0;
        }
    }
    function _wrapNativeSuper(e) {
        var t = "function" == typeof Map ? new Map : void 0;
        return _wrapNativeSuper = function(e) {
            if (null === e || !function _isNativeFunction(e) {
                try {
                    return -1 !== Function.toString.call(e).indexOf("[native code]");
                } catch (t) {
                    return "function" == typeof e;
                }
            }(e)) return e;
            if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== t) {
                if (t.has(e)) return t.get(e);
                t.set(e, Wrapper);
            }
            function Wrapper() {
                return function _construct(e, t, n) {
                    if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
                    var r = [
                        null
                    ];
                    r.push.apply(r, t);
                    var a = new (e.bind.apply(e, r));
                    return n && _setPrototypeOf(a, n.prototype), a;
                }(e, arguments, _getPrototypeOf(this).constructor);
            }
            return Wrapper.prototype = Object.create(e.prototype, {
                constructor: {
                    value: Wrapper,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                }
            }), _setPrototypeOf(Wrapper, e);
        }, _wrapNativeSuper(e);
    }
    var t = function(e) {
        _inherits(JSBI, e);
        var t = _createSuper(JSBI);
        function JSBI(e, n) {
            var r;
            if (_classCallCheck(this, JSBI), (r = t.call(this, e)).sign = n, Object.setPrototypeOf(_assertThisInitialized(r), JSBI.prototype), e > JSBI.__kMaxLength) throw new RangeError("Maximum BigInt size exceeded");
            return _possibleConstructorReturn(r);
        }
        return _createClass(JSBI, [
            {
                key: "toDebugString",
                value: function toDebugString() {
                    var e, t = [
                        "BigInt["
                    ], n = _createForOfIteratorHelper(this);
                    try {
                        for(n.s(); !(e = n.n()).done;){
                            var r = e.value;
                            t.push((r ? (r >>> 0).toString(16) : r) + ", ");
                        }
                    } catch (e) {
                        n.e(e);
                    } finally{
                        n.f();
                    }
                    return t.push("]"), t.join("");
                }
            },
            {
                key: "toString",
                value: function toString() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 10;
                    if (2 > e || 36 < e) throw new RangeError("toString() radix argument must be between 2 and 36");
                    return 0 === this.length ? "0" : 0 == (e & e - 1) ? JSBI.__toStringBasePowerOfTwo(this, e) : JSBI.__toStringGeneric(this, e, !1);
                }
            },
            {
                key: "valueOf",
                value: function valueOf() {
                    throw new Error("Convert JSBI instances to native numbers using `toNumber`.");
                }
            },
            {
                key: "__copy",
                value: function __copy() {
                    for(var e = new JSBI(this.length, this.sign), t = 0; t < this.length; t++)e[t] = this[t];
                    return e;
                }
            },
            {
                key: "__trim",
                value: function __trim() {
                    for(var e = this.length, t = this[e - 1]; 0 === t;)t = this[--e - 1], this.pop();
                    return 0 === e && (this.sign = !1), this;
                }
            },
            {
                key: "__initializeDigits",
                value: function __initializeDigits() {
                    for(var e = 0; e < this.length; e++)this[e] = 0;
                }
            },
            {
                key: "__clzmsd",
                value: function __clzmsd() {
                    return JSBI.__clz30(this.__digit(this.length - 1));
                }
            },
            {
                key: "__inplaceMultiplyAdd",
                value: function __inplaceMultiplyAdd(e, t, n) {
                    n > this.length && (n = this.length);
                    for(var r = 32767 & e, a = e >>> 15, o = 0, i = t, u = 0; u < n; u++){
                        var s = this.__digit(u), l = 32767 & s, c = s >>> 15, d = JSBI.__imul(l, r), m = JSBI.__imul(l, a), h = JSBI.__imul(c, r), f = i + d + o;
                        o = f >>> 30, f &= 1073741823, o += (f += ((32767 & m) << 15) + ((32767 & h) << 15)) >>> 30, i = JSBI.__imul(c, a) + (m >>> 15) + (h >>> 15), this.__setDigit(u, 1073741823 & f);
                    }
                    if (0 != o || 0 !== i) throw new Error("implementation bug");
                }
            },
            {
                key: "__inplaceAdd",
                value: function __inplaceAdd(e, t, n) {
                    for(var r = 0, a = 0; a < n; a++){
                        var o = this.__halfDigit(t + a) + e.__halfDigit(a) + r;
                        r = o >>> 15, this.__setHalfDigit(t + a, 32767 & o);
                    }
                    return r;
                }
            },
            {
                key: "__inplaceSub",
                value: function __inplaceSub(e, t, n) {
                    var r = 0;
                    if (1 & t) {
                        t >>= 1;
                        for(var a = this.__digit(t), o = 32767 & a, i = 0; i < n - 1 >>> 1; i++){
                            var u = e.__digit(i), s = (a >>> 15) - (32767 & u) - r;
                            r = 1 & s >>> 15, this.__setDigit(t + i, (32767 & s) << 15 | 32767 & o), r = 1 & (o = (32767 & (a = this.__digit(t + i + 1))) - (u >>> 15) - r) >>> 15;
                        }
                        var l = e.__digit(i), c = (a >>> 15) - (32767 & l) - r;
                        if (r = 1 & c >>> 15, this.__setDigit(t + i, (32767 & c) << 15 | 32767 & o), t + i + 1 >= this.length) throw new RangeError("out of bounds");
                        0 == (1 & n) && (r = 1 & (o = (32767 & (a = this.__digit(t + i + 1))) - (l >>> 15) - r) >>> 15, this.__setDigit(t + e.length, 1073709056 & a | 32767 & o));
                    } else {
                        t >>= 1;
                        for(var d = 0; d < e.length - 1; d++){
                            var m = this.__digit(t + d), h = e.__digit(d), f = (32767 & m) - (32767 & h) - r, p = (m >>> 15) - (h >>> 15) - (r = 1 & f >>> 15);
                            r = 1 & p >>> 15, this.__setDigit(t + d, (32767 & p) << 15 | 32767 & f);
                        }
                        var v = this.__digit(t + d), D = e.__digit(d), g = (32767 & v) - (32767 & D) - r;
                        r = 1 & g >>> 15;
                        var y = 0;
                        0 == (1 & n) && (r = 1 & (y = (v >>> 15) - (D >>> 15) - r) >>> 15), this.__setDigit(t + d, (32767 & y) << 15 | 32767 & g);
                    }
                    return r;
                }
            },
            {
                key: "__inplaceRightShift",
                value: function __inplaceRightShift(e) {
                    if (0 !== e) {
                        for(var t = this.__digit(0) >>> e, n = this.length - 1, r = 0; r < n; r++){
                            var a = this.__digit(r + 1);
                            this.__setDigit(r, 1073741823 & a << 30 - e | t), t = a >>> e;
                        }
                        this.__setDigit(n, t);
                    }
                }
            },
            {
                key: "__digit",
                value: function __digit(e) {
                    return this[e];
                }
            },
            {
                key: "__unsignedDigit",
                value: function __unsignedDigit(e) {
                    return this[e] >>> 0;
                }
            },
            {
                key: "__setDigit",
                value: function __setDigit(e, t) {
                    this[e] = 0 | t;
                }
            },
            {
                key: "__setDigitGrow",
                value: function __setDigitGrow(e, t) {
                    this[e] = 0 | t;
                }
            },
            {
                key: "__halfDigitLength",
                value: function __halfDigitLength() {
                    var e = this.length;
                    return 32767 >= this.__unsignedDigit(e - 1) ? 2 * e - 1 : 2 * e;
                }
            },
            {
                key: "__halfDigit",
                value: function __halfDigit(e) {
                    return 32767 & this[e >>> 1] >>> 15 * (1 & e);
                }
            },
            {
                key: "__setHalfDigit",
                value: function __setHalfDigit(e, t) {
                    var n = e >>> 1, r = this.__digit(n), a = 1 & e ? 32767 & r | t << 15 : 1073709056 & r | 32767 & t;
                    this.__setDigit(n, a);
                }
            }
        ], [
            {
                key: "BigInt",
                value: function BigInt(e) {
                    var t = Math.floor, n = Number.isFinite;
                    if ("number" == typeof e) {
                        if (0 === e) return JSBI.__zero();
                        if (JSBI.__isOneDigitInt(e)) return 0 > e ? JSBI.__oneDigit(-e, !0) : JSBI.__oneDigit(e, !1);
                        if (!n(e) || t(e) !== e) throw new RangeError("The number " + e + " cannot be converted to BigInt because it is not an integer");
                        return JSBI.__fromDouble(e);
                    }
                    if ("string" == typeof e) {
                        var r = JSBI.__fromString(e);
                        if (null === r) throw new SyntaxError("Cannot convert " + e + " to a BigInt");
                        return r;
                    }
                    if ("boolean" == typeof e) return !0 === e ? JSBI.__oneDigit(1, !1) : JSBI.__zero();
                    if ("object" == _typeof(e)) {
                        if (e.constructor === JSBI) return e;
                        var a = JSBI.__toPrimitive(e);
                        return JSBI.BigInt(a);
                    }
                    throw new TypeError("Cannot convert " + e + " to a BigInt");
                }
            },
            {
                key: "toNumber",
                value: function toNumber(e) {
                    var t = e.length;
                    if (0 === t) return 0;
                    if (1 === t) {
                        var n = e.__unsignedDigit(0);
                        return e.sign ? -n : n;
                    }
                    var r = e.__digit(t - 1), a = JSBI.__clz30(r), o = 30 * t - a;
                    if (1024 < o) return e.sign ? -1 / 0 : 1 / 0;
                    var i = o - 1, u = r, s = t - 1, l = a + 3, c = 32 === l ? 0 : u << l;
                    c >>>= 12;
                    var d = l - 12, m = 12 <= l ? 0 : u << 20 + l, h = 20 + l;
                    for(0 < d && 0 < s && (s--, c |= (u = e.__digit(s)) >>> 30 - d, m = u << d + 2, h = d + 2); 0 < h && 0 < s;)s--, u = e.__digit(s), m |= 30 <= h ? u << h - 30 : u >>> 30 - h, h -= 30;
                    var f = JSBI.__decideRounding(e, h, s, u);
                    if ((1 === f || 0 === f && 1 == (1 & m)) && 0 == (m = m + 1 >>> 0) && 0 != ++c >>> 20 && (c = 0, 1023 < ++i)) return e.sign ? -1 / 0 : 1 / 0;
                    var p = e.sign ? -2147483648 : 0;
                    return i = i + 1023 << 20, JSBI.__kBitConversionInts[1] = p | i | c, JSBI.__kBitConversionInts[0] = m, JSBI.__kBitConversionDouble[0];
                }
            },
            {
                key: "unaryMinus",
                value: function unaryMinus(e) {
                    if (0 === e.length) return e;
                    var t = e.__copy();
                    return t.sign = !e.sign, t;
                }
            },
            {
                key: "bitwiseNot",
                value: function bitwiseNot(e) {
                    return e.sign ? JSBI.__absoluteSubOne(e).__trim() : JSBI.__absoluteAddOne(e, !0);
                }
            },
            {
                key: "exponentiate",
                value: function exponentiate(e, t) {
                    if (t.sign) throw new RangeError("Exponent must be positive");
                    if (0 === t.length) return JSBI.__oneDigit(1, !1);
                    if (0 === e.length) return e;
                    if (1 === e.length && 1 === e.__digit(0)) return e.sign && 0 == (1 & t.__digit(0)) ? JSBI.unaryMinus(e) : e;
                    if (1 < t.length) throw new RangeError("BigInt too big");
                    var n = t.__unsignedDigit(0);
                    if (1 === n) return e;
                    if (n >= JSBI.__kMaxLengthBits) throw new RangeError("BigInt too big");
                    if (1 === e.length && 2 === e.__digit(0)) {
                        var r = 1 + (0 | n / 30), a = new JSBI(r, e.sign && 0 != (1 & n));
                        a.__initializeDigits();
                        var o = 1 << n % 30;
                        return a.__setDigit(r - 1, o), a;
                    }
                    var i = null, u = e;
                    for(0 != (1 & n) && (i = e), n >>= 1; 0 !== n; n >>= 1)u = JSBI.multiply(u, u), 0 != (1 & n) && (i = null === i ? u : JSBI.multiply(i, u));
                    return i;
                }
            },
            {
                key: "multiply",
                value: function multiply(e, t) {
                    if (0 === e.length) return e;
                    if (0 === t.length) return t;
                    var n = e.length + t.length;
                    30 <= e.__clzmsd() + t.__clzmsd() && n--;
                    var r = new JSBI(n, e.sign !== t.sign);
                    r.__initializeDigits();
                    for(var a = 0; a < e.length; a++)JSBI.__multiplyAccumulate(t, e.__digit(a), r, a);
                    return r.__trim();
                }
            },
            {
                key: "divide",
                value: function divide(e, t) {
                    if (0 === t.length) throw new RangeError("Division by zero");
                    if (0 > JSBI.__absoluteCompare(e, t)) return JSBI.__zero();
                    var n, r = e.sign !== t.sign, a = t.__unsignedDigit(0);
                    if (1 === t.length && 32767 >= a) {
                        if (1 === a) return r === e.sign ? e : JSBI.unaryMinus(e);
                        n = JSBI.__absoluteDivSmall(e, a, null);
                    } else n = JSBI.__absoluteDivLarge(e, t, !0, !1);
                    return n.sign = r, n.__trim();
                }
            },
            {
                key: "remainder",
                value: function remainder(e, t) {
                    if (0 === t.length) throw new RangeError("Division by zero");
                    if (0 > JSBI.__absoluteCompare(e, t)) return e;
                    var n = t.__unsignedDigit(0);
                    if (1 === t.length && 32767 >= n) {
                        if (1 === n) return JSBI.__zero();
                        var r = JSBI.__absoluteModSmall(e, n);
                        return 0 === r ? JSBI.__zero() : JSBI.__oneDigit(r, e.sign);
                    }
                    var a = JSBI.__absoluteDivLarge(e, t, !1, !0);
                    return a.sign = e.sign, a.__trim();
                }
            },
            {
                key: "add",
                value: function add(e, t) {
                    var n = e.sign;
                    return n === t.sign ? JSBI.__absoluteAdd(e, t, n) : 0 <= JSBI.__absoluteCompare(e, t) ? JSBI.__absoluteSub(e, t, n) : JSBI.__absoluteSub(t, e, !n);
                }
            },
            {
                key: "subtract",
                value: function subtract(e, t) {
                    var n = e.sign;
                    return n === t.sign ? 0 <= JSBI.__absoluteCompare(e, t) ? JSBI.__absoluteSub(e, t, n) : JSBI.__absoluteSub(t, e, !n) : JSBI.__absoluteAdd(e, t, n);
                }
            },
            {
                key: "leftShift",
                value: function leftShift(e, t) {
                    return 0 === t.length || 0 === e.length ? e : t.sign ? JSBI.__rightShiftByAbsolute(e, t) : JSBI.__leftShiftByAbsolute(e, t);
                }
            },
            {
                key: "signedRightShift",
                value: function signedRightShift(e, t) {
                    return 0 === t.length || 0 === e.length ? e : t.sign ? JSBI.__leftShiftByAbsolute(e, t) : JSBI.__rightShiftByAbsolute(e, t);
                }
            },
            {
                key: "unsignedRightShift",
                value: function unsignedRightShift() {
                    throw new TypeError("BigInts have no unsigned right shift; use >> instead");
                }
            },
            {
                key: "lessThan",
                value: function lessThan(e, t) {
                    return 0 > JSBI.__compareToBigInt(e, t);
                }
            },
            {
                key: "lessThanOrEqual",
                value: function lessThanOrEqual(e, t) {
                    return 0 >= JSBI.__compareToBigInt(e, t);
                }
            },
            {
                key: "greaterThan",
                value: function greaterThan(e, t) {
                    return 0 < JSBI.__compareToBigInt(e, t);
                }
            },
            {
                key: "greaterThanOrEqual",
                value: function greaterThanOrEqual(e, t) {
                    return 0 <= JSBI.__compareToBigInt(e, t);
                }
            },
            {
                key: "equal",
                value: function equal(e, t) {
                    if (e.sign !== t.sign) return !1;
                    if (e.length !== t.length) return !1;
                    for(var n = 0; n < e.length; n++)if (e.__digit(n) !== t.__digit(n)) return !1;
                    return !0;
                }
            },
            {
                key: "notEqual",
                value: function notEqual(e, t) {
                    return !JSBI.equal(e, t);
                }
            },
            {
                key: "bitwiseAnd",
                value: function bitwiseAnd(e, t) {
                    var n, r = Math.max;
                    if (!e.sign && !t.sign) return JSBI.__absoluteAnd(e, t).__trim();
                    if (e.sign && t.sign) {
                        var a = r(e.length, t.length) + 1, o = JSBI.__absoluteSubOne(e, a), i = JSBI.__absoluteSubOne(t);
                        return o = JSBI.__absoluteOr(o, i, o), JSBI.__absoluteAddOne(o, !0, o).__trim();
                    }
                    return e.sign && (e = (n = [
                        t,
                        e
                    ])[0], t = n[1]), JSBI.__absoluteAndNot(e, JSBI.__absoluteSubOne(t)).__trim();
                }
            },
            {
                key: "bitwiseXor",
                value: function bitwiseXor(e, t) {
                    var n, r = Math.max;
                    if (!e.sign && !t.sign) return JSBI.__absoluteXor(e, t).__trim();
                    if (e.sign && t.sign) {
                        var a = r(e.length, t.length), o = JSBI.__absoluteSubOne(e, a), i = JSBI.__absoluteSubOne(t);
                        return JSBI.__absoluteXor(o, i, o).__trim();
                    }
                    var u = r(e.length, t.length) + 1;
                    e.sign && (e = (n = [
                        t,
                        e
                    ])[0], t = n[1]);
                    var s = JSBI.__absoluteSubOne(t, u);
                    return s = JSBI.__absoluteXor(s, e, s), JSBI.__absoluteAddOne(s, !0, s).__trim();
                }
            },
            {
                key: "bitwiseOr",
                value: function bitwiseOr(e, t) {
                    var n, r = (0, Math.max)(e.length, t.length);
                    if (!e.sign && !t.sign) return JSBI.__absoluteOr(e, t).__trim();
                    if (e.sign && t.sign) {
                        var a = JSBI.__absoluteSubOne(e, r), o = JSBI.__absoluteSubOne(t);
                        return a = JSBI.__absoluteAnd(a, o, a), JSBI.__absoluteAddOne(a, !0, a).__trim();
                    }
                    e.sign && (e = (n = [
                        t,
                        e
                    ])[0], t = n[1]);
                    var i = JSBI.__absoluteSubOne(t, r);
                    return i = JSBI.__absoluteAndNot(i, e, i), JSBI.__absoluteAddOne(i, !0, i).__trim();
                }
            },
            {
                key: "asIntN",
                value: function asIntN(e, t) {
                    var n = Math.floor;
                    if (0 === t.length) return t;
                    if (0 > (e = n(e))) throw new RangeError("Invalid value: not (convertible to) a safe integer");
                    if (0 === e) return JSBI.__zero();
                    if (e >= JSBI.__kMaxLengthBits) return t;
                    var r = 0 | (e + 29) / 30;
                    if (t.length < r) return t;
                    var a = t.__unsignedDigit(r - 1), o = 1 << (e - 1) % 30;
                    if (t.length === r && a < o) return t;
                    if ((a & o) !== o) return JSBI.__truncateToNBits(e, t);
                    if (!t.sign) return JSBI.__truncateAndSubFromPowerOfTwo(e, t, !0);
                    if (0 == (a & o - 1)) {
                        for(var i = r - 2; 0 <= i; i--)if (0 !== t.__digit(i)) return JSBI.__truncateAndSubFromPowerOfTwo(e, t, !1);
                        return t.length === r && a === o ? t : JSBI.__truncateToNBits(e, t);
                    }
                    return JSBI.__truncateAndSubFromPowerOfTwo(e, t, !1);
                }
            },
            {
                key: "asUintN",
                value: function asUintN(e, t) {
                    var n = Math.floor;
                    if (0 === t.length) return t;
                    if (0 > (e = n(e))) throw new RangeError("Invalid value: not (convertible to) a safe integer");
                    if (0 === e) return JSBI.__zero();
                    if (t.sign) {
                        if (e > JSBI.__kMaxLengthBits) throw new RangeError("BigInt too big");
                        return JSBI.__truncateAndSubFromPowerOfTwo(e, t, !1);
                    }
                    if (e >= JSBI.__kMaxLengthBits) return t;
                    var r = 0 | (e + 29) / 30;
                    if (t.length < r) return t;
                    var a = e % 30;
                    if (t.length == r) {
                        if (0 === a) return t;
                        if (0 == t.__digit(r - 1) >>> a) return t;
                    }
                    return JSBI.__truncateToNBits(e, t);
                }
            },
            {
                key: "ADD",
                value: function ADD(e, t) {
                    if (e = JSBI.__toPrimitive(e), t = JSBI.__toPrimitive(t), "string" == typeof e) return "string" != typeof t && (t = t.toString()), e + t;
                    if ("string" == typeof t) return e.toString() + t;
                    if (e = JSBI.__toNumeric(e), t = JSBI.__toNumeric(t), JSBI.__isBigInt(e) && JSBI.__isBigInt(t)) return JSBI.add(e, t);
                    if ("number" == typeof e && "number" == typeof t) return e + t;
                    throw new TypeError("Cannot mix BigInt and other types, use explicit conversions");
                }
            },
            {
                key: "LT",
                value: function LT(e, t) {
                    return JSBI.__compare(e, t, 0);
                }
            },
            {
                key: "LE",
                value: function LE(e, t) {
                    return JSBI.__compare(e, t, 1);
                }
            },
            {
                key: "GT",
                value: function GT(e, t) {
                    return JSBI.__compare(e, t, 2);
                }
            },
            {
                key: "GE",
                value: function GE(e, t) {
                    return JSBI.__compare(e, t, 3);
                }
            },
            {
                key: "EQ",
                value: function EQ(e, t) {
                    for(;;){
                        if (JSBI.__isBigInt(e)) return JSBI.__isBigInt(t) ? JSBI.equal(e, t) : JSBI.EQ(t, e);
                        if ("number" == typeof e) {
                            if (JSBI.__isBigInt(t)) return JSBI.__equalToNumber(t, e);
                            if ("object" != _typeof(t)) return e == t;
                            t = JSBI.__toPrimitive(t);
                        } else if ("string" == typeof e) {
                            if (JSBI.__isBigInt(t)) return null !== (e = JSBI.__fromString(e)) && JSBI.equal(e, t);
                            if ("object" != _typeof(t)) return e == t;
                            t = JSBI.__toPrimitive(t);
                        } else if ("boolean" == typeof e) {
                            if (JSBI.__isBigInt(t)) return JSBI.__equalToNumber(t, +e);
                            if ("object" != _typeof(t)) return e == t;
                            t = JSBI.__toPrimitive(t);
                        } else if ("symbol" == _typeof(e)) {
                            if (JSBI.__isBigInt(t)) return !1;
                            if ("object" != _typeof(t)) return e == t;
                            t = JSBI.__toPrimitive(t);
                        } else {
                            if ("object" != _typeof(e)) return e == t;
                            if ("object" == _typeof(t) && t.constructor !== JSBI) return e == t;
                            e = JSBI.__toPrimitive(e);
                        }
                    }
                }
            },
            {
                key: "NE",
                value: function NE(e, t) {
                    return !JSBI.EQ(e, t);
                }
            },
            {
                key: "DataViewGetBigInt64",
                value: function DataViewGetBigInt64(e, t) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                    return JSBI.asIntN(64, JSBI.DataViewGetBigUint64(e, t, n));
                }
            },
            {
                key: "DataViewGetBigUint64",
                value: function DataViewGetBigUint64(e, t) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r = _slicedToArray(n ? [
                        4,
                        0
                    ] : [
                        0,
                        4
                    ], 2), a = r[0], o = r[1], i = e.getUint32(t + a, n), u = e.getUint32(t + o, n), s = new JSBI(3, !1);
                    return s.__setDigit(0, 1073741823 & u), s.__setDigit(1, (268435455 & i) << 2 | u >>> 30), s.__setDigit(2, i >>> 28), s.__trim();
                }
            },
            {
                key: "DataViewSetBigInt64",
                value: function DataViewSetBigInt64(e, t, n) {
                    var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                    JSBI.DataViewSetBigUint64(e, t, n, r);
                }
            },
            {
                key: "DataViewSetBigUint64",
                value: function DataViewSetBigUint64(e, t, n) {
                    var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3], a = 0, o = 0;
                    if (0 < (n = JSBI.asUintN(64, n)).length && (o = n.__digit(0), 1 < n.length)) {
                        var i = n.__digit(1);
                        o |= i << 30, a = i >>> 2, 2 < n.length && (a |= n.__digit(2) << 28);
                    }
                    var u = _slicedToArray(r ? [
                        4,
                        0
                    ] : [
                        0,
                        4
                    ], 2), s = u[0], l = u[1];
                    e.setUint32(t + s, a, r), e.setUint32(t + l, o, r);
                }
            },
            {
                key: "__zero",
                value: function __zero() {
                    return new JSBI(0, !1);
                }
            },
            {
                key: "__oneDigit",
                value: function __oneDigit(e, t) {
                    var n = new JSBI(1, t);
                    return n.__setDigit(0, e), n;
                }
            },
            {
                key: "__decideRounding",
                value: function __decideRounding(e, t, n, r) {
                    if (0 < t) return -1;
                    var a;
                    if (0 > t) a = -t - 1;
                    else {
                        if (0 === n) return -1;
                        n--, r = e.__digit(n), a = 29;
                    }
                    var o = 1 << a;
                    if (0 == (r & o)) return -1;
                    if (0 != (r & (o -= 1))) return 1;
                    for(; 0 < n;)if (n--, 0 !== e.__digit(n)) return 1;
                    return 0;
                }
            },
            {
                key: "__fromDouble",
                value: function __fromDouble(e) {
                    JSBI.__kBitConversionDouble[0] = e;
                    var t, n = (2047 & JSBI.__kBitConversionInts[1] >>> 20) - 1023, r = 1 + (0 | n / 30), a = new JSBI(r, 0 > e), o = 1048575 & JSBI.__kBitConversionInts[1] | 1048576, i = JSBI.__kBitConversionInts[0], u = n % 30, s = 0;
                    if (u < 20) {
                        var l = 20 - u;
                        s = l + 32, t = o >>> l, o = o << 32 - l | i >>> l, i <<= 32 - l;
                    } else if (20 === u) s = 32, t = o, o = i, i = 0;
                    else {
                        var c = u - 20;
                        s = 32 - c, t = o << c | i >>> 32 - c, o = i << c, i = 0;
                    }
                    a.__setDigit(r - 1, t);
                    for(var d = r - 2; 0 <= d; d--)0 < s ? (s -= 30, t = o >>> 2, o = o << 30 | i >>> 2, i <<= 30) : t = 0, a.__setDigit(d, t);
                    return a.__trim();
                }
            },
            {
                key: "__isWhitespace",
                value: function __isWhitespace(e) {
                    return !!(13 >= e && 9 <= e) || (159 >= e ? 32 == e : 131071 >= e ? 160 == e || 5760 == e : 196607 >= e ? 10 >= (e &= 131071) || 40 == e || 41 == e || 47 == e || 95 == e || 4096 == e : 65279 == e);
                }
            },
            {
                key: "__fromString",
                value: function __fromString(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = 0, r = e.length, a = 0;
                    if (a === r) return JSBI.__zero();
                    for(var o = e.charCodeAt(a); JSBI.__isWhitespace(o);){
                        if (++a === r) return JSBI.__zero();
                        o = e.charCodeAt(a);
                    }
                    if (43 === o) {
                        if (++a === r) return null;
                        o = e.charCodeAt(a), n = 1;
                    } else if (45 === o) {
                        if (++a === r) return null;
                        o = e.charCodeAt(a), n = -1;
                    }
                    if (0 === t) {
                        if (t = 10, 48 === o) {
                            if (++a === r) return JSBI.__zero();
                            if (88 === (o = e.charCodeAt(a)) || 120 === o) {
                                if (t = 16, ++a === r) return null;
                                o = e.charCodeAt(a);
                            } else if (79 === o || 111 === o) {
                                if (t = 8, ++a === r) return null;
                                o = e.charCodeAt(a);
                            } else if (66 === o || 98 === o) {
                                if (t = 2, ++a === r) return null;
                                o = e.charCodeAt(a);
                            }
                        }
                    } else if (16 === t && 48 === o) {
                        if (++a === r) return JSBI.__zero();
                        if (88 === (o = e.charCodeAt(a)) || 120 === o) {
                            if (++a === r) return null;
                            o = e.charCodeAt(a);
                        }
                    }
                    if (0 != n && 10 !== t) return null;
                    for(; 48 === o;){
                        if (++a === r) return JSBI.__zero();
                        o = e.charCodeAt(a);
                    }
                    var i = r - a, u = JSBI.__kMaxBitsPerChar[t], s = JSBI.__kBitsPerCharTableMultiplier - 1;
                    if (i > 1073741824 / u) return null;
                    var l = new JSBI(0 | (29 + (u * i + s >>> JSBI.__kBitsPerCharTableShift)) / 30, !1), c = 10 > t ? t : 10, d = 10 < t ? t - 10 : 0;
                    if (0 == (t & t - 1)) {
                        u >>= JSBI.__kBitsPerCharTableShift;
                        var m = [], h = [], f = !1;
                        do {
                            for(var p = 0, v = 0;;){
                                var D = void 0;
                                if (o - 48 >>> 0 < c) D = o - 48;
                                else {
                                    if (!((32 | o) - 97 >>> 0 < d)) {
                                        f = !0;
                                        break;
                                    }
                                    D = (32 | o) - 87;
                                }
                                if (v += u, p = p << u | D, ++a === r) {
                                    f = !0;
                                    break;
                                }
                                if (o = e.charCodeAt(a), 30 < v + u) break;
                            }
                            m.push(p), h.push(v);
                        }while (!f);
                        JSBI.__fillFromParts(l, m, h);
                    } else {
                        l.__initializeDigits();
                        var g = !1, y = 0;
                        do {
                            for(var T = 0, S = 1;;){
                                var I = void 0;
                                if (o - 48 >>> 0 < c) I = o - 48;
                                else {
                                    if (!((32 | o) - 97 >>> 0 < d)) {
                                        g = !0;
                                        break;
                                    }
                                    I = (32 | o) - 87;
                                }
                                var C = S * t;
                                if (1073741823 < C) break;
                                if (S = C, T = T * t + I, y++, ++a === r) {
                                    g = !0;
                                    break;
                                }
                                o = e.charCodeAt(a);
                            }
                            var _ = 0 | (u * y + (s = 30 * JSBI.__kBitsPerCharTableMultiplier - 1) >>> JSBI.__kBitsPerCharTableShift) / 30;
                            l.__inplaceMultiplyAdd(S, T, _);
                        }while (!g);
                    }
                    if (a !== r) {
                        if (!JSBI.__isWhitespace(o)) return null;
                        for(a++; a < r; a++)if (o = e.charCodeAt(a), !JSBI.__isWhitespace(o)) return null;
                    }
                    return l.sign = -1 == n, l.__trim();
                }
            },
            {
                key: "__fillFromParts",
                value: function __fillFromParts(e, t, n) {
                    for(var r = 0, a = 0, o = 0, i = t.length - 1; 0 <= i; i--){
                        var u = t[i], s = n[i];
                        a |= u << o, 30 === (o += s) ? (e.__setDigit(r++, a), o = 0, a = 0) : 30 < o && (e.__setDigit(r++, 1073741823 & a), a = u >>> s - (o -= 30));
                    }
                    if (0 !== a) {
                        if (r >= e.length) throw new Error("implementation bug");
                        e.__setDigit(r++, a);
                    }
                    for(; r < e.length; r++)e.__setDigit(r, 0);
                }
            },
            {
                key: "__toStringBasePowerOfTwo",
                value: function __toStringBasePowerOfTwo(e, t) {
                    var n = e.length, r = t - 1, a = r = (15 & (r = (51 & (r = (85 & r >>> 1) + (85 & r)) >>> 2) + (51 & r)) >>> 4) + (15 & r), o = t - 1, i = e.__digit(n - 1), u = 0 | (30 * n - JSBI.__clz30(i) + a - 1) / a;
                    if (e.sign && u++, 268435456 < u) throw new Error("string too long");
                    for(var s = Array(u), l = u - 1, c = 0, d = 0, m = 0; m < n - 1; m++){
                        var h = e.__digit(m), f = (c | h << d) & o;
                        s[l--] = JSBI.__kConversionChars[f];
                        var p = a - d;
                        for(c = h >>> p, d = 30 - p; d >= a;)s[l--] = JSBI.__kConversionChars[c & o], c >>>= a, d -= a;
                    }
                    var v = (c | i << d) & o;
                    for(s[l--] = JSBI.__kConversionChars[v], c = i >>> a - d; 0 !== c;)s[l--] = JSBI.__kConversionChars[c & o], c >>>= a;
                    if (e.sign && (s[l--] = "-"), -1 != l) throw new Error("implementation bug");
                    return s.join("");
                }
            },
            {
                key: "__toStringGeneric",
                value: function __toStringGeneric(e, t, n) {
                    var r = e.length;
                    if (0 === r) return "";
                    if (1 === r) {
                        var a = e.__unsignedDigit(0).toString(t);
                        return !1 === n && e.sign && (a = "-" + a), a;
                    }
                    var o, i, u = 30 * r - JSBI.__clz30(e.__digit(r - 1)), s = JSBI.__kMaxBitsPerChar[t] - 1, l = u * JSBI.__kBitsPerCharTableMultiplier, c = 1 + (l = 0 | (l += s - 1) / s) >> 1, d = JSBI.exponentiate(JSBI.__oneDigit(t, !1), JSBI.__oneDigit(c, !1)), m = d.__unsignedDigit(0);
                    if (1 === d.length && 32767 >= m) {
                        (o = new JSBI(e.length, !1)).__initializeDigits();
                        for(var h = 0, f = 2 * e.length - 1; 0 <= f; f--){
                            var p = h << 15 | e.__halfDigit(f);
                            o.__setHalfDigit(f, 0 | p / m), h = 0 | p % m;
                        }
                        i = h.toString(t);
                    } else {
                        var v = JSBI.__absoluteDivLarge(e, d, !0, !0);
                        o = v.quotient;
                        var D = v.remainder.__trim();
                        i = JSBI.__toStringGeneric(D, t, !0);
                    }
                    o.__trim();
                    for(var g = JSBI.__toStringGeneric(o, t, !0); i.length < c;)i = "0" + i;
                    return !1 === n && e.sign && (g = "-" + g), g + i;
                }
            },
            {
                key: "__unequalSign",
                value: function __unequalSign(e) {
                    return e ? -1 : 1;
                }
            },
            {
                key: "__absoluteGreater",
                value: function __absoluteGreater(e) {
                    return e ? -1 : 1;
                }
            },
            {
                key: "__absoluteLess",
                value: function __absoluteLess(e) {
                    return e ? 1 : -1;
                }
            },
            {
                key: "__compareToBigInt",
                value: function __compareToBigInt(e, t) {
                    var n = e.sign;
                    if (n !== t.sign) return JSBI.__unequalSign(n);
                    var r = JSBI.__absoluteCompare(e, t);
                    return 0 < r ? JSBI.__absoluteGreater(n) : 0 > r ? JSBI.__absoluteLess(n) : 0;
                }
            },
            {
                key: "__compareToNumber",
                value: function __compareToNumber(e, t) {
                    if (JSBI.__isOneDigitInt(t)) {
                        var n = e.sign, r = 0 > t;
                        if (n !== r) return JSBI.__unequalSign(n);
                        if (0 === e.length) {
                            if (r) throw new Error("implementation bug");
                            return 0 === t ? 0 : -1;
                        }
                        if (1 < e.length) return JSBI.__absoluteGreater(n);
                        var a = Math.abs(t), o = e.__unsignedDigit(0);
                        return o > a ? JSBI.__absoluteGreater(n) : o < a ? JSBI.__absoluteLess(n) : 0;
                    }
                    return JSBI.__compareToDouble(e, t);
                }
            },
            {
                key: "__compareToDouble",
                value: function __compareToDouble(e, t) {
                    if (t != t) return t;
                    if (t === 1 / 0) return -1;
                    if (t === -1 / 0) return 1;
                    var n = e.sign;
                    if (n !== 0 > t) return JSBI.__unequalSign(n);
                    if (0 === t) throw new Error("implementation bug: should be handled elsewhere");
                    if (0 === e.length) return -1;
                    JSBI.__kBitConversionDouble[0] = t;
                    var r = 2047 & JSBI.__kBitConversionInts[1] >>> 20;
                    if (2047 == r) throw new Error("implementation bug: handled elsewhere");
                    var a = r - 1023;
                    if (0 > a) return JSBI.__absoluteGreater(n);
                    var o = e.length, i = e.__digit(o - 1), u = JSBI.__clz30(i), s = 30 * o - u, l = a + 1;
                    if (s < l) return JSBI.__absoluteLess(n);
                    if (s > l) return JSBI.__absoluteGreater(n);
                    var c = 1048576 | 1048575 & JSBI.__kBitConversionInts[1], d = JSBI.__kBitConversionInts[0], m = 29 - u;
                    if (m !== (0 | (s - 1) % 30)) throw new Error("implementation bug");
                    var h, f = 0;
                    if (20 > m) {
                        var p = 20 - m;
                        f = p + 32, h = c >>> p, c = c << 32 - p | d >>> p, d <<= 32 - p;
                    } else if (20 === m) f = 32, h = c, c = d, d = 0;
                    else {
                        var v = m - 20;
                        f = 32 - v, h = c << v | d >>> 32 - v, c = d << v, d = 0;
                    }
                    if ((i >>>= 0) > (h >>>= 0)) return JSBI.__absoluteGreater(n);
                    if (i < h) return JSBI.__absoluteLess(n);
                    for(var D = o - 2; 0 <= D; D--){
                        0 < f ? (f -= 30, h = c >>> 2, c = c << 30 | d >>> 2, d <<= 30) : h = 0;
                        var g = e.__unsignedDigit(D);
                        if (g > h) return JSBI.__absoluteGreater(n);
                        if (g < h) return JSBI.__absoluteLess(n);
                    }
                    if (0 !== c || 0 !== d) {
                        if (0 === f) throw new Error("implementation bug");
                        return JSBI.__absoluteLess(n);
                    }
                    return 0;
                }
            },
            {
                key: "__equalToNumber",
                value: function __equalToNumber(e, t) {
                    var n = Math.abs;
                    return JSBI.__isOneDigitInt(t) ? 0 === t ? 0 === e.length : 1 === e.length && e.sign === 0 > t && e.__unsignedDigit(0) === n(t) : 0 === JSBI.__compareToDouble(e, t);
                }
            },
            {
                key: "__comparisonResultToBool",
                value: function __comparisonResultToBool(e, t) {
                    return 0 === t ? 0 > e : 1 === t ? 0 >= e : 2 === t ? 0 < e : 3 === t ? 0 <= e : void 0;
                }
            },
            {
                key: "__compare",
                value: function __compare(e, t, n) {
                    if (e = JSBI.__toPrimitive(e), t = JSBI.__toPrimitive(t), "string" == typeof e && "string" == typeof t) switch(n){
                        case 0:
                            return e < t;
                        case 1:
                            return e <= t;
                        case 2:
                            return e > t;
                        case 3:
                            return e >= t;
                    }
                    if (JSBI.__isBigInt(e) && "string" == typeof t) return null !== (t = JSBI.__fromString(t)) && JSBI.__comparisonResultToBool(JSBI.__compareToBigInt(e, t), n);
                    if ("string" == typeof e && JSBI.__isBigInt(t)) return null !== (e = JSBI.__fromString(e)) && JSBI.__comparisonResultToBool(JSBI.__compareToBigInt(e, t), n);
                    if (e = JSBI.__toNumeric(e), t = JSBI.__toNumeric(t), JSBI.__isBigInt(e)) {
                        if (JSBI.__isBigInt(t)) return JSBI.__comparisonResultToBool(JSBI.__compareToBigInt(e, t), n);
                        if ("number" != typeof t) throw new Error("implementation bug");
                        return JSBI.__comparisonResultToBool(JSBI.__compareToNumber(e, t), n);
                    }
                    if ("number" != typeof e) throw new Error("implementation bug");
                    if (JSBI.__isBigInt(t)) return JSBI.__comparisonResultToBool(JSBI.__compareToNumber(t, e), 2 ^ n);
                    if ("number" != typeof t) throw new Error("implementation bug");
                    return 0 === n ? e < t : 1 === n ? e <= t : 2 === n ? e > t : 3 === n ? e >= t : void 0;
                }
            },
            {
                key: "__absoluteAdd",
                value: function __absoluteAdd(e, t, n) {
                    if (e.length < t.length) return JSBI.__absoluteAdd(t, e, n);
                    if (0 === e.length) return e;
                    if (0 === t.length) return e.sign === n ? e : JSBI.unaryMinus(e);
                    var r = e.length;
                    (0 === e.__clzmsd() || t.length === e.length && 0 === t.__clzmsd()) && r++;
                    for(var a = new JSBI(r, n), o = 0, i = 0; i < t.length; i++){
                        var u = e.__digit(i) + t.__digit(i) + o;
                        o = u >>> 30, a.__setDigit(i, 1073741823 & u);
                    }
                    for(; i < e.length; i++){
                        var s = e.__digit(i) + o;
                        o = s >>> 30, a.__setDigit(i, 1073741823 & s);
                    }
                    return i < a.length && a.__setDigit(i, o), a.__trim();
                }
            },
            {
                key: "__absoluteSub",
                value: function __absoluteSub(e, t, n) {
                    if (0 === e.length) return e;
                    if (0 === t.length) return e.sign === n ? e : JSBI.unaryMinus(e);
                    for(var r = new JSBI(e.length, n), a = 0, o = 0; o < t.length; o++){
                        var i = e.__digit(o) - t.__digit(o) - a;
                        a = 1 & i >>> 30, r.__setDigit(o, 1073741823 & i);
                    }
                    for(; o < e.length; o++){
                        var u = e.__digit(o) - a;
                        a = 1 & u >>> 30, r.__setDigit(o, 1073741823 & u);
                    }
                    return r.__trim();
                }
            },
            {
                key: "__absoluteAddOne",
                value: function __absoluteAddOne(e, t) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, r = e.length;
                    null === n ? n = new JSBI(r, t) : n.sign = t;
                    for(var a = 1, o = 0; o < r; o++){
                        var i = e.__digit(o) + a;
                        a = i >>> 30, n.__setDigit(o, 1073741823 & i);
                    }
                    return 0 != a && n.__setDigitGrow(r, 1), n;
                }
            },
            {
                key: "__absoluteSubOne",
                value: function __absoluteSubOne(e, t) {
                    for(var n = e.length, r = new JSBI(t = t || n, !1), a = 1, o = 0; o < n; o++){
                        var i = e.__digit(o) - a;
                        a = 1 & i >>> 30, r.__setDigit(o, 1073741823 & i);
                    }
                    if (0 != a) throw new Error("implementation bug");
                    for(var u = n; u < t; u++)r.__setDigit(u, 0);
                    return r;
                }
            },
            {
                key: "__absoluteAnd",
                value: function __absoluteAnd(e, t) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, r = e.length, a = t.length, o = a;
                    if (r < a) {
                        o = r;
                        var i = e, u = r;
                        e = t, r = a, t = i, a = u;
                    }
                    var s = o;
                    null === n ? n = new JSBI(s, !1) : s = n.length;
                    for(var l = 0; l < o; l++)n.__setDigit(l, e.__digit(l) & t.__digit(l));
                    for(; l < s; l++)n.__setDigit(l, 0);
                    return n;
                }
            },
            {
                key: "__absoluteAndNot",
                value: function __absoluteAndNot(e, t) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, r = e.length, a = t.length, o = a;
                    r < a && (o = r);
                    var i = r;
                    null === n ? n = new JSBI(i, !1) : i = n.length;
                    for(var u = 0; u < o; u++)n.__setDigit(u, e.__digit(u) & ~t.__digit(u));
                    for(; u < r; u++)n.__setDigit(u, e.__digit(u));
                    for(; u < i; u++)n.__setDigit(u, 0);
                    return n;
                }
            },
            {
                key: "__absoluteOr",
                value: function __absoluteOr(e, t) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, r = e.length, a = t.length, o = a;
                    if (r < a) {
                        o = r;
                        var i = e, u = r;
                        e = t, r = a, t = i, a = u;
                    }
                    var s = r;
                    null === n ? n = new JSBI(s, !1) : s = n.length;
                    for(var l = 0; l < o; l++)n.__setDigit(l, e.__digit(l) | t.__digit(l));
                    for(; l < r; l++)n.__setDigit(l, e.__digit(l));
                    for(; l < s; l++)n.__setDigit(l, 0);
                    return n;
                }
            },
            {
                key: "__absoluteXor",
                value: function __absoluteXor(e, t) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, r = e.length, a = t.length, o = a;
                    if (r < a) {
                        o = r;
                        var i = e, u = r;
                        e = t, r = a, t = i, a = u;
                    }
                    var s = r;
                    null === n ? n = new JSBI(s, !1) : s = n.length;
                    for(var l = 0; l < o; l++)n.__setDigit(l, e.__digit(l) ^ t.__digit(l));
                    for(; l < r; l++)n.__setDigit(l, e.__digit(l));
                    for(; l < s; l++)n.__setDigit(l, 0);
                    return n;
                }
            },
            {
                key: "__absoluteCompare",
                value: function __absoluteCompare(e, t) {
                    var n = e.length - t.length;
                    if (0 != n) return n;
                    for(var r = e.length - 1; 0 <= r && e.__digit(r) === t.__digit(r);)r--;
                    return 0 > r ? 0 : e.__unsignedDigit(r) > t.__unsignedDigit(r) ? 1 : -1;
                }
            },
            {
                key: "__multiplyAccumulate",
                value: function __multiplyAccumulate(e, t, n, r) {
                    if (0 !== t) {
                        for(var a, o = 32767 & t, i = t >>> 15, u = 0, s = 0, l = 0; l < e.length; l++, r++){
                            a = n.__digit(r);
                            var c = e.__digit(l), d = 32767 & c, m = c >>> 15, h = JSBI.__imul(d, o), f = JSBI.__imul(d, i), p = JSBI.__imul(m, o);
                            u = (a += s + h + u) >>> 30, a &= 1073741823, u += (a += ((32767 & f) << 15) + ((32767 & p) << 15)) >>> 30, s = JSBI.__imul(m, i) + (f >>> 15) + (p >>> 15), n.__setDigit(r, 1073741823 & a);
                        }
                        for(; 0 != u || 0 !== s; r++){
                            var v = n.__digit(r);
                            v += u + s, s = 0, u = v >>> 30, n.__setDigit(r, 1073741823 & v);
                        }
                    }
                }
            },
            {
                key: "__internalMultiplyAdd",
                value: function __internalMultiplyAdd(e, t, n, r, a) {
                    for(var o = n, i = 0, u = 0; u < r; u++){
                        var s = e.__digit(u), l = JSBI.__imul(32767 & s, t), c = JSBI.__imul(s >>> 15, t), d = l + ((32767 & c) << 15) + i + o;
                        o = d >>> 30, i = c >>> 15, a.__setDigit(u, 1073741823 & d);
                    }
                    if (a.length > r) for(a.__setDigit(r++, o + i); r < a.length;)a.__setDigit(r++, 0);
                    else if (0 !== o + i) throw new Error("implementation bug");
                }
            },
            {
                key: "__absoluteDivSmall",
                value: function __absoluteDivSmall(e, t) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
                    null === n && (n = new JSBI(e.length, !1));
                    for(var r, a = 0, o = 2 * e.length - 1; 0 <= o; o -= 2){
                        var i = 0 | (r = (a << 15 | e.__halfDigit(o)) >>> 0) / t, u = 0 | (r = ((a = 0 | r % t) << 15 | e.__halfDigit(o - 1)) >>> 0) / t;
                        a = 0 | r % t, n.__setDigit(o >>> 1, i << 15 | u);
                    }
                    return n;
                }
            },
            {
                key: "__absoluteModSmall",
                value: function __absoluteModSmall(e, t) {
                    for(var n = 0, r = 2 * e.length - 1; 0 <= r; r--)n = 0 | ((n << 15 | e.__halfDigit(r)) >>> 0) % t;
                    return n;
                }
            },
            {
                key: "__absoluteDivLarge",
                value: function __absoluteDivLarge(e, t, n, r) {
                    var a = t.__halfDigitLength(), o = t.length, i = e.__halfDigitLength() - a, u = null;
                    n && (u = new JSBI(i + 2 >>> 1, !1)).__initializeDigits();
                    var s = new JSBI(a + 2 >>> 1, !1);
                    s.__initializeDigits();
                    var l = JSBI.__clz15(t.__halfDigit(a - 1));
                    0 < l && (t = JSBI.__specialLeftShift(t, l, 0));
                    for(var c, d = JSBI.__specialLeftShift(e, l, 1), m = t.__halfDigit(a - 1), h = 0, f = i; 0 <= f; f--){
                        c = 32767;
                        var p = d.__halfDigit(f + a);
                        if (p !== m) {
                            var v = (p << 15 | d.__halfDigit(f + a - 1)) >>> 0;
                            c = 0 | v / m;
                            for(var D = 0 | v % m, g = t.__halfDigit(a - 2), y = d.__halfDigit(f + a - 2); JSBI.__imul(c, g) >>> 0 > (D << 16 | y) >>> 0 && (c--, !(32767 < (D += m))););
                        }
                        JSBI.__internalMultiplyAdd(t, c, 0, o, s);
                        var T = d.__inplaceSub(s, f, a + 1);
                        0 !== T && (T = d.__inplaceAdd(t, f, a), d.__setHalfDigit(f + a, 32767 & d.__halfDigit(f + a) + T), c--), n && (1 & f ? h = c << 15 : u.__setDigit(f >>> 1, h | c));
                    }
                    if (r) return d.__inplaceRightShift(l), n ? {
                        quotient: u,
                        remainder: d
                    } : d;
                    if (n) return u;
                    throw new Error("unreachable");
                }
            },
            {
                key: "__clz15",
                value: function __clz15(e) {
                    return JSBI.__clz30(e) - 15;
                }
            },
            {
                key: "__specialLeftShift",
                value: function __specialLeftShift(e, t, n) {
                    var r = e.length, a = new JSBI(r + n, !1);
                    if (0 === t) {
                        for(var o = 0; o < r; o++)a.__setDigit(o, e.__digit(o));
                        return 0 < n && a.__setDigit(r, 0), a;
                    }
                    for(var i = 0, u = 0; u < r; u++){
                        var s = e.__digit(u);
                        a.__setDigit(u, 1073741823 & s << t | i), i = s >>> 30 - t;
                    }
                    return 0 < n && a.__setDigit(r, i), a;
                }
            },
            {
                key: "__leftShiftByAbsolute",
                value: function __leftShiftByAbsolute(e, t) {
                    var n = JSBI.__toShiftAmount(t);
                    if (0 > n) throw new RangeError("BigInt too big");
                    var r = 0 | n / 30, a = n % 30, o = e.length, i = 0 !== a && 0 != e.__digit(o - 1) >>> 30 - a, u = o + r + (i ? 1 : 0), s = new JSBI(u, e.sign);
                    if (0 === a) {
                        for(var l = 0; l < r; l++)s.__setDigit(l, 0);
                        for(; l < u; l++)s.__setDigit(l, e.__digit(l - r));
                    } else {
                        for(var c = 0, d = 0; d < r; d++)s.__setDigit(d, 0);
                        for(var m = 0; m < o; m++){
                            var h = e.__digit(m);
                            s.__setDigit(m + r, 1073741823 & h << a | c), c = h >>> 30 - a;
                        }
                        if (i) s.__setDigit(o + r, c);
                        else if (0 !== c) throw new Error("implementation bug");
                    }
                    return s.__trim();
                }
            },
            {
                key: "__rightShiftByAbsolute",
                value: function __rightShiftByAbsolute(e, t) {
                    var n = e.length, r = e.sign, a = JSBI.__toShiftAmount(t);
                    if (0 > a) return JSBI.__rightShiftByMaximum(r);
                    var o = 0 | a / 30, i = a % 30, u = n - o;
                    if (0 >= u) return JSBI.__rightShiftByMaximum(r);
                    var s = !1;
                    if (r) {
                        if (0 != (e.__digit(o) & (1 << i) - 1)) s = !0;
                        else for(var l = 0; l < o; l++)if (0 !== e.__digit(l)) {
                            s = !0;
                            break;
                        }
                    }
                    s && 0 === i && 0 == ~e.__digit(n - 1) && u++;
                    var c = new JSBI(u, r);
                    if (0 === i) {
                        c.__setDigit(u - 1, 0);
                        for(var d = o; d < n; d++)c.__setDigit(d - o, e.__digit(d));
                    } else {
                        for(var m = e.__digit(o) >>> i, h = n - o - 1, f = 0; f < h; f++){
                            var p = e.__digit(f + o + 1);
                            c.__setDigit(f, 1073741823 & p << 30 - i | m), m = p >>> i;
                        }
                        c.__setDigit(h, m);
                    }
                    return s && (c = JSBI.__absoluteAddOne(c, !0, c)), c.__trim();
                }
            },
            {
                key: "__rightShiftByMaximum",
                value: function __rightShiftByMaximum(e) {
                    return e ? JSBI.__oneDigit(1, !0) : JSBI.__zero();
                }
            },
            {
                key: "__toShiftAmount",
                value: function __toShiftAmount(e) {
                    if (1 < e.length) return -1;
                    var t = e.__unsignedDigit(0);
                    return t > JSBI.__kMaxLengthBits ? -1 : t;
                }
            },
            {
                key: "__toPrimitive",
                value: function __toPrimitive(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "default";
                    if ("object" != _typeof(e)) return e;
                    if (e.constructor === JSBI) return e;
                    if ("undefined" != typeof Symbol && "symbol" == _typeof(Symbol.toPrimitive)) {
                        var n = e[Symbol.toPrimitive];
                        if (n) {
                            var r = n(t);
                            if ("object" != _typeof(r)) return r;
                            throw new TypeError("Cannot convert object to primitive value");
                        }
                    }
                    var a = e.valueOf;
                    if (a) {
                        var o = a.call(e);
                        if ("object" != _typeof(o)) return o;
                    }
                    var i = e.toString;
                    if (i) {
                        var u = i.call(e);
                        if ("object" != _typeof(u)) return u;
                    }
                    throw new TypeError("Cannot convert object to primitive value");
                }
            },
            {
                key: "__toNumeric",
                value: function __toNumeric(e) {
                    return JSBI.__isBigInt(e) ? e : +e;
                }
            },
            {
                key: "__isBigInt",
                value: function __isBigInt(e) {
                    return "object" == _typeof(e) && null !== e && e.constructor === JSBI;
                }
            },
            {
                key: "__truncateToNBits",
                value: function __truncateToNBits(e, t) {
                    for(var n = 0 | (e + 29) / 30, r = new JSBI(n, t.sign), a = n - 1, o = 0; o < a; o++)r.__setDigit(o, t.__digit(o));
                    var i = t.__digit(a);
                    if (0 != e % 30) {
                        var u = 32 - e % 30;
                        i = i << u >>> u;
                    }
                    return r.__setDigit(a, i), r.__trim();
                }
            },
            {
                key: "__truncateAndSubFromPowerOfTwo",
                value: function __truncateAndSubFromPowerOfTwo(e, t, n) {
                    for(var r = Math.min, a = 0 | (e + 29) / 30, o = new JSBI(a, n), i = 0, u = a - 1, s = 0, l = r(u, t.length); i < l; i++){
                        var c = 0 - t.__digit(i) - s;
                        s = 1 & c >>> 30, o.__setDigit(i, 1073741823 & c);
                    }
                    for(; i < u; i++)o.__setDigit(i, 0 | 1073741823 & -s);
                    var d, m = u < t.length ? t.__digit(u) : 0, h = e % 30;
                    if (0 == h) d = 0 - m - s, d &= 1073741823;
                    else {
                        var f = 32 - h, p = 1 << 32 - f;
                        d = p - (m = m << f >>> f) - s, d &= p - 1;
                    }
                    return o.__setDigit(u, d), o.__trim();
                }
            },
            {
                key: "__digitPow",
                value: function __digitPow(e, t) {
                    for(var n = 1; 0 < t;)1 & t && (n *= e), t >>>= 1, e *= e;
                    return n;
                }
            },
            {
                key: "__isOneDigitInt",
                value: function __isOneDigitInt(e) {
                    return (1073741823 & e) === e;
                }
            }
        ]), JSBI;
    }(_wrapNativeSuper(Array));
    t.__kMaxLength = 33554432, t.__kMaxLengthBits = t.__kMaxLength << 5, t.__kMaxBitsPerChar = [
        0,
        0,
        32,
        51,
        64,
        75,
        83,
        90,
        96,
        102,
        107,
        111,
        115,
        119,
        122,
        126,
        128,
        131,
        134,
        136,
        139,
        141,
        143,
        145,
        147,
        149,
        151,
        153,
        154,
        156,
        158,
        159,
        160,
        162,
        163,
        165,
        166
    ], t.__kBitsPerCharTableShift = 5, t.__kBitsPerCharTableMultiplier = 1 << t.__kBitsPerCharTableShift, t.__kConversionChars = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z"
    ], t.__kBitConversionBuffer = new ArrayBuffer(8), t.__kBitConversionDouble = new Float64Array(t.__kBitConversionBuffer), t.__kBitConversionInts = new Int32Array(t.__kBitConversionBuffer), t.__clz30 = Math.clz32 ? function(e) {
        return Math.clz32(e) - 2;
    } : function(e) {
        return 0 === e ? 30 : 0 | 29 - (0 | Math.log(e >>> 0) / Math.LN2);
    }, t.__imul = Math.imul || function(e, t) {
        return 0 | e * t;
    };
    var n, r, a = t.BigInt(0), o = t.BigInt(1), i = t.BigInt(2), u = t.BigInt(10), s = t.BigInt(24), l = t.BigInt(60), c = t.BigInt(1e3), d = t.BigInt(1e6), m = t.BigInt(1e9), h = t.multiply(t.BigInt(3600), m), f = t.multiply(l, m), p = t.multiply(h, s);
    function ensureJSBI(e) {
        return "bigint" == typeof e ? t.BigInt(e.toString(10)) : e;
    }
    function isEven(e) {
        return t.equal(t.remainder(e, i), a);
    }
    function abs(e) {
        return t.lessThan(e, a) ? t.unaryMinus(e) : e;
    }
    function compare(e, n) {
        return t.lessThan(e, n) ? -1 : t.greaterThan(e, n) ? 1 : 0;
    }
    function divmod(e, n) {
        return {
            quotient: t.divide(e, n),
            remainder: t.remainder(e, n)
        };
    }
    var v = "slot-epochNanoSeconds", D = "slot-iso-date", g = "slot-iso-date-time", y = "slot-time", T = "slot-calendar", S = "slot-date-brand", I = "slot-year-month-brand", C = "slot-month-day-brand", _ = "slot-time-zone", O = "slot-years", b = "slot-months", w = "slot-weeks", k = "slot-days", E = "slot-hours", B = "slot-minutes", R = "slot-seconds", G = "slot-milliseconds", M = "slot-microseconds", A = "slot-nanoseconds", P = "date", j = "ym", N = "md", Y = "time", J = "datetime", L = "instant", Z = "original", U = "timezone-canonical", x = "timezone-original", H = "calendar-id", W = "locale", z = "options", q = new WeakMap, $ = Symbol.for("@@Temporal__GetSlots");
    (n = globalThis)[$] || (n[$] = function _GetSlots(e) {
        return q.get(e);
    });
    var V = globalThis[$], K = Symbol.for("@@Temporal__CreateSlots");
    (r = globalThis)[K] || (r[K] = function _CreateSlots(e) {
        q.set(e, Object.create(null));
    });
    var X, Q = globalThis[K];
    function HasSlot(e) {
        if (!e || "object" !== _typeof(e)) return !1;
        for(var t = V(e), n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)r[a - 1] = arguments[a];
        return !!t && r.every(function(e) {
            return e in t;
        });
    }
    function GetSlot(e, t) {
        var n, r = null === (n = V(e)) || void 0 === n ? void 0 : n[t];
        if (void 0 === r) throw new TypeError("Missing internal slot ".concat(t));
        return r;
    }
    function SetSlot(e, t, n) {
        var r = V(e);
        if (void 0 === r) throw new TypeError("Missing slots for the given container");
        if (r[t]) throw new TypeError("".concat(t, " already has set"));
        r[t] = n;
    }
    var ee = {};
    function MakeIntrinsicClass(e, t) {
        Object.defineProperty(e.prototype, Symbol.toStringTag, {
            value: t,
            writable: !1,
            enumerable: !1,
            configurable: !0
        });
        for(var n = Object.getOwnPropertyNames(e), r = 0; r < n.length; r++){
            var a = n[r], o = Object.getOwnPropertyDescriptor(e, a);
            o.configurable && o.enumerable && (o.enumerable = !1, Object.defineProperty(e, a, o));
        }
        for(var i = Object.getOwnPropertyNames(e.prototype), u = 0; u < i.length; u++){
            var s = i[u], l = Object.getOwnPropertyDescriptor(e.prototype, s);
            l.configurable && l.enumerable && (l.enumerable = !1, Object.defineProperty(e.prototype, s, l));
        }
        DefineIntrinsic(t, e), DefineIntrinsic("".concat(t, ".prototype"), e.prototype);
    }
    function DefineIntrinsic(e, t) {
        var n = "%".concat(e, "%");
        if (void 0 !== ee[n]) throw new Error("intrinsic ".concat(e, " already exists"));
        ee[n] = t;
    }
    function GetIntrinsic(e) {
        return ee[e];
    }
    function TruncatingDivModByPowerOf10(e, t) {
        var n = e;
        if (0 === n) return {
            div: n,
            mod: n
        };
        var r = Math.sign(n);
        n = Math.abs(n);
        var a = Math.trunc(1 + Math.log10(n));
        if (t >= a) return {
            div: 0 * r,
            mod: r * n
        };
        if (0 === t) return {
            div: r * n,
            mod: 0 * r
        };
        var o = n.toPrecision(a);
        return {
            div: r * Number.parseInt(o.slice(0, a - t), 10),
            mod: r * Number.parseInt(o.slice(a - t), 10)
        };
    }
    function FMAPowerOf10(e, t, n) {
        var r = e, a = n;
        if (0 === r) return a;
        var o = Math.sign(r) || Math.sign(a);
        r = Math.abs(r), a = Math.abs(a);
        var i = r.toPrecision(Math.trunc(1 + Math.log10(r)));
        if (0 === a) return o * Number.parseInt(i + "0".repeat(t), 10);
        var u = i + a.toPrecision(Math.trunc(1 + Math.log10(a))).padStart(t, "0");
        return o * Number.parseInt(u, 10);
    }
    function GetUnsignedRoundingMode(e, t) {
        var n = "negative" === t;
        switch(e){
            case "ceil":
                return n ? "zero" : "infinity";
            case "floor":
                return n ? "infinity" : "zero";
            case "expand":
                return "infinity";
            case "trunc":
                return "zero";
            case "halfCeil":
                return n ? "half-zero" : "half-infinity";
            case "halfFloor":
                return n ? "half-infinity" : "half-zero";
            case "halfExpand":
                return "half-infinity";
            case "halfTrunc":
                return "half-zero";
            case "halfEven":
                return "half-even";
        }
    }
    function ApplyUnsignedRoundingMode(e, t, n, r, a) {
        return "zero" === a ? e : "infinity" === a ? t : n < 0 ? e : n > 0 ? t : "half-zero" === a ? e : "half-infinity" === a ? t : r ? e : t;
    }
    _defineProperty(X = {}, "Intl.DateTimeFormat", function IntlDateTimeFormat(e, t, n) {
        return n(GetSlot(this, Z), _objectSpread2({
            depth: e
        }, t));
    }), _defineProperty(X, "Temporal.Duration", function TemporalDuration(e, t) {
        var n = t.stylize(this._repr_, "special");
        if (e < 1) return n;
        for(var r = [], a = [
            "years",
            "months",
            "weeks",
            "days",
            "hours",
            "minutes",
            "seconds",
            "milliseconds",
            "microseconds",
            "nanoseconds"
        ], o = 0; o < a.length; o++){
            var i = a[o];
            0 !== this[i] && r.push("  ".concat(i, ": ").concat(t.stylize(this[i], "number")));
        }
        return n + " {\n" + r.join(",\n") + "\n}";
    });
    var te = function() {
        function TimeDuration(e) {
            _classCallCheck(this, TimeDuration), this.totalNs = ensureJSBI(e), this.sec = t.toNumber(t.divide(this.totalNs, m)), this.subsec = t.toNumber(t.remainder(this.totalNs, m));
        }
        return _createClass(TimeDuration, [
            {
                key: "abs",
                value: function abs$1() {
                    return new TimeDuration(abs(this.totalNs));
                }
            },
            {
                key: "add",
                value: function add(e) {
                    return TimeDuration.validateNew(t.add(this.totalNs, e.totalNs), "sum");
                }
            },
            {
                key: "add24HourDays",
                value: function add24HourDays(e) {
                    return TimeDuration.validateNew(t.add(this.totalNs, t.multiply(t.BigInt(e), p)), "sum");
                }
            },
            {
                key: "addToEpochNs",
                value: function addToEpochNs(e) {
                    return t.add(ensureJSBI(e), this.totalNs);
                }
            },
            {
                key: "cmp",
                value: function cmp(e) {
                    return compare(this.totalNs, e.totalNs);
                }
            },
            {
                key: "divmod",
                value: function divmod$1(e) {
                    var n = divmod(this.totalNs, t.BigInt(e)), r = n.quotient, a = n.remainder;
                    return {
                        quotient: t.toNumber(r),
                        remainder: new TimeDuration(a)
                    };
                }
            },
            {
                key: "fdiv",
                value: function fdiv(e) {
                    for(var n, r = ensureJSBI(e), o = t.BigInt(r), i = divmod(this.totalNs, o), s = i.quotient, l = i.remainder, c = [], d = (t.lessThan(this.totalNs, a) ? -1 : 1) * Math.sign(t.toNumber(r)); !t.equal(l, a) && c.length < 50;){
                        var m = divmod(l = t.multiply(l, u), o);
                        n = m.quotient, l = m.remainder, c.push(Math.abs(t.toNumber(n)));
                    }
                    return d * Number(abs(s).toString() + "." + c.join(""));
                }
            },
            {
                key: "isZero",
                value: function isZero() {
                    return t.equal(this.totalNs, a);
                }
            },
            {
                key: "round",
                value: function round(e, n) {
                    var r = ensureJSBI(e);
                    if (t.equal(r, o)) return this;
                    var u = divmod(this.totalNs, r), s = u.quotient, l = u.remainder, c = t.lessThan(this.totalNs, a) ? "negative" : "positive", d = t.multiply(abs(s), r), m = t.add(d, r), h = compare(abs(t.multiply(l, i)), r), f = GetUnsignedRoundingMode(n, c), p = t.equal(abs(this.totalNs), d) ? d : ApplyUnsignedRoundingMode(d, m, h, isEven(s), f), v = "positive" === c ? p : t.unaryMinus(p);
                    return TimeDuration.validateNew(v, "rounding");
                }
            },
            {
                key: "sign",
                value: function sign() {
                    return this.cmp(new TimeDuration(a));
                }
            },
            {
                key: "subtract",
                value: function subtract(e) {
                    return TimeDuration.validateNew(t.subtract(this.totalNs, e.totalNs), "difference");
                }
            }
        ], [
            {
                key: "validateNew",
                value: function validateNew(e, n) {
                    if (t.greaterThan(abs(e), TimeDuration.MAX)) throw new RangeError("".concat(n, " of duration time units cannot exceed ").concat(TimeDuration.MAX, " s"));
                    return new TimeDuration(e);
                }
            },
            {
                key: "fromEpochNsDiff",
                value: function fromEpochNsDiff(e, n) {
                    return new TimeDuration(t.subtract(ensureJSBI(e), ensureJSBI(n)));
                }
            },
            {
                key: "fromComponents",
                value: function fromComponents(e, n, r, a, o, i) {
                    var u = t.add(t.add(t.add(t.add(t.add(t.BigInt(i), t.multiply(t.BigInt(o), c)), t.multiply(t.BigInt(a), d)), t.multiply(t.BigInt(r), m)), t.multiply(t.BigInt(n), f)), t.multiply(t.BigInt(e), h));
                    return TimeDuration.validateNew(u, "total");
                }
            }
        ]), TimeDuration;
    }();
    te.MAX = t.BigInt("9007199254740991999999999"), te.ZERO = new te(a);
    var ne = /[A-Za-z._][A-Za-z._0-9+-]*/, re = new RegExp("(?:".concat(/(?:[+-](?:[01][0-9]|2[0-3])(?::?[0-5][0-9])?)/.source, "|(?:").concat(ne.source, ")(?:\\/(?:").concat(ne.source, "))*)")), ae = /(?:[+-]\d{6}|\d{4})/, oe = /(?:0[1-9]|1[0-2])/, ie = /(?:0[1-9]|[12]\d|3[01])/, ue = new RegExp("(".concat(ae.source, ")(?:-(").concat(oe.source, ")-(").concat(ie.source, ")|(").concat(oe.source, ")(").concat(ie.source, "))")), se = /(\d{2})(?::(\d{2})(?::(\d{2})(?:[.,](\d{1,9}))?)?|(\d{2})(?:(\d{2})(?:[.,](\d{1,9}))?)?)?/, le = /((?:[+-])(?:[01][0-9]|2[0-3])(?::?(?:[0-5][0-9])(?::?(?:[0-5][0-9])(?:[.,](?:\d{1,9}))?)?)?)/, ce = new RegExp("([zZ])|".concat(le.source, "?")), de = /\[(!)?([a-z_][a-z0-9_-]*)=([A-Za-z0-9]+(?:-[A-Za-z0-9]+)*)\]/g, me = new RegExp([
        "^".concat(ue.source),
        "(?:(?:[tT]|\\s+)".concat(se.source, "(?:").concat(ce.source, ")?)?"),
        "(?:\\[!?(".concat(re.source, ")\\])?"),
        "((?:".concat(de.source, ")*)$")
    ].join("")), he = new RegExp([
        "^[tT]?".concat(se.source),
        "(?:".concat(ce.source, ")?"),
        "(?:\\[!?".concat(re.source, "\\])?"),
        "((?:".concat(de.source, ")*)$")
    ].join("")), fe = new RegExp("^(".concat(ae.source, ")-?(").concat(oe.source, ")(?:\\[!?").concat(re.source, "\\])?((?:").concat(de.source, ")*)$")), pe = new RegExp("^(?:--)?(".concat(oe.source, ")-?(").concat(ie.source, ")(?:\\[!?").concat(re.source, "\\])?((?:").concat(de.source, ")*)$")), ve = /(\d+)(?:[.,](\d{1,9}))?/, De = new RegExp("(?:".concat(ve.source, "H)?(?:").concat(ve.source, "M)?(?:").concat(ve.source, "S)?")), ge = new RegExp("^([+-])?P".concat(/(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)W)?(?:(\d+)D)?/.source, "(?:T(?!$)").concat(De.source, ")?$"), "i"), ye = 864e5, Te = 1e6 * ye, Se = 6e10, Ie = 1e8 * ye, Ce = epochMsToNs(Ie), _e = t.unaryMinus(Ce), Oe = t.add(t.subtract(_e, p), o), be = t.subtract(t.add(Ce, p), o), we = 146097 * ye, Fe = -271821, ke = 275760, Ee = Date.UTC(1847, 0, 1), Be = [
        "iso8601",
        "hebrew",
        "islamic",
        "islamic-umalqura",
        "islamic-tbla",
        "islamic-civil",
        "islamic-rgsa",
        "islamicc",
        "persian",
        "ethiopic",
        "ethioaa",
        "ethiopic-amete-alem",
        "coptic",
        "chinese",
        "dangi",
        "roc",
        "indian",
        "buddhist",
        "japanese",
        "gregory"
    ], Re = new Set([
        "ACT",
        "AET",
        "AGT",
        "ART",
        "AST",
        "BET",
        "BST",
        "CAT",
        "CNT",
        "CST",
        "CTT",
        "EAT",
        "ECT",
        "IET",
        "IST",
        "JST",
        "MIT",
        "NET",
        "NST",
        "PLT",
        "PNT",
        "PRT",
        "PST",
        "SST",
        "VST"
    ]);
    function IsObject(e) {
        return "object" === _typeof(e) && null !== e || "function" == typeof e;
    }
    function ToNumber(e) {
        if ("bigint" == typeof e) throw new TypeError("Cannot convert BigInt to number");
        return Number(e);
    }
    function ToString(e) {
        if ("symbol" === _typeof(e)) throw new TypeError("Cannot convert a Symbol value to a String");
        return String(e);
    }
    function ToIntegerWithTruncation(e) {
        var t = ToNumber(e);
        if (0 === t) return 0;
        if (Number.isNaN(t) || t === 1 / 0 || t === -1 / 0) throw new RangeError("invalid number value");
        var n = Math.trunc(t);
        return 0 === n ? 0 : n;
    }
    function ToPositiveIntegerWithTruncation(e, t) {
        var n = ToIntegerWithTruncation(e);
        if (n <= 0) {
            if (void 0 !== t) throw new RangeError("property '".concat(t, "' cannot be a a number less than one"));
            throw new RangeError("Cannot convert a number less than one to a positive integer");
        }
        return n;
    }
    function ToIntegerIfIntegral(e) {
        var t = ToNumber(e);
        if (Number.isNaN(t)) throw new RangeError("not a number");
        if (t === 1 / 0 || t === -1 / 0) throw new RangeError("infinity is out of range");
        if (!function IsIntegralNumber(e) {
            if ("number" != typeof e || Number.isNaN(e) || e === 1 / 0 || e === -1 / 0) return !1;
            var t = Math.abs(e);
            return Math.floor(t) === t;
        }(t)) throw new RangeError("unsupported fractional value ".concat(e));
        return 0 === t ? 0 : t;
    }
    function ToZeroPaddedDecimalString(e, t) {
        return String(e).padStart(t, "0");
    }
    function RequireString(e) {
        if ("string" != typeof e) throw new TypeError("expected a string, not ".concat(String(e)));
        return e;
    }
    function ToPrimitive(e, t) {
        if (IsObject(e)) {
            var n = null == e ? void 0 : e.toString();
            if ("string" == typeof n || "number" == typeof n) return n;
            throw new TypeError("Cannot convert object to primitive value");
        }
        return e;
    }
    var Ge = [
        "era",
        "eraYear",
        "year",
        "month",
        "monthCode",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond",
        "microsecond",
        "nanosecond",
        "offset",
        "timeZone"
    ], Me = {
        era: ToString,
        eraYear: ToIntegerWithTruncation,
        year: ToIntegerWithTruncation,
        month: ToPositiveIntegerWithTruncation,
        monthCode: function ToSyntacticallyValidMonthCode(e) {
            var t = RequireString(ToPrimitive(e));
            if (t.length < 3 || t.length > 4 || "M" !== t[0] || -1 === "0123456789".indexOf(t[1]) || -1 === "0123456789".indexOf(t[2]) || t[1] + t[2] === "00" && "L" !== t[3] || "L" !== t[3] && void 0 !== t[3]) throw new RangeError("bad month code ".concat(t, "; must match M01-M99 or M00L-M99L"));
            return t;
        },
        day: ToPositiveIntegerWithTruncation,
        hour: ToIntegerWithTruncation,
        minute: ToIntegerWithTruncation,
        second: ToIntegerWithTruncation,
        millisecond: ToIntegerWithTruncation,
        microsecond: ToIntegerWithTruncation,
        nanosecond: ToIntegerWithTruncation,
        offset: function ToOffsetString(e) {
            var t = RequireString(ToPrimitive(e));
            return ParseDateTimeUTCOffset(t), t;
        },
        timeZone: ToTemporalTimeZoneIdentifier
    }, Ae = {
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
        microsecond: 0,
        nanosecond: 0
    }, Pe = [
        [
            "years",
            "year",
            "date"
        ],
        [
            "months",
            "month",
            "date"
        ],
        [
            "weeks",
            "week",
            "date"
        ],
        [
            "days",
            "day",
            "date"
        ],
        [
            "hours",
            "hour",
            "time"
        ],
        [
            "minutes",
            "minute",
            "time"
        ],
        [
            "seconds",
            "second",
            "time"
        ],
        [
            "milliseconds",
            "millisecond",
            "time"
        ],
        [
            "microseconds",
            "microsecond",
            "time"
        ],
        [
            "nanoseconds",
            "nanosecond",
            "time"
        ]
    ], je = Object.fromEntries(Pe.map(function(e) {
        return [
            e[0],
            e[1]
        ];
    })), Ne = Object.fromEntries(Pe.map(function(e) {
        var t = _slicedToArray(e, 2), n = t[0];
        return [
            t[1],
            n
        ];
    })), Ye = Pe.map(function(e) {
        return _slicedToArray(e, 2)[1];
    }), Je = {
        day: Te,
        hour: 36e11,
        minute: 6e10,
        second: 1e9,
        millisecond: 1e6,
        microsecond: 1e3,
        nanosecond: 1
    }, Le = [
        "days",
        "hours",
        "microseconds",
        "milliseconds",
        "minutes",
        "months",
        "nanoseconds",
        "seconds",
        "weeks",
        "years"
    ], Ze = Intl.DateTimeFormat, Ue = new Map;
    function getIntlDateTimeFormatEnUsForTimeZone(e) {
        var t = ASCIILowercase(e), n = Ue.get(t);
        return void 0 === n && (n = new Ze("en-us", {
            timeZone: t,
            hour12: !1,
            era: "short",
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric"
        }), Ue.set(t, n)), n;
    }
    function IsTemporalInstant(e) {
        return HasSlot(e, v) && !HasSlot(e, _, T);
    }
    function IsTemporalDuration(e) {
        return HasSlot(e, O, b, k, E, B, R, G, M, A);
    }
    function IsTemporalDate(e) {
        return HasSlot(e, S);
    }
    function IsTemporalTime(e) {
        return HasSlot(e, y);
    }
    function IsTemporalDateTime(e) {
        return HasSlot(e, g);
    }
    function IsTemporalYearMonth(e) {
        return HasSlot(e, I);
    }
    function IsTemporalMonthDay(e) {
        return HasSlot(e, C);
    }
    function IsTemporalZonedDateTime(e) {
        return HasSlot(e, v, _, T);
    }
    function CheckReceiver(e, t) {
        if (!t(e)) throw new TypeError("invalid receiver: method called with the wrong type of this-object");
    }
    function RejectTemporalLikeObject(e) {
        if (HasSlot(e, T) || HasSlot(e, _)) throw new TypeError("with() does not support a calendar or timeZone property");
        if (IsTemporalTime(e)) throw new TypeError("with() does not accept Temporal.PlainTime, use withPlainTime() instead");
        if (void 0 !== e.calendar) throw new TypeError("with() does not support a calendar property");
        if (void 0 !== e.timeZone) throw new TypeError("with() does not support a timeZone property");
    }
    function FormatCalendarAnnotation(e, t) {
        return "never" === t || "auto" === t && "iso8601" === e ? "" : "[".concat("critical" === t ? "!" : "", "u-ca=").concat(e, "]");
    }
    function processAnnotations(e) {
        var t, n, r = !1;
        for(de.lastIndex = 0; n = de.exec(e);){
            var a = n, o = a[1], i = a[2], u = a[3];
            if ("u-ca" === i) {
                if (void 0 === t) t = u, r = "!" === o;
                else if ("!" === o || r) throw new RangeError("Invalid annotations in ".concat(e, ": more than one u-ca present with critical flag"));
            } else if ("!" === o) throw new RangeError("Unrecognized annotation: !".concat(i, "=").concat(u));
        }
        return t;
    }
    function ParseISODateTime(e) {
        var t, n, r, a, o, i, u, s, l, c, d, m = me.exec(e);
        if (!m) throw new RangeError("invalid RFC 9557 string: ".concat(e));
        var h = processAnnotations(m[16]), f = m[1];
        if ("-000000" === f) throw new RangeError("invalid RFC 9557 string: ".concat(e));
        var p = +f, v = +(null !== (t = null !== (n = m[2]) && void 0 !== n ? n : m[4]) && void 0 !== t ? t : 1), D = +(null !== (r = null !== (a = m[3]) && void 0 !== a ? a : m[5]) && void 0 !== r ? r : 1), g = void 0 !== m[6], y = +(null !== (o = m[6]) && void 0 !== o ? o : 0), T = +(null !== (i = null !== (u = m[7]) && void 0 !== u ? u : m[10]) && void 0 !== i ? i : 0), S = +(null !== (s = null !== (l = m[8]) && void 0 !== l ? l : m[11]) && void 0 !== s ? s : 0);
        60 === S && (S = 59);
        var I, C = (null !== (c = null !== (d = m[9]) && void 0 !== d ? d : m[12]) && void 0 !== c ? c : "") + "000000000", _ = +C.slice(0, 3), O = +C.slice(3, 6), b = +C.slice(6, 9), w = !1;
        m[13] ? (I = void 0, w = !0) : m[14] && (I = m[14]);
        var k = m[15];
        return RejectDateTime(p, v, D, y, T, S, _, O, b), {
            year: p,
            month: v,
            day: D,
            time: g ? {
                hour: y,
                minute: T,
                second: S,
                millisecond: _,
                microsecond: O,
                nanosecond: b
            } : "start-of-day",
            tzAnnotation: k,
            offset: I,
            z: w,
            calendar: h
        };
    }
    function ParseTemporalTimeString(e) {
        var t, n, r, a, o, i, u, s = he.exec(e);
        if (s) {
            var l, c, d, m, h, f, p;
            u = processAnnotations(s[10]), t = +(null !== (l = s[1]) && void 0 !== l ? l : 0), n = +(null !== (c = null !== (d = s[2]) && void 0 !== d ? d : s[5]) && void 0 !== c ? c : 0), 60 == (r = +(null !== (m = null !== (h = s[3]) && void 0 !== h ? h : s[6]) && void 0 !== m ? m : 0)) && (r = 59);
            var v = (null !== (f = null !== (p = s[4]) && void 0 !== p ? p : s[7]) && void 0 !== f ? f : "") + "000000000";
            if (a = +v.slice(0, 3), o = +v.slice(3, 6), i = +v.slice(6, 9), s[8]) throw new RangeError("Z designator not supported for PlainTime");
        } else {
            var D, g, y = ParseISODateTime(e);
            if (D = y.time, g = y.z, u = y.calendar, "start-of-day" === D) throw new RangeError("time is missing in string: ".concat(e));
            if (g) throw new RangeError("Z designator not supported for PlainTime");
            var T = D;
            t = T.hour, n = T.minute, r = T.second, a = T.millisecond, o = T.microsecond, i = T.nanosecond;
        }
        if (RejectTime(t, n, r, a, o, i), /[tT ][0-9][0-9]/.test(e)) return {
            hour: t,
            minute: n,
            second: r,
            millisecond: a,
            microsecond: o,
            nanosecond: i,
            calendar: u
        };
        try {
            var S = ParseTemporalMonthDayString(e);
            RejectISODate(1972, S.month, S.day);
        } catch (s) {
            try {
                var I = ParseTemporalYearMonthString(e);
                RejectISODate(I.year, I.month, 1);
            } catch (e) {
                return {
                    hour: t,
                    minute: n,
                    second: r,
                    millisecond: a,
                    microsecond: o,
                    nanosecond: i,
                    calendar: u
                };
            }
        }
        throw new RangeError("invalid RFC 9557 time-only string ".concat(e, "; may need a T prefix"));
    }
    function ParseTemporalYearMonthString(e) {
        var t, n, r, a, o = fe.exec(e);
        if (o) {
            r = processAnnotations(o[3]);
            var i = o[1];
            if ("-000000" === i) throw new RangeError("invalid RFC 9557 string: ".concat(e));
            if (t = +i, n = +o[2], a = 1, void 0 !== r && "iso8601" !== r) throw new RangeError("YYYY-MM format is only valid with iso8601 calendar");
        } else {
            var u = ParseISODateTime(e);
            if (t = u.year, n = u.month, r = u.calendar, a = u.day, u.z) throw new RangeError("Z designator not supported for PlainYearMonth");
        }
        return {
            year: t,
            month: n,
            calendar: r,
            referenceISODay: a
        };
    }
    function ParseTemporalMonthDayString(e) {
        var t, n, r, a, o = pe.exec(e);
        if (o) {
            if (r = processAnnotations(o[3]), t = +o[1], n = +o[2], void 0 !== r && "iso8601" !== r) throw new RangeError("MM-DD format is only valid with iso8601 calendar");
        } else {
            var i = ParseISODateTime(e);
            if (t = i.month, n = i.day, r = i.calendar, a = i.year, i.z) throw new RangeError("Z designator not supported for PlainMonthDay");
        }
        return {
            month: t,
            day: n,
            calendar: r,
            referenceISOYear: a
        };
    }
    var xe = new RegExp("^".concat(re.source, "$"), "i"), He = new RegExp("^".concat(/([+-])([01][0-9]|2[0-3])(?::?([0-5][0-9])?)?/.source, "$"));
    function throwBadTimeZoneStringError(e) {
        var t = Ke.test(e) ? "Seconds not allowed in offset time zone" : "Invalid time zone";
        throw new RangeError("".concat(t, ": ").concat(e));
    }
    function ParseTimeZoneIdentifier(e) {
        return xe.test(e) || throwBadTimeZoneStringError(e), He.test(e) ? {
            offsetMinutes: ParseDateTimeUTCOffset(e) / 6e10
        } : {
            tzName: e
        };
    }
    function RegulateISODate(e, t, n, r) {
        var a = e, o = t, i = n;
        switch(r){
            case "reject":
                RejectISODate(a, o, i);
                break;
            case "constrain":
                var u = ConstrainISODate(a, o, i);
                a = u.year, o = u.month, i = u.day;
        }
        return {
            year: a,
            month: o,
            day: i
        };
    }
    function RegulateTime(e, t, n, r, a, o, i) {
        var u = e, s = t, l = n, c = r, d = a, m = o;
        switch(i){
            case "reject":
                RejectTime(u, s, l, c, d, m);
                break;
            case "constrain":
                u = ConstrainToRange(u, 0, 23), s = ConstrainToRange(s, 0, 59), l = ConstrainToRange(l, 0, 59), c = ConstrainToRange(c, 0, 999), d = ConstrainToRange(d, 0, 999), m = ConstrainToRange(m, 0, 999);
        }
        return {
            hour: u,
            minute: s,
            second: l,
            millisecond: c,
            microsecond: d,
            nanosecond: m
        };
    }
    function ToTemporalPartialDurationRecord(e) {
        if (!IsObject(e)) throw new TypeError("invalid duration-like");
        for(var t = {
            years: void 0,
            months: void 0,
            weeks: void 0,
            days: void 0,
            hours: void 0,
            minutes: void 0,
            seconds: void 0,
            milliseconds: void 0,
            microseconds: void 0,
            nanoseconds: void 0
        }, n = !1, r = 0; r < Le.length; r++){
            var a = Le[r], o = e[a];
            void 0 !== o && (n = !0, t[a] = ToIntegerIfIntegral(o));
        }
        if (!n) throw new TypeError("invalid duration-like");
        return t;
    }
    function AdjustDateDurationRecord(e, t, n, r) {
        var a = e.years, o = e.months, i = e.weeks, u = e.days;
        return {
            years: a,
            months: null != r ? r : o,
            weeks: null != n ? n : i,
            days: null != t ? t : u
        };
    }
    function CombineISODateAndTimeRecord(e, t) {
        return {
            isoDate: e,
            time: t
        };
    }
    function GetTemporalOverflowOption(e) {
        return GetOption(e, "overflow", [
            "constrain",
            "reject"
        ], "constrain");
    }
    function GetTemporalDisambiguationOption(e) {
        return GetOption(e, "disambiguation", [
            "compatible",
            "earlier",
            "later",
            "reject"
        ], "compatible");
    }
    function GetRoundingModeOption(e, t) {
        return GetOption(e, "roundingMode", [
            "ceil",
            "floor",
            "expand",
            "trunc",
            "halfCeil",
            "halfFloor",
            "halfExpand",
            "halfTrunc",
            "halfEven"
        ], t);
    }
    function GetTemporalOffsetOption(e, t) {
        return GetOption(e, "offset", [
            "prefer",
            "use",
            "ignore",
            "reject"
        ], t);
    }
    function GetTemporalShowCalendarNameOption(e) {
        return GetOption(e, "calendarName", [
            "auto",
            "always",
            "never",
            "critical"
        ], "auto");
    }
    function GetTemporalRoundingIncrementOption(e) {
        var t = e.roundingIncrement;
        if (void 0 === t) return 1;
        var n = ToIntegerWithTruncation(t);
        if (n < 1 || n > 1e9) throw new RangeError("roundingIncrement must be at least 1 and at most 1e9, not ".concat(t));
        return n;
    }
    function ValidateTemporalRoundingIncrement(e, t, n) {
        var r = n ? t : t - 1;
        if (e > r) throw new RangeError("roundingIncrement must be at least 1 and less than ".concat(r, ", not ").concat(e));
        if (t % e != 0) throw new RangeError("Rounding increment must divide evenly into ".concat(t));
    }
    function GetTemporalFractionalSecondDigitsOption(e) {
        var t = e.fractionalSecondDigits;
        if (void 0 === t) return "auto";
        if ("number" != typeof t) {
            if ("auto" !== ToString(t)) throw new RangeError("fractionalSecondDigits must be 'auto' or 0 through 9, not ".concat(t));
            return "auto";
        }
        var n = Math.floor(t);
        if (!Number.isFinite(n) || n < 0 || n > 9) throw new RangeError("fractionalSecondDigits must be 'auto' or 0 through 9, not ".concat(t));
        return n;
    }
    function ToSecondsStringPrecisionRecord(e, t) {
        switch(e){
            case "minute":
                return {
                    precision: "minute",
                    unit: "minute",
                    increment: 1
                };
            case "second":
                return {
                    precision: 0,
                    unit: "second",
                    increment: 1
                };
            case "millisecond":
                return {
                    precision: 3,
                    unit: "millisecond",
                    increment: 1
                };
            case "microsecond":
                return {
                    precision: 6,
                    unit: "microsecond",
                    increment: 1
                };
            case "nanosecond":
                return {
                    precision: 9,
                    unit: "nanosecond",
                    increment: 1
                };
        }
        switch(t){
            case "auto":
                return {
                    precision: t,
                    unit: "nanosecond",
                    increment: 1
                };
            case 0:
                return {
                    precision: t,
                    unit: "second",
                    increment: 1
                };
            case 1:
            case 2:
            case 3:
                return {
                    precision: t,
                    unit: "millisecond",
                    increment: Math.pow(10, 3 - t)
                };
            case 4:
            case 5:
            case 6:
                return {
                    precision: t,
                    unit: "microsecond",
                    increment: Math.pow(10, 6 - t)
                };
            case 7:
            case 8:
            case 9:
                return {
                    precision: t,
                    unit: "nanosecond",
                    increment: Math.pow(10, 9 - t)
                };
            default:
                throw new RangeError("fractionalSecondDigits must be 'auto' or 0 through 9, not ".concat(t));
        }
    }
    var We = Symbol("~required~");
    function GetTemporalUnitValuedOption(e, t, n, r) {
        for(var a = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : [], o = [], i = 0; i < Pe.length; i++){
            var u = Pe[i], s = u[1], l = u[2];
            "datetime" !== n && n !== l || o.push(s);
        }
        o = o.concat(a);
        var c = r;
        c === We ? c = void 0 : void 0 !== c && o.push(c);
        var d = [];
        d = d.concat(o);
        for(var m = 0; m < o.length; m++){
            var h = o[m], f = Ne[h];
            void 0 !== f && d.push(f);
        }
        var p = GetOption(e, t, d, c);
        if (void 0 === p && r === We) throw new RangeError("".concat(t, " is required"));
        return p && p in je ? je[p] : p;
    }
    function GetTemporalRelativeToOption(e) {
        var t = e.relativeTo;
        if (void 0 === t) return {};
        var n, r, a, o, i, u = "option", s = !1;
        if (IsObject(t)) {
            if (IsTemporalZonedDateTime(t)) return {
                zonedRelativeTo: t
            };
            if (IsTemporalDate(t)) return {
                plainRelativeTo: t
            };
            if (IsTemporalDateTime(t)) return {
                plainRelativeTo: CreateTemporalDate(GetSlot(t, g).isoDate, GetSlot(t, T))
            };
            var l = PrepareCalendarFields(a = GetTemporalCalendarIdentifierWithISODefault(t), t, [
                "year",
                "month",
                "monthCode",
                "day"
            ], [
                "hour",
                "minute",
                "second",
                "millisecond",
                "microsecond",
                "nanosecond",
                "offset",
                "timeZone"
            ], []), c = InterpretTemporalDateTimeFields(a, l, "constrain");
            n = c.isoDate, r = c.time, i = l.offset, o = l.timeZone, void 0 === i && (u = "wall");
        } else {
            var d, m, h, f, p, v = ParseISODateTime(RequireString(t));
            if (h = v.year, f = v.month, p = v.day, r = v.time, a = v.calendar, d = v.tzAnnotation, i = v.offset, m = v.z, d) o = ToTemporalTimeZoneIdentifier(d), m ? u = "exact" : i || (u = "wall"), s = !0;
            else if (m) throw new RangeError("Z designator not supported for PlainDate relativeTo; either remove the Z or add a bracketed time zone");
            a || (a = "iso8601"), a = CanonicalizeCalendar(a), n = {
                year: h,
                month: f,
                day: p
            };
        }
        return void 0 === o ? {
            plainRelativeTo: CreateTemporalDate(n, a)
        } : {
            zonedRelativeTo: CreateTemporalZonedDateTime(InterpretISODateTimeOffset(n, r, u, "option" === u ? ParseDateTimeUTCOffset(i) : 0, o, "compatible", "reject", s), o, a)
        };
    }
    function DefaultTemporalLargestUnit(e) {
        return 0 !== GetSlot(e, O) ? "year" : 0 !== GetSlot(e, b) ? "month" : 0 !== GetSlot(e, w) ? "week" : 0 !== GetSlot(e, k) ? "day" : 0 !== GetSlot(e, E) ? "hour" : 0 !== GetSlot(e, B) ? "minute" : 0 !== GetSlot(e, R) ? "second" : 0 !== GetSlot(e, G) ? "millisecond" : 0 !== GetSlot(e, M) ? "microsecond" : "nanosecond";
    }
    function LargerOfTwoTemporalUnits(e, t) {
        return Ye.indexOf(e) > Ye.indexOf(t) ? t : e;
    }
    function IsCalendarUnit(e) {
        return "year" === e || "month" === e || "week" === e;
    }
    function TemporalUnitCategory(e) {
        return IsCalendarUnit(e) || "day" === e ? "date" : "time";
    }
    function calendarImplForID(e) {
        return GetIntrinsic("%calendarImpl%")(e);
    }
    function calendarImplForObj(e) {
        return GetIntrinsic("%calendarImpl%")(GetSlot(e, T));
    }
    function ISODateToFields(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "date", r = Object.create(null), a = calendarImplForID(e).isoToDate(t, {
            year: !0,
            monthCode: !0,
            day: !0
        });
        return r.monthCode = a.monthCode, "month-day" !== n && "date" !== n || (r.day = a.day), "year-month" !== n && "date" !== n || (r.year = a.year), r;
    }
    function PrepareCalendarFields(e, t, n, r, a) {
        var o = calendarImplForID(e).extraFields(n), i = n.concat(r, o), u = Object.create(null), s = !1;
        i.sort();
        for(var l = 0; l < i.length; l++){
            var c = i[l], d = t[c];
            if (void 0 !== d) s = !0, u[c] = (0, Me[c])(d);
            else if ("partial" !== a) {
                if (a.includes(c)) throw new TypeError("required property '".concat(c, "' missing or undefined"));
                u[c] = Ae[c];
            }
        }
        if ("partial" === a && !s) throw new TypeError("no supported properties found");
        return u;
    }
    function ToTemporalTimeRecord(e) {
        for(var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "complete", n = [
            "hour",
            "microsecond",
            "millisecond",
            "minute",
            "nanosecond",
            "second"
        ], r = !1, a = Object.create(null), o = 0; o < n.length; o++){
            var i = n[o], u = e[i];
            void 0 !== u ? (a[i] = ToIntegerWithTruncation(u), r = !0) : "complete" === t && (a[i] = 0);
        }
        if (!r) throw new TypeError("invalid time-like");
        return a;
    }
    function ToTemporalDate(e, t) {
        if (IsObject(e)) {
            if (IsTemporalDate(e)) return GetTemporalOverflowOption(GetOptionsObject(t)), CreateTemporalDate(GetSlot(e, D), GetSlot(e, T));
            if (IsTemporalZonedDateTime(e)) {
                var n = GetISODateTimeFor(GetSlot(e, _), GetSlot(e, v));
                return GetTemporalOverflowOption(GetOptionsObject(t)), CreateTemporalDate(n.isoDate, GetSlot(e, T));
            }
            if (IsTemporalDateTime(e)) return GetTemporalOverflowOption(GetOptionsObject(t)), CreateTemporalDate(GetSlot(e, g).isoDate, GetSlot(e, T));
            var r = GetTemporalCalendarIdentifierWithISODefault(e);
            return CreateTemporalDate(CalendarDateFromFields(r, PrepareCalendarFields(r, e, [
                "year",
                "month",
                "monthCode",
                "day"
            ], [], []), GetTemporalOverflowOption(GetOptionsObject(t))), r);
        }
        var a = function ParseTemporalDateString(e) {
            return ParseISODateTime(e);
        }(RequireString(e)), o = a.year, i = a.month, u = a.day, s = a.calendar;
        if (a.z) throw new RangeError("Z designator not supported for PlainDate");
        return s || (s = "iso8601"), s = CanonicalizeCalendar(s), GetTemporalOverflowOption(GetOptionsObject(t)), CreateTemporalDate({
            year: o,
            month: i,
            day: u
        }, s);
    }
    function InterpretTemporalDateTimeFields(e, t, n) {
        return CombineISODateAndTimeRecord(CalendarDateFromFields(e, t, n), RegulateTime(t.hour, t.minute, t.second, t.millisecond, t.microsecond, t.nanosecond, n));
    }
    function ToTemporalDateTime(e, t) {
        var n, r, a;
        if (IsObject(e)) {
            if (IsTemporalDateTime(e)) return GetTemporalOverflowOption(GetOptionsObject(t)), CreateTemporalDateTime(GetSlot(e, g), GetSlot(e, T));
            if (IsTemporalZonedDateTime(e)) {
                var o = GetISODateTimeFor(GetSlot(e, _), GetSlot(e, v));
                return GetTemporalOverflowOption(GetOptionsObject(t)), CreateTemporalDateTime(o, GetSlot(e, T));
            }
            if (IsTemporalDate(e)) return GetTemporalOverflowOption(GetOptionsObject(t)), CreateTemporalDateTime(CombineISODateAndTimeRecord(GetSlot(e, D), {
                deltaDays: 0,
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
                microsecond: 0,
                nanosecond: 0
            }), GetSlot(e, T));
            var i = InterpretTemporalDateTimeFields(a = GetTemporalCalendarIdentifierWithISODefault(e), PrepareCalendarFields(a, e, [
                "year",
                "month",
                "monthCode",
                "day"
            ], [
                "hour",
                "minute",
                "second",
                "millisecond",
                "microsecond",
                "nanosecond"
            ], []), GetTemporalOverflowOption(GetOptionsObject(t)));
            n = i.isoDate, r = i.time;
        } else {
            var u, s, l, c = function ParseTemporalDateTimeString(e) {
                return ParseISODateTime(e);
            }(RequireString(e));
            if (u = c.year, s = c.month, l = c.day, r = c.time, a = c.calendar, c.z) throw new RangeError("Z designator not supported for PlainDateTime");
            "start-of-day" === r && (r = {
                deltaDays: 0,
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
                microsecond: 0,
                nanosecond: 0
            }), RejectDateTime(u, s, l, r.hour, r.minute, r.second, r.millisecond, r.microsecond, r.nanosecond), a || (a = "iso8601"), a = CanonicalizeCalendar(a), GetTemporalOverflowOption(GetOptionsObject(t)), n = {
                year: u,
                month: s,
                day: l
            };
        }
        return CreateTemporalDateTime(CombineISODateAndTimeRecord(n, r), a);
    }
    function ToTemporalDuration(e) {
        var t = GetIntrinsic("%Temporal.Duration%");
        if (IsTemporalDuration(e)) return new t(GetSlot(e, O), GetSlot(e, b), GetSlot(e, w), GetSlot(e, k), GetSlot(e, E), GetSlot(e, B), GetSlot(e, R), GetSlot(e, G), GetSlot(e, M), GetSlot(e, A));
        if (!IsObject(e)) return function ParseTemporalDurationString(e) {
            var t = function ParseTemporalDurationStringRaw(e) {
                var t = ge.exec(e);
                if (!t) throw new RangeError("invalid duration: ".concat(e));
                if (t.every(function(e, t) {
                    return t < 2 || void 0 === e;
                })) throw new RangeError("invalid duration: ".concat(e));
                var n = "-" === t[1] ? -1 : 1, r = void 0 === t[2] ? 0 : ToIntegerWithTruncation(t[2]) * n, a = void 0 === t[3] ? 0 : ToIntegerWithTruncation(t[3]) * n, o = void 0 === t[4] ? 0 : ToIntegerWithTruncation(t[4]) * n, i = void 0 === t[5] ? 0 : ToIntegerWithTruncation(t[5]) * n, u = void 0 === t[6] ? 0 : ToIntegerWithTruncation(t[6]) * n, s = t[7], l = t[8], c = t[9], d = t[10], m = t[11], h = 0, f = 0, p = 0;
                if (void 0 !== s) {
                    var v, D, g;
                    if (null !== (v = null !== (D = null !== (g = null != l ? l : c) && void 0 !== g ? g : d) && void 0 !== D ? D : m) && void 0 !== v && v) throw new RangeError("only the smallest unit can be fractional");
                    p = 3600 * ToIntegerWithTruncation((s + "000000000").slice(0, 9)) * n;
                } else if (h = void 0 === l ? 0 : ToIntegerWithTruncation(l) * n, void 0 !== c) {
                    var y;
                    if (null !== (y = null != d ? d : m) && void 0 !== y && y) throw new RangeError("only the smallest unit can be fractional");
                    p = 60 * ToIntegerWithTruncation((c + "000000000").slice(0, 9)) * n;
                } else f = void 0 === d ? 0 : ToIntegerWithTruncation(d) * n, void 0 !== m && (p = ToIntegerWithTruncation((m + "000000000").slice(0, 9)) * n);
                var T = p % 1e3, S = Math.trunc(p / 1e3) % 1e3, I = Math.trunc(p / 1e6) % 1e3;
                return f += Math.trunc(p / 1e9) % 60, RejectDuration(r, a, o, i, u, h += Math.trunc(p / 6e10), f, I, S, T), {
                    years: r,
                    months: a,
                    weeks: o,
                    days: i,
                    hours: u,
                    minutes: h,
                    seconds: f,
                    milliseconds: I,
                    microseconds: S,
                    nanoseconds: T
                };
            }(e), n = t.years, r = t.months, a = t.weeks, o = t.days, i = t.hours, u = t.minutes, s = t.seconds, l = t.milliseconds, c = t.microseconds, d = t.nanoseconds;
            return new (GetIntrinsic("%Temporal.Duration%"))(n, r, a, o, i, u, s, l, c, d);
        }(RequireString(e));
        for(var n = {
            years: 0,
            months: 0,
            weeks: 0,
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
            milliseconds: 0,
            microseconds: 0,
            nanoseconds: 0
        }, r = ToTemporalPartialDurationRecord(e), a = 0; a < Le.length; a++){
            var o = Le[a], i = r[o];
            void 0 !== i && (n[o] = i);
        }
        return new t(n.years, n.months, n.weeks, n.days, n.hours, n.minutes, n.seconds, n.milliseconds, n.microseconds, n.nanoseconds);
    }
    function ToTemporalInstant(e) {
        var t;
        if (IsObject(e)) {
            if (IsTemporalInstant(e) || IsTemporalZonedDateTime(e)) return CreateTemporalInstant(GetSlot(e, v));
            t = ToPrimitive(e);
        } else t = e;
        var n = function ParseTemporalInstantString(e) {
            var t = ParseISODateTime(e);
            if (!t.z && !t.offset) throw new RangeError("Temporal.Instant requires a time zone offset");
            return t;
        }(RequireString(t)), r = n.year, a = n.month, o = n.day, i = n.time, u = n.offset, s = n.z, l = "start-of-day" === i ? {} : i, c = l.hour, d = void 0 === c ? 0 : c, m = l.minute, h = void 0 === m ? 0 : m, f = l.second, p = void 0 === f ? 0 : f, D = l.millisecond, g = void 0 === D ? 0 : D, y = l.microsecond, T = void 0 === y ? 0 : y, S = l.nanosecond, I = BalanceISODateTime(r, a, o, d, h, p, g, T, (void 0 === S ? 0 : S) - (s ? 0 : ParseDateTimeUTCOffset(u)));
        return CheckISODaysRange(I.isoDate), CreateTemporalInstant(GetUTCEpochNanoseconds(I));
    }
    function ToTemporalMonthDay(e, t) {
        var n;
        if (IsObject(e)) return IsTemporalMonthDay(e) ? (GetTemporalOverflowOption(GetOptionsObject(t)), CreateTemporalMonthDay(GetSlot(e, D), GetSlot(e, T))) : (HasSlot(e, T) ? n = GetSlot(e, T) : (void 0 === (n = e.calendar) && (n = "iso8601"), n = ToTemporalCalendarIdentifier(n)), CreateTemporalMonthDay(CalendarMonthDayFromFields(n, PrepareCalendarFields(n, e, [
            "year",
            "month",
            "monthCode",
            "day"
        ], [], []), GetTemporalOverflowOption(GetOptionsObject(t))), n));
        var r = ParseTemporalMonthDayString(RequireString(e)), a = r.month, o = r.day, i = r.referenceISOYear, u = r.calendar;
        if (void 0 === u && (u = "iso8601"), u = CanonicalizeCalendar(u), GetTemporalOverflowOption(GetOptionsObject(t)), "iso8601" === u) return CreateTemporalMonthDay({
            year: 1972,
            month: a,
            day: o
        }, u);
        var s = {
            year: i,
            month: a,
            day: o
        };
        return RejectDateRange(s), CreateTemporalMonthDay(s = CalendarMonthDayFromFields(u, ISODateToFields(u, s, "month-day"), "constrain"), u);
    }
    function ToTemporalTime(e, t) {
        var n;
        if (IsObject(e)) {
            if (IsTemporalTime(e)) return GetTemporalOverflowOption(GetOptionsObject(t)), CreateTemporalTime(GetSlot(e, y));
            if (IsTemporalDateTime(e)) return GetTemporalOverflowOption(GetOptionsObject(t)), CreateTemporalTime(GetSlot(e, g).time);
            if (IsTemporalZonedDateTime(e)) {
                var r = GetISODateTimeFor(GetSlot(e, _), GetSlot(e, v));
                return GetTemporalOverflowOption(GetOptionsObject(t)), CreateTemporalTime(r.time);
            }
            var a = ToTemporalTimeRecord(e);
            n = RegulateTime(a.hour, a.minute, a.second, a.millisecond, a.microsecond, a.nanosecond, GetTemporalOverflowOption(GetOptionsObject(t)));
        } else n = ParseTemporalTimeString(RequireString(e)), GetTemporalOverflowOption(GetOptionsObject(t));
        return CreateTemporalTime(n);
    }
    function ToTimeRecordOrMidnight(e) {
        return void 0 === e ? {
            deltaDays: 0,
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
            microsecond: 0,
            nanosecond: 0
        } : GetSlot(ToTemporalTime(e), y);
    }
    function ToTemporalYearMonth(e, t) {
        if (IsObject(e)) {
            if (IsTemporalYearMonth(e)) return GetTemporalOverflowOption(GetOptionsObject(t)), CreateTemporalYearMonth(GetSlot(e, D), GetSlot(e, T));
            var n = GetTemporalCalendarIdentifierWithISODefault(e);
            return CreateTemporalYearMonth(CalendarYearMonthFromFields(n, PrepareCalendarFields(n, e, [
                "year",
                "month",
                "monthCode"
            ], [], []), GetTemporalOverflowOption(GetOptionsObject(t))), n);
        }
        var r = ParseTemporalYearMonthString(RequireString(e)), a = r.year, o = r.month, i = r.referenceISODay, u = r.calendar;
        void 0 === u && (u = "iso8601"), u = CanonicalizeCalendar(u), GetTemporalOverflowOption(GetOptionsObject(t));
        var s = {
            year: a,
            month: o,
            day: i
        };
        return RejectYearMonthRange(s), CreateTemporalYearMonth(s = CalendarYearMonthFromFields(u, ISODateToFields(u, s, "year-month"), "constrain"), u);
    }
    function InterpretISODateTimeOffset(e, n, r, a, o, i, u, s) {
        if ("start-of-day" === n) return GetStartOfDay(o, e);
        var l = CombineISODateAndTimeRecord(e, n);
        if ("wall" === r || "ignore" === u) return GetEpochNanosecondsFor(o, l, i);
        if ("exact" === r || "use" === u) {
            var c = BalanceISODateTime(e.year, e.month, e.day, n.hour, n.minute, n.second, n.millisecond, n.microsecond, n.nanosecond - a);
            CheckISODaysRange(c.isoDate);
            var d = GetUTCEpochNanoseconds(c);
            return ValidateEpochNanoseconds(d), d;
        }
        CheckISODaysRange(e);
        for(var m = GetUTCEpochNanoseconds(l), h = GetPossibleEpochNanoseconds(o, l), f = 0; f < h.length; f++){
            var p = h[f], v = t.toNumber(t.subtract(m, p)), D = RoundNumberToIncrement(v, 6e10, "halfExpand");
            if (v === a || s && D === a) return p;
        }
        if ("reject" === u) {
            var g = FormatUTCOffsetNanoseconds(a), y = ISODateTimeToString(l, "iso8601", "auto");
            throw new RangeError("Offset ".concat(g, " is invalid for ").concat(y, " in ").concat(o));
        }
        return DisambiguatePossibleEpochNanoseconds(h, o, l, i);
    }
    function ToTemporalZonedDateTime(e, t) {
        var n, r, a, o, i, u, s, l = !1, c = "option";
        if (IsObject(e)) {
            if (IsTemporalZonedDateTime(e)) {
                var d = GetOptionsObject(t);
                return GetTemporalDisambiguationOption(d), GetTemporalOffsetOption(d, "reject"), GetTemporalOverflowOption(d), CreateTemporalZonedDateTime(GetSlot(e, v), GetSlot(e, _), GetSlot(e, T));
            }
            var m = PrepareCalendarFields(i = GetTemporalCalendarIdentifierWithISODefault(e), e, [
                "year",
                "month",
                "monthCode",
                "day"
            ], [
                "hour",
                "minute",
                "second",
                "millisecond",
                "microsecond",
                "nanosecond",
                "offset",
                "timeZone"
            ], [
                "timeZone"
            ]);
            o = m.offset, a = m.timeZone, void 0 === o && (c = "wall");
            var h = GetOptionsObject(t);
            u = GetTemporalDisambiguationOption(h), s = GetTemporalOffsetOption(h, "reject");
            var f = InterpretTemporalDateTimeFields(i, m, GetTemporalOverflowOption(h));
            n = f.isoDate, r = f.time;
        } else {
            var p, D, g, y, S, I = function ParseTemporalZonedDateTimeString(e) {
                var t = ParseISODateTime(e);
                if (!t.tzAnnotation) throw new RangeError("Temporal.ZonedDateTime requires a time zone ID in brackets");
                return t;
            }(RequireString(e));
            g = I.year, y = I.month, S = I.day, r = I.time, p = I.tzAnnotation, o = I.offset, D = I.z, i = I.calendar, a = ToTemporalTimeZoneIdentifier(p), D ? c = "exact" : o || (c = "wall"), i || (i = "iso8601"), i = CanonicalizeCalendar(i), l = !0;
            var C = GetOptionsObject(t);
            u = GetTemporalDisambiguationOption(C), s = GetTemporalOffsetOption(C, "reject"), GetTemporalOverflowOption(C), n = {
                year: g,
                month: y,
                day: S
            };
        }
        var O = 0;
        return "option" === c && (O = ParseDateTimeUTCOffset(o)), CreateTemporalZonedDateTime(InterpretISODateTimeOffset(n, r, c, O, a, u, s, l), a, i);
    }
    function CreateTemporalDateSlots(e, t, n) {
        RejectDateRange(t), Q(e), SetSlot(e, D, t), SetSlot(e, T, n), SetSlot(e, S, !0);
    }
    function CreateTemporalDate(e, t) {
        var n = GetIntrinsic("%Temporal.PlainDate%"), r = Object.create(n.prototype);
        return CreateTemporalDateSlots(r, e, t), r;
    }
    function CreateTemporalDateTimeSlots(e, t, n) {
        RejectDateTimeRange(t), Q(e), SetSlot(e, g, t), SetSlot(e, T, n);
    }
    function CreateTemporalDateTime(e, t) {
        var n = GetIntrinsic("%Temporal.PlainDateTime%"), r = Object.create(n.prototype);
        return CreateTemporalDateTimeSlots(r, e, t), r;
    }
    function CreateTemporalMonthDaySlots(e, t, n) {
        RejectDateRange(t), Q(e), SetSlot(e, D, t), SetSlot(e, T, n), SetSlot(e, C, !0);
    }
    function CreateTemporalMonthDay(e, t) {
        var n = GetIntrinsic("%Temporal.PlainMonthDay%"), r = Object.create(n.prototype);
        return CreateTemporalMonthDaySlots(r, e, t), r;
    }
    function CreateTemporalTimeSlots(e, t) {
        Q(e), SetSlot(e, y, t);
    }
    function CreateTemporalTime(e) {
        var t = GetIntrinsic("%Temporal.PlainTime%"), n = Object.create(t.prototype);
        return CreateTemporalTimeSlots(n, e), n;
    }
    function CreateTemporalYearMonthSlots(e, t, n) {
        RejectYearMonthRange(t), Q(e), SetSlot(e, D, t), SetSlot(e, T, n), SetSlot(e, I, !0);
    }
    function CreateTemporalYearMonth(e, t) {
        var n = GetIntrinsic("%Temporal.PlainYearMonth%"), r = Object.create(n.prototype);
        return CreateTemporalYearMonthSlots(r, e, t), r;
    }
    function CreateTemporalInstantSlots(e, t) {
        ValidateEpochNanoseconds(t), Q(e), SetSlot(e, v, t);
    }
    function CreateTemporalInstant(e) {
        var t = GetIntrinsic("%Temporal.Instant%"), n = Object.create(t.prototype);
        return CreateTemporalInstantSlots(n, e), n;
    }
    function CreateTemporalZonedDateTimeSlots(e, t, n, r) {
        ValidateEpochNanoseconds(t), Q(e), SetSlot(e, v, t), SetSlot(e, _, n), SetSlot(e, T, r);
    }
    function CreateTemporalZonedDateTime(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "iso8601", r = GetIntrinsic("%Temporal.ZonedDateTime%"), a = Object.create(r.prototype);
        return CreateTemporalZonedDateTimeSlots(a, e, t, n), a;
    }
    function CalendarFieldKeysPresent(e) {
        return Ge.filter(function(t) {
            return void 0 !== e[t];
        });
    }
    function CalendarMergeFields(e, t, n) {
        for(var r = CalendarFieldKeysPresent(n), a = calendarImplForID(e).fieldKeysToIgnore(r), o = Object.create(null), i = CalendarFieldKeysPresent(t), u = 0; u < Ge.length; u++){
            var s = void 0, l = Ge[u];
            i.includes(l) && !a.includes(l) && (s = t[l]), r.includes(l) && (s = n[l]), void 0 !== s && (o[l] = s);
        }
        return o;
    }
    function CalendarDateAdd(e, t, n, r) {
        var a = calendarImplForID(e).dateAdd(t, n, r);
        return RejectDateRange(a), a;
    }
    function CalendarDateUntil(e, t, n, r) {
        return calendarImplForID(e).dateUntil(t, n, r);
    }
    function ToTemporalCalendarIdentifier(e) {
        if (IsObject(e) && HasSlot(e, T)) return GetSlot(e, T);
        var t, n = RequireString(e);
        try {
            return CanonicalizeCalendar(n);
        } catch (e) {}
        try {
            t = ParseISODateTime(n).calendar;
        } catch (e) {
            try {
                t = ParseTemporalTimeString(n).calendar;
            } catch (e) {
                try {
                    t = ParseTemporalYearMonthString(n).calendar;
                } catch (e) {
                    t = ParseTemporalMonthDayString(n).calendar;
                }
            }
        }
        return t || (t = "iso8601"), CanonicalizeCalendar(t);
    }
    function GetTemporalCalendarIdentifierWithISODefault(e) {
        if (HasSlot(e, T)) return GetSlot(e, T);
        var t = e.calendar;
        return void 0 === t ? "iso8601" : ToTemporalCalendarIdentifier(t);
    }
    function CalendarEquals(e, t) {
        return CanonicalizeCalendar(e) === CanonicalizeCalendar(t);
    }
    function CalendarDateFromFields(e, t, n) {
        var r = calendarImplForID(e);
        r.resolveFields(t, "date");
        var a = r.dateToISO(t, n);
        return RejectDateRange(a), a;
    }
    function CalendarYearMonthFromFields(e, t, n) {
        var r = calendarImplForID(e);
        r.resolveFields(t, "year-month"), t.day = 1;
        var a = r.dateToISO(t, n);
        return RejectYearMonthRange(a), a;
    }
    function CalendarMonthDayFromFields(e, t, n) {
        var r = calendarImplForID(e);
        r.resolveFields(t, "month-day");
        var a = r.monthDayToISOReferenceDate(t, n);
        return RejectDateRange(a), a;
    }
    function ToTemporalTimeZoneIdentifier(e) {
        if (IsObject(e) && IsTemporalZonedDateTime(e)) return GetSlot(e, _);
        var t = RequireString(e);
        if ("UTC" === t) return "UTC";
        var n = function ParseTemporalTimeZoneString(e) {
            var t = function ParseTemporalTimeZoneStringRaw(e) {
                if (xe.test(e)) return {
                    tzAnnotation: e,
                    offset: void 0,
                    z: !1
                };
                try {
                    var t = ParseISODateTime(e), n = t.tzAnnotation, r = t.offset, a = t.z;
                    if (a || n || r) return {
                        tzAnnotation: n,
                        offset: r,
                        z: a
                    };
                } catch (e) {}
                throwBadTimeZoneStringError(e);
            }(e), n = t.tzAnnotation, r = t.offset, a = t.z;
            return n ? ParseTimeZoneIdentifier(n) : a ? ParseTimeZoneIdentifier("UTC") : r ? ParseTimeZoneIdentifier(r) : void 0;
        }(t), r = n.tzName, a = n.offsetMinutes;
        if (void 0 !== a) return FormatOffsetTimeZoneIdentifier(a);
        var o = GetAvailableNamedTimeZoneIdentifier(r);
        if (!o) throw new RangeError("Unrecognized time zone ".concat(r));
        return o.identifier;
    }
    function TimeZoneEquals(e, t) {
        if (e === t) return !0;
        var n = ParseTimeZoneIdentifier(e).offsetMinutes, r = ParseTimeZoneIdentifier(t).offsetMinutes;
        if (void 0 === n && void 0 === r) {
            var a = GetAvailableNamedTimeZoneIdentifier(t);
            if (!a) return !1;
            var o = GetAvailableNamedTimeZoneIdentifier(e);
            return !!o && o.primaryIdentifier === a.primaryIdentifier;
        }
        return n === r;
    }
    function GetOffsetNanosecondsFor(e, t) {
        var n = ParseTimeZoneIdentifier(e).offsetMinutes;
        return void 0 !== n ? 6e10 * n : GetNamedTimeZoneOffsetNanoseconds(e, t);
    }
    function FormatUTCOffsetNanoseconds(e) {
        var t = e < 0 ? "-" : "+", n = Math.abs(e), r = Math.floor(n / 36e11), a = Math.floor(n / 6e10) % 60, o = Math.floor(n / 1e9) % 60, i = n % 1e9, u = FormatTimeString(r, a, o, i, 0 === o && 0 === i ? "minute" : "auto");
        return "".concat(t).concat(u);
    }
    function GetISODateTimeFor(e, t) {
        var n = GetOffsetNanosecondsFor(e, t), r = GetISOPartsFromEpoch(t), a = r.isoDate, o = a.year, i = a.month, u = a.day, s = r.time;
        return BalanceISODateTime(o, i, u, s.hour, s.minute, s.second, s.millisecond, s.microsecond, s.nanosecond + n);
    }
    function GetEpochNanosecondsFor(e, t, n) {
        return DisambiguatePossibleEpochNanoseconds(GetPossibleEpochNanoseconds(e, t), e, t, n);
    }
    function DisambiguatePossibleEpochNanoseconds(e, n, r, a) {
        var o = e.length;
        if (1 === o) return e[0];
        if (o) switch(a){
            case "compatible":
            case "earlier":
                return e[0];
            case "later":
                return e[o - 1];
            case "reject":
                throw new RangeError("multiple instants found");
        }
        if ("reject" === a) throw new RangeError("multiple instants found");
        var i = GetUTCEpochNanoseconds(r), u = t.subtract(i, p);
        ValidateEpochNanoseconds(u);
        var s = GetOffsetNanosecondsFor(n, u), l = t.add(i, p);
        ValidateEpochNanoseconds(l);
        var c = GetOffsetNanosecondsFor(n, l) - s;
        switch(a){
            case "earlier":
                var d = te.fromComponents(0, 0, 0, 0, 0, -c), m = AddTime(r.time, d);
                return GetPossibleEpochNanoseconds(n, CombineISODateAndTimeRecord(BalanceISODate(r.isoDate.year, r.isoDate.month, r.isoDate.day + m.deltaDays), m))[0];
            case "compatible":
            case "later":
                var h = te.fromComponents(0, 0, 0, 0, 0, c), f = AddTime(r.time, h), v = GetPossibleEpochNanoseconds(n, CombineISODateAndTimeRecord(BalanceISODate(r.isoDate.year, r.isoDate.month, r.isoDate.day + f.deltaDays), f));
                return v[v.length - 1];
        }
    }
    function GetPossibleEpochNanoseconds(e, n) {
        if ("UTC" === e) return CheckISODaysRange(n.isoDate), [
            GetUTCEpochNanoseconds(n)
        ];
        var r = ParseTimeZoneIdentifier(e).offsetMinutes;
        if (void 0 !== r) {
            var a = BalanceISODateTime(n.isoDate.year, n.isoDate.month, n.isoDate.day, n.time.hour, n.time.minute - r, n.time.second, n.time.millisecond, n.time.microsecond, n.time.nanosecond);
            CheckISODaysRange(a.isoDate);
            var o = GetUTCEpochNanoseconds(a);
            return ValidateEpochNanoseconds(o), [
                o
            ];
        }
        return CheckISODaysRange(n.isoDate), function GetNamedTimeZoneEpochNanoseconds(e, n) {
            var r = GetUTCEpochNanoseconds(n), a = t.subtract(r, p);
            t.lessThan(a, _e) && (a = r);
            var o = t.add(r, p);
            t.greaterThan(o, Ce) && (o = r);
            var i = GetNamedTimeZoneOffsetNanoseconds(e, a), u = GetNamedTimeZoneOffsetNanoseconds(e, o), s = (i === u ? [
                i
            ] : [
                i,
                u
            ]).map(function(a) {
                var o = t.subtract(r, t.BigInt(a)), i = function GetNamedTimeZoneDateTimeParts(e, t) {
                    var n = GetISOPartsFromEpoch(t), r = n.epochMilliseconds, a = n.time, o = a.millisecond, i = a.microsecond, u = a.nanosecond, s = GetFormatterParts(e, r);
                    return BalanceISODateTime(s.year, s.month, s.day, s.hour, s.minute, s.second, o, i, u);
                }(e, o);
                if (0 === CompareISODateTime(n, i)) return ValidateEpochNanoseconds(o), o;
            });
            return s.filter(function(e) {
                return void 0 !== e;
            });
        }(e, n);
    }
    function GetStartOfDay(e, n) {
        var r = CombineISODateAndTimeRecord(n, {
            deltaDays: 0,
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
            microsecond: 0,
            nanosecond: 0
        }), a = GetPossibleEpochNanoseconds(e, r);
        if (a.length) return a[0];
        var o = GetUTCEpochNanoseconds(r), i = t.subtract(o, p);
        return ValidateEpochNanoseconds(i), GetNamedTimeZoneNextTransition(e, i);
    }
    function ISOYearString(e) {
        return e < 0 || e > 9999 ? (e < 0 ? "-" : "+") + ToZeroPaddedDecimalString(Math.abs(e), 6) : ToZeroPaddedDecimalString(e, 4);
    }
    function ISODateTimePartString(e) {
        return ToZeroPaddedDecimalString(e, 2);
    }
    function FormatFractionalSeconds(e, t) {
        var n;
        if ("auto" === t) {
            if (0 === e) return "";
            n = ToZeroPaddedDecimalString(e, 9).replace(/0+$/, "");
        } else {
            if (0 === t) return "";
            n = ToZeroPaddedDecimalString(e, 9).slice(0, t);
        }
        return ".".concat(n);
    }
    function FormatTimeString(e, t, n, r, a) {
        var o = "".concat(ISODateTimePartString(e), ":").concat(ISODateTimePartString(t));
        return "minute" === a ? o : (o += ":".concat(ISODateTimePartString(n)), o += FormatFractionalSeconds(r, a));
    }
    function TemporalInstantToString(e, t, n) {
        var r = t;
        void 0 === r && (r = "UTC");
        var a = GetSlot(e, v), o = ISODateTimeToString(GetISODateTimeFor(r, a), "iso8601", n, "never"), i = "Z";
        return void 0 !== t && (i = FormatDateTimeUTCOffsetRounded(GetOffsetNanosecondsFor(r, a))), "".concat(o).concat(i);
    }
    function TemporalDurationToString(e, t) {
        var n = GetSlot(e, O), r = GetSlot(e, b), a = GetSlot(e, w), o = GetSlot(e, k), i = GetSlot(e, E), u = GetSlot(e, B), s = DurationSign(e), l = "";
        0 !== n && (l += "".concat(Math.abs(n), "Y")), 0 !== r && (l += "".concat(Math.abs(r), "M")), 0 !== a && (l += "".concat(Math.abs(a), "W")), 0 !== o && (l += "".concat(Math.abs(o), "D"));
        var c = "";
        0 !== i && (c += "".concat(Math.abs(i), "H")), 0 !== u && (c += "".concat(Math.abs(u), "M"));
        var d = te.fromComponents(0, 0, GetSlot(e, R), GetSlot(e, G), GetSlot(e, M), GetSlot(e, A));
        if (!d.isZero() || [
            "second",
            "millisecond",
            "microsecond",
            "nanosecond"
        ].includes(DefaultTemporalLargestUnit(e)) || "auto" !== t) {
            var m = Math.abs(d.sec), h = FormatFractionalSeconds(Math.abs(d.subsec), t);
            c += "".concat(m).concat(h, "S");
        }
        var f = "".concat(s < 0 ? "-" : "", "P").concat(l);
        return c && (f = "".concat(f, "T").concat(c)), f;
    }
    function TemporalDateToString(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "auto", n = GetSlot(e, D), r = n.year, a = n.month, o = n.day, i = ISOYearString(r), u = ISODateTimePartString(a), s = ISODateTimePartString(o), l = FormatCalendarAnnotation(GetSlot(e, T), t);
        return "".concat(i, "-").concat(u, "-").concat(s).concat(l);
    }
    function TimeRecordToString(e, t) {
        return FormatTimeString(e.hour, e.minute, e.second, 1e6 * e.millisecond + 1e3 * e.microsecond + e.nanosecond, t);
    }
    function ISODateTimeToString(e, t, n) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "auto", a = e.isoDate, o = a.year, i = a.month, u = a.day, s = e.time, l = s.hour, c = s.minute, d = s.second, m = s.millisecond, h = s.microsecond, f = s.nanosecond, p = ISOYearString(o), v = ISODateTimePartString(i), D = ISODateTimePartString(u), g = FormatTimeString(l, c, d, 1e6 * m + 1e3 * h + f, n), y = FormatCalendarAnnotation(t, r);
        return "".concat(p, "-").concat(v, "-").concat(D, "T").concat(g).concat(y);
    }
    function TemporalMonthDayToString(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "auto", n = GetSlot(e, D), r = n.year, a = n.month, o = n.day, i = ISODateTimePartString(a), u = ISODateTimePartString(o), s = "".concat(i, "-").concat(u), l = GetSlot(e, T);
        if ("always" === t || "critical" === t || "iso8601" !== l) {
            var c = ISOYearString(r);
            s = "".concat(c, "-").concat(s);
        }
        var d = FormatCalendarAnnotation(l, t);
        return d && (s += d), s;
    }
    function TemporalYearMonthToString(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "auto", n = GetSlot(e, D), r = n.year, a = n.month, o = n.day, i = ISOYearString(r), u = ISODateTimePartString(a), s = "".concat(i, "-").concat(u), l = GetSlot(e, T);
        if ("always" === t || "critical" === t || "iso8601" !== l) {
            var c = ISODateTimePartString(o);
            s += "-".concat(c);
        }
        var d = FormatCalendarAnnotation(l, t);
        return d && (s += d), s;
    }
    function TemporalZonedDateTimeToString(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "auto", r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "auto", a = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "auto", o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : void 0, i = GetSlot(e, v);
        if (o) {
            var u = o.unit;
            i = RoundTemporalInstant(i, o.increment, u, o.roundingMode);
        }
        var s = GetSlot(e, _), l = GetOffsetNanosecondsFor(s, i), c = ISODateTimeToString(GetISODateTimeFor(s, i), "iso8601", t, "never");
        return "never" !== a && (c += FormatDateTimeUTCOffsetRounded(l)), "never" !== r && (c += "[".concat("critical" === r ? "!" : "").concat(s, "]")), c + FormatCalendarAnnotation(GetSlot(e, T), n);
    }
    function IsOffsetTimeZoneIdentifier(e) {
        return He.test(e);
    }
    function ParseDateTimeUTCOffset(e) {
        var t = Xe.exec(e);
        if (!t) throw new RangeError("invalid time zone offset: ".concat(e, "; must match \xb1HH:MM[:SS.SSSSSSSSS]"));
        return ("-" === t[1] ? -1 : 1) * (1e9 * (60 * (60 * +t[2] + +(t[3] || 0)) + +(t[4] || 0)) + +((t[5] || 0) + "000000000").slice(0, 9));
    }
    var ze = void 0, qe = Object.assign(Object.create(null), {
        "/": !0,
        "-": !0,
        _: !0
    });
    function GetAvailableNamedTimeZoneIdentifier(e) {
        var t, n, r;
        if (void 0 === ze) {
            var a, o, i = null === (a = (o = Intl).supportedValuesOf) || void 0 === a ? void 0 : a.call(o, "timeZone");
            if (i) {
                ze = new Map;
                for(var u = 0; u < i.length; u++){
                    var s = i[u];
                    ze.set(ASCIILowercase(s), s);
                }
            } else ze = null;
        }
        var l = ASCIILowercase(e), c = null === (t = ze) || void 0 === t ? void 0 : t.get(l);
        if (c) return {
            identifier: c,
            primaryIdentifier: c
        };
        try {
            c = getIntlDateTimeFormatEnUsForTimeZone(e).resolvedOptions().timeZone;
        } catch (e) {
            return;
        }
        if ("antarctica/south_pole" === l && (c = "Antarctica/McMurdo"), Re.has(e)) throw new RangeError("".concat(e, " is a legacy time zone identifier from ICU. Use ").concat(c, " instead"));
        var d = _toConsumableArray(l).map(function(e, t) {
            return 0 === t || qe[l[t - 1]] ? e.toUpperCase() : e;
        }).join("").split("/");
        if (1 === d.length) return "gb-eire" === l ? {
            identifier: "GB-Eire",
            primaryIdentifier: c
        } : {
            identifier: l.length <= 3 || /[-0-9]/.test(l) ? l.toUpperCase() : d[0],
            primaryIdentifier: c
        };
        if ("Etc" === d[0]) {
            var m = [
                "Zulu",
                "Greenwich",
                "Universal"
            ].includes(d[1]) ? d[1] : d[1].toUpperCase();
            return {
                identifier: "Etc/".concat(m),
                primaryIdentifier: c
            };
        }
        if ("Us" === d[0]) return {
            identifier: "US/".concat(d[1]),
            primaryIdentifier: c
        };
        var h = new Map([
            [
                "Act",
                "ACT"
            ],
            [
                "Lhi",
                "LHI"
            ],
            [
                "Nsw",
                "NSW"
            ],
            [
                "Dar_Es_Salaam",
                "Dar_es_Salaam"
            ],
            [
                "Port_Of_Spain",
                "Port_of_Spain"
            ],
            [
                "Port-Au-Prince",
                "Port-au-Prince"
            ],
            [
                "Isle_Of_Man",
                "Isle_of_Man"
            ],
            [
                "Comodrivadavia",
                "ComodRivadavia"
            ],
            [
                "Knox_In",
                "Knox_IN"
            ],
            [
                "Dumontdurville",
                "DumontDUrville"
            ],
            [
                "Mcmurdo",
                "McMurdo"
            ],
            [
                "Denoronha",
                "DeNoronha"
            ],
            [
                "Easterisland",
                "EasterIsland"
            ],
            [
                "Bajanorte",
                "BajaNorte"
            ],
            [
                "Bajasur",
                "BajaSur"
            ]
        ]);
        return d[1] = null !== (n = h.get(d[1])) && void 0 !== n ? n : d[1], d.length > 2 && (d[2] = null !== (r = h.get(d[2])) && void 0 !== r ? r : d[2]), {
            identifier: d.join("/"),
            primaryIdentifier: c
        };
    }
    function GetNamedTimeZoneOffsetNanosecondsImpl(e, t) {
        var n = GetFormatterParts(e, t), r = t % 1e3;
        return r < 0 && (r += 1e3), 1e6 * (GetUTCEpochMilliseconds({
            isoDate: {
                year: n.year,
                month: n.month,
                day: n.day
            },
            time: {
                hour: n.hour,
                minute: n.minute,
                second: n.second,
                millisecond: r
            }
        }) - t);
    }
    function GetNamedTimeZoneOffsetNanoseconds(e, t) {
        return GetNamedTimeZoneOffsetNanosecondsImpl(e, epochNsToMs(t, "floor"));
    }
    function FormatOffsetTimeZoneIdentifier(e) {
        var t = e < 0 ? "-" : "+", n = Math.abs(e), r = FormatTimeString(Math.floor(n / 60), n % 60, 0, 0, "minute");
        return "".concat(t).concat(r);
    }
    function FormatDateTimeUTCOffsetRounded(e) {
        return FormatOffsetTimeZoneIdentifier(RoundNumberToIncrement(e, Se, "halfExpand") / 6e10);
    }
    function GetUTCEpochMilliseconds(e) {
        var t = e.isoDate, n = t.year, r = t.month, a = t.day, o = e.time, i = o.hour, u = o.minute, s = o.second, l = o.millisecond, c = n % 400, d = (n - c) / 400, m = new Date;
        return m.setUTCHours(i, u, s, l), m.setUTCFullYear(c, r - 1, a), m.getTime() + we * d;
    }
    function GetUTCEpochNanoseconds(e) {
        var n = GetUTCEpochMilliseconds(e), r = 1e3 * e.time.microsecond + e.time.nanosecond;
        return t.add(epochMsToNs(n), t.BigInt(r));
    }
    function GetISOPartsFromEpoch(e) {
        var n = epochNsToMs(e, "trunc"), r = t.toNumber(t.remainder(e, d));
        r < 0 && (r += 1e6, n -= 1);
        var a = Math.floor(r / 1e3) % 1e3, o = r % 1e3, i = new Date(n);
        return {
            epochMilliseconds: n,
            isoDate: {
                year: i.getUTCFullYear(),
                month: i.getUTCMonth() + 1,
                day: i.getUTCDate()
            },
            time: {
                hour: i.getUTCHours(),
                minute: i.getUTCMinutes(),
                second: i.getUTCSeconds(),
                millisecond: i.getUTCMilliseconds(),
                microsecond: a,
                nanosecond: o
            }
        };
    }
    function GetNamedTimeZoneNextTransition(e, t) {
        if ("UTC" === e) return null;
        var n = epochNsToMs(t, "floor");
        if (n < Ee) return GetNamedTimeZoneNextTransition(e, epochMsToNs(Ee));
        for(var r = Date.now(), a = Math.max(n, r) + 366 * ye * 3, o = n, i = GetNamedTimeZoneOffsetNanosecondsImpl(e, o), u = o, s = i; i === s && o < a;){
            if ((u = o + 2 * ye * 7) > Ie) return null;
            i === (s = GetNamedTimeZoneOffsetNanosecondsImpl(e, u)) && (o = u);
        }
        return i === s ? null : epochMsToNs(bisect(function(t) {
            return GetNamedTimeZoneOffsetNanosecondsImpl(e, t);
        }, o, u, i, s));
    }
    function GetNamedTimeZonePreviousTransition(e, n) {
        if ("UTC" === e) return null;
        var r = epochNsToMs(n, "ceil"), a = Date.now(), o = a + 366 * ye * 3;
        if (r > o) {
            var i = GetNamedTimeZonePreviousTransition(e, epochMsToNs(o));
            if (null === i || t.lessThan(i, epochMsToNs(a))) return i;
        }
        if ("Africa/Casablanca" === e || "Africa/El_Aaiun" === e) {
            var u = Date.UTC(2088, 0, 1);
            if (u < r) return GetNamedTimeZonePreviousTransition(e, epochMsToNs(u));
        }
        var s = r - 1;
        if (s < Ee) return null;
        for(var l = GetNamedTimeZoneOffsetNanosecondsImpl(e, s), c = s, d = l; l === d && s > Ee;){
            if ((c = s - 2 * ye * 7) < Ee) return null;
            l === (d = GetNamedTimeZoneOffsetNanosecondsImpl(e, c)) && (s = c);
        }
        return l === d ? null : epochMsToNs(bisect(function(t) {
            return GetNamedTimeZoneOffsetNanosecondsImpl(e, t);
        }, c, s, d, l));
    }
    function GetFormatterParts(e, t) {
        return function parseFromEnUsFormat(e) {
            var t = e.split(/[^\w]+/);
            if (7 !== t.length) throw new RangeError('expected 7 parts in "'.concat(e));
            var n = +t[0], r = +t[1], a = +t[2], o = t[3];
            if ("b" === o[0] || "B" === o[0]) a = 1 - a;
            else if ("a" !== o[0] && "A" !== o[0]) throw new RangeError("Unknown era ".concat(o, ' in "').concat(e));
            var i = "24" === t[4] ? 0 : +t[4], u = +t[5], s = +t[6];
            if (!(Number.isFinite(a) && Number.isFinite(n) && Number.isFinite(r) && Number.isFinite(i) && Number.isFinite(u) && Number.isFinite(s))) throw new RangeError('Invalid number in "'.concat(e));
            return {
                year: a,
                month: n,
                day: r,
                hour: i,
                minute: u,
                second: s
            };
        }(getIntlDateTimeFormatEnUsForTimeZone(e).format(t));
    }
    function LeapYear(e) {
        return !(void 0 === e || e % 4 != 0 || e % 100 == 0 && e % 400 != 0);
    }
    function ISODaysInMonth(e, t) {
        return ({
            standard: [
                31,
                28,
                31,
                30,
                31,
                30,
                31,
                31,
                30,
                31,
                30,
                31
            ],
            leapyear: [
                31,
                29,
                31,
                30,
                31,
                30,
                31,
                31,
                30,
                31,
                30,
                31
            ]
        })[LeapYear(e) ? "leapyear" : "standard"][t - 1];
    }
    function DurationSign(e) {
        for(var t = [
            GetSlot(e, O),
            GetSlot(e, b),
            GetSlot(e, w),
            GetSlot(e, k),
            GetSlot(e, E),
            GetSlot(e, B),
            GetSlot(e, R),
            GetSlot(e, G),
            GetSlot(e, M),
            GetSlot(e, A)
        ], n = 0; n < t.length; n++){
            var r = t[n];
            if (0 !== r) return r < 0 ? -1 : 1;
        }
        return 0;
    }
    function DateDurationSign(e) {
        for(var t = [
            "years",
            "months",
            "weeks",
            "days"
        ], n = 0; n < t.length; n++){
            var r = e[t[n]];
            if (0 !== r) return r < 0 ? -1 : 1;
        }
        return 0;
    }
    function InternalDurationSign(e) {
        var t = DateDurationSign(e.date);
        return 0 !== t ? t : e.time.sign();
    }
    function BalanceISOYearMonth(e, t) {
        var n = e, r = t;
        if (!Number.isFinite(n) || !Number.isFinite(r)) throw new RangeError("infinity is out of range");
        return r -= 1, n += Math.floor(r / 12), (r %= 12) < 0 && (r += 12), {
            year: n,
            month: r += 1
        };
    }
    function BalanceISODate(e, t, n) {
        var r = e, a = t, o = n;
        if (!Number.isFinite(o)) throw new RangeError("infinity is out of range");
        var i = BalanceISOYearMonth(r, a);
        r = i.year, a = i.month;
        var u = 146097;
        if (Math.abs(o) > u) {
            var s = Math.trunc(o / u);
            r += 400 * s, o -= s * u;
        }
        for(var l = 0, c = a > 2 ? r : r - 1; o < -(l = LeapYear(c) ? 366 : 365);)r -= 1, c -= 1, o += l;
        for(c += 1; o > (l = LeapYear(c) ? 366 : 365);)r += 1, c += 1, o -= l;
        for(; o < 1;){
            var d = BalanceISOYearMonth(r, a - 1);
            o += ISODaysInMonth(r = d.year, a = d.month);
        }
        for(; o > ISODaysInMonth(r, a);){
            o -= ISODaysInMonth(r, a);
            var m = BalanceISOYearMonth(r, a + 1);
            r = m.year, a = m.month;
        }
        return {
            year: r,
            month: a,
            day: o
        };
    }
    function BalanceISODateTime(e, t, n, r, a, o, i, u, s) {
        var l = BalanceTime(r, a, o, i, u, s);
        return CombineISODateAndTimeRecord(BalanceISODate(e, t, n + l.deltaDays), l);
    }
    function BalanceTime(e, t, n, r, a, o) {
        var i = e, u = t, s = n, l = r, c = a, d = o, m = TruncatingDivModByPowerOf10(d, 3);
        c += m.div, (d = m.mod) < 0 && (c -= 1, d += 1e3);
        var h = TruncatingDivModByPowerOf10(c, 3);
        l += h.div, (c = h.mod) < 0 && (l -= 1, c += 1e3), s += Math.trunc(l / 1e3), (l %= 1e3) < 0 && (s -= 1, l += 1e3), u += Math.trunc(s / 60), (s %= 60) < 0 && (u -= 1, s += 60), i += Math.trunc(u / 60), (u %= 60) < 0 && (i -= 1, u += 60);
        var f = Math.trunc(i / 24);
        return (i %= 24) < 0 && (f -= 1, i += 24), {
            deltaDays: f += 0,
            hour: i += 0,
            minute: u += 0,
            second: s += 0,
            millisecond: l += 0,
            microsecond: c += 0,
            nanosecond: d += 0
        };
    }
    function DateDurationDays(e, t) {
        var n = AdjustDateDurationRecord(e, 0);
        if (0 === DateDurationSign(n)) return e.days;
        var r = GetSlot(t, D), a = CalendarDateAdd(GetSlot(t, T), r, n, "constrain"), o = ISODateToEpochDays(r.year, r.month - 1, r.day), i = ISODateToEpochDays(a.year, a.month - 1, a.day) - o;
        return e.days + i;
    }
    function CreateNegatedTemporalDuration(e) {
        return new (GetIntrinsic("%Temporal.Duration%"))(-GetSlot(e, O), -GetSlot(e, b), -GetSlot(e, w), -GetSlot(e, k), -GetSlot(e, E), -GetSlot(e, B), -GetSlot(e, R), -GetSlot(e, G), -GetSlot(e, M), -GetSlot(e, A));
    }
    function ConstrainToRange(e, t, n) {
        return Math.min(n, Math.max(t, e));
    }
    function ConstrainISODate(e, t, n) {
        var r = ConstrainToRange(t, 1, 12);
        return {
            year: e,
            month: r,
            day: ConstrainToRange(n, 1, ISODaysInMonth(e, r))
        };
    }
    function RejectToRange(e, t, n) {
        if (e < t || e > n) throw new RangeError("value out of range: ".concat(t, " <= ").concat(e, " <= ").concat(n));
    }
    function RejectISODate(e, t, n) {
        RejectToRange(t, 1, 12), RejectToRange(n, 1, ISODaysInMonth(e, t));
    }
    function RejectDateRange(e) {
        RejectDateTimeRange(CombineISODateAndTimeRecord(e, {
            deltaDays: 0,
            hour: 12,
            minute: 0,
            second: 0,
            millisecond: 0,
            microsecond: 0,
            nanosecond: 0
        }));
    }
    function RejectTime(e, t, n, r, a, o) {
        RejectToRange(e, 0, 23), RejectToRange(t, 0, 59), RejectToRange(n, 0, 59), RejectToRange(r, 0, 999), RejectToRange(a, 0, 999), RejectToRange(o, 0, 999);
    }
    function RejectDateTime(e, t, n, r, a, o, i, u, s) {
        RejectISODate(e, t, n), RejectTime(r, a, o, i, u, s);
    }
    function RejectDateTimeRange(e) {
        var n = GetUTCEpochNanoseconds(e);
        (t.lessThan(n, Oe) || t.greaterThan(n, be)) && ValidateEpochNanoseconds(n);
    }
    function AssertISODateTimeWithinLimits(e) {
        GetUTCEpochNanoseconds(e);
    }
    function ValidateEpochNanoseconds(e) {
        if (t.lessThan(e, _e) || t.greaterThan(e, Ce)) throw new RangeError("date/time value is outside of supported range");
    }
    function RejectYearMonthRange(e) {
        var t = e.year, n = e.month;
        RejectToRange(t, Fe, ke), t === Fe ? RejectToRange(n, 4, 12) : t === ke && RejectToRange(n, 1, 9);
    }
    function RejectDuration(e, t, n, r, a, o, i, u, s, l) {
        for(var c = 0, d = [
            e,
            t,
            n,
            r,
            a,
            o,
            i,
            u,
            s,
            l
        ], m = 0; m < d.length; m++){
            var h = d[m];
            if (h === 1 / 0 || h === -1 / 0) throw new RangeError("infinite values not allowed as duration fields");
            if (0 !== h) {
                var f = h < 0 ? -1 : 1;
                if (0 !== c && f !== c) throw new RangeError("mixed-sign values not allowed as duration fields");
                c = f;
            }
        }
        if (Math.abs(e) >= Math.pow(2, 32) || Math.abs(t) >= Math.pow(2, 32) || Math.abs(n) >= Math.pow(2, 32)) throw new RangeError("years, months, and weeks must be < 2\xb3\xb2");
        var p = TruncatingDivModByPowerOf10(u, 3), v = TruncatingDivModByPowerOf10(s, 6), D = TruncatingDivModByPowerOf10(l, 9), g = TruncatingDivModByPowerOf10(1e6 * p.mod + 1e3 * v.mod + D.mod, 9).div, y = 86400 * r + 3600 * a + 60 * o + i + p.div + v.div + D.div + g;
        if (!Number.isSafeInteger(y)) throw new RangeError("total of duration time units cannot exceed 9007199254740991.999999999 s");
    }
    function ToInternalDurationRecord(e) {
        return {
            date: {
                years: GetSlot(e, O),
                months: GetSlot(e, b),
                weeks: GetSlot(e, w),
                days: GetSlot(e, k)
            },
            time: te.fromComponents(GetSlot(e, E), GetSlot(e, B), GetSlot(e, R), GetSlot(e, G), GetSlot(e, M), GetSlot(e, A))
        };
    }
    function ToInternalDurationRecordWith24HourDays(e) {
        var t = te.fromComponents(GetSlot(e, E), GetSlot(e, B), GetSlot(e, R), GetSlot(e, G), GetSlot(e, M), GetSlot(e, A)).add24HourDays(GetSlot(e, k));
        return {
            date: {
                years: GetSlot(e, O),
                months: GetSlot(e, b),
                weeks: GetSlot(e, w),
                days: 0
            },
            time: t
        };
    }
    function ToDateDurationRecordWithoutTime(e) {
        var t = ToInternalDurationRecordWith24HourDays(e), n = Math.trunc(t.time.sec / 86400);
        return RejectDuration(t.date.years, t.date.months, t.date.weeks, n, 0, 0, 0, 0, 0, 0), _objectSpread2(_objectSpread2({}, t.date), {}, {
            days: n
        });
    }
    function TemporalDurationFromInternal(e, t) {
        var n = e.time.sign(), r = e.time.abs().subsec, a = 0, o = 0, i = e.time.abs().sec, u = 0, s = 0, l = 0;
        switch(t){
            case "year":
            case "month":
            case "week":
            case "day":
                a = Math.trunc(r / 1e3), r %= 1e3, o = Math.trunc(a / 1e3), a %= 1e3, i += Math.trunc(o / 1e3), o %= 1e3, u = Math.trunc(i / 60), i %= 60, s = Math.trunc(u / 60), u %= 60, l = Math.trunc(s / 24), s %= 24;
                break;
            case "hour":
                a = Math.trunc(r / 1e3), r %= 1e3, o = Math.trunc(a / 1e3), a %= 1e3, i += Math.trunc(o / 1e3), o %= 1e3, u = Math.trunc(i / 60), i %= 60, s = Math.trunc(u / 60), u %= 60;
                break;
            case "minute":
                a = Math.trunc(r / 1e3), r %= 1e3, o = Math.trunc(a / 1e3), a %= 1e3, i += Math.trunc(o / 1e3), o %= 1e3, u = Math.trunc(i / 60), i %= 60;
                break;
            case "second":
                a = Math.trunc(r / 1e3), r %= 1e3, o = Math.trunc(a / 1e3), a %= 1e3, i += Math.trunc(o / 1e3), o %= 1e3;
                break;
            case "millisecond":
                a = Math.trunc(r / 1e3), r %= 1e3, o = FMAPowerOf10(i, 3, Math.trunc(a / 1e3)), a %= 1e3, i = 0;
                break;
            case "microsecond":
                a = FMAPowerOf10(i, 6, Math.trunc(r / 1e3)), r %= 1e3, i = 0;
                break;
            case "nanosecond":
                r = FMAPowerOf10(i, 9, r), i = 0;
        }
        return new (GetIntrinsic("%Temporal.Duration%"))(e.date.years, e.date.months, e.date.weeks, e.date.days + n * l, n * s, n * u, n * i, n * o, n * a, n * r);
    }
    function CombineDateAndTimeDuration(e, t) {
        return DateDurationSign(e), t.sign(), {
            date: e,
            time: t
        };
    }
    function ISODateToEpochDays(e, t, n) {
        return GetUTCEpochMilliseconds({
            isoDate: {
                year: e,
                month: t + 1,
                day: n
            },
            time: {
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0
            }
        }) / ye;
    }
    function CheckISODaysRange(e) {
        var t = e.year, n = e.month, r = e.day;
        if (Math.abs(ISODateToEpochDays(t, n - 1, r)) > 1e8) throw new RangeError("date/time value is outside the supported range");
    }
    function DifferenceTime(e, t) {
        var n = t.hour - e.hour, r = t.minute - e.minute, a = t.second - e.second, o = t.millisecond - e.millisecond, i = t.microsecond - e.microsecond, u = t.nanosecond - e.nanosecond;
        return te.fromComponents(n, r, a, o, i, u);
    }
    function DifferenceInstant(e, t, n, r, a) {
        var o = te.fromEpochNsDiff(t, e);
        return CombineDateAndTimeDuration({
            years: 0,
            months: 0,
            weeks: 0,
            days: 0
        }, o = RoundTimeDuration(o, n, r, a));
    }
    function DifferenceISODateTime(e, t, n, r) {
        AssertISODateTimeWithinLimits(e), AssertISODateTimeWithinLimits(t);
        var a = DifferenceTime(e.time, t.time), o = a.sign(), i = CompareISODate(e.isoDate, t.isoDate), u = t.isoDate;
        i === o && (u = BalanceISODate(u.year, u.month, u.day + o), a = a.add24HourDays(-o));
        var s = LargerOfTwoTemporalUnits("day", r), l = CalendarDateUntil(n, e.isoDate, u, s);
        return r !== s && (a = a.add24HourDays(l.days), l.days = 0), CombineDateAndTimeDuration(l, a);
    }
    function DifferenceZonedDateTime(e, n, r, o, i) {
        var u = t.subtract(n, e);
        if (t.equal(u, a)) return {
            date: {
                years: 0,
                months: 0,
                weeks: 0,
                days: 0
            },
            time: te.ZERO
        };
        var s, l = t.lessThan(u, a) ? -1 : 1, c = GetISODateTimeFor(r, e), d = GetISODateTimeFor(r, n), m = 0, h = 1 === l ? 2 : 1, f = DifferenceTime(c.time, d.time);
        for(f.sign() === -l && m++; m <= h; m++){
            var p = GetEpochNanosecondsFor(r, s = CombineISODateAndTimeRecord(BalanceISODate(d.isoDate.year, d.isoDate.month, d.isoDate.day - m * l), c.time), "compatible");
            if ((f = te.fromEpochNsDiff(n, p)).sign() !== -l) break;
        }
        var v = LargerOfTwoTemporalUnits("day", i);
        return CombineDateAndTimeDuration(CalendarDateUntil(o, c.isoDate, s.isoDate, v), f);
    }
    function NudgeToCalendarUnit(e, n, r, a, o, i, u, s, l) {
        var c, d, m, h, f = n;
        switch(s){
            case "year":
                var p = RoundNumberToIncrement(f.date.years, u, "trunc");
                d = p + u * e, h = _objectSpread2(_objectSpread2({}, m = {
                    years: c = p,
                    months: 0,
                    weeks: 0,
                    days: 0
                }), {}, {
                    years: d
                });
                break;
            case "month":
                var v = RoundNumberToIncrement(f.date.months, u, "trunc");
                c = v, d = v + u * e, m = AdjustDateDurationRecord(f.date, 0, 0, c), h = AdjustDateDurationRecord(f.date, 0, 0, d);
                break;
            case "week":
                var D = AdjustDateDurationRecord(f.date, 0, 0), g = CalendarDateAdd(i, a.isoDate, D, "constrain"), y = CalendarDateUntil(i, g, BalanceISODate(g.year, g.month, g.day + f.date.days), "week"), T = RoundNumberToIncrement(f.date.weeks + y.weeks, u, "trunc");
                c = T, d = T + u * e, m = AdjustDateDurationRecord(f.date, 0, c), h = AdjustDateDurationRecord(f.date, 0, d);
                break;
            case "day":
                var S = RoundNumberToIncrement(f.date.days, u, "trunc");
                c = S, d = S + u * e, m = AdjustDateDurationRecord(f.date, c), h = AdjustDateDurationRecord(f.date, d);
        }
        var I, C, _ = CalendarDateAdd(i, a.isoDate, m, "constrain"), O = CalendarDateAdd(i, a.isoDate, h, "constrain"), b = CombineISODateAndTimeRecord(_, a.time), w = CombineISODateAndTimeRecord(O, a.time);
        o ? (I = GetEpochNanosecondsFor(o, b, "compatible"), C = GetEpochNanosecondsFor(o, w, "compatible")) : (I = GetUTCEpochNanoseconds(b), C = GetUTCEpochNanoseconds(w));
        var k = te.fromEpochNsDiff(r, I), E = te.fromEpochNsDiff(C, I), B = GetUnsignedRoundingMode(l, e < 0 ? "negative" : "positive"), R = k.add(k).abs().subtract(E.abs()).sign(), G = Math.abs(c) / u % 2 == 0, M = k.isZero() ? Math.abs(c) : k.cmp(E) ? ApplyUnsignedRoundingMode(Math.abs(c), Math.abs(d), R, G, B) : Math.abs(d), A = new te(t.add(t.multiply(E.totalNs, t.BigInt(c)), t.multiply(k.totalNs, t.BigInt(u * e)))).fdiv(E.totalNs), P = M === Math.abs(d);
        return {
            nudgeResult: {
                duration: f = {
                    date: P ? h : m,
                    time: te.ZERO
                },
                nudgedEpochNs: P ? C : I,
                didExpandCalendarUnit: P
            },
            total: A
        };
    }
    function RoundRelativeDuration(e, n, r, a, o, i, u, s, l) {
        var c, d = e, m = IsCalendarUnit(s) || a && "day" === s, h = InternalDurationSign(d) < 0 ? -1 : 1;
        return c = m ? NudgeToCalendarUnit(h, d, n, r, a, o, u, s, l).nudgeResult : a ? function NudgeToZonedTime(e, n, r, a, o, i, u, s) {
            var l = n, c = CalendarDateAdd(o, r.isoDate, l.date, "constrain"), d = CombineISODateAndTimeRecord(c, r.time), m = CombineISODateAndTimeRecord(BalanceISODate(c.year, c.month, c.day + e), r.time), h = GetEpochNanosecondsFor(a, d, "compatible"), f = GetEpochNanosecondsFor(a, m, "compatible"), p = te.fromEpochNsDiff(f, h);
            if (p.sign() !== e) throw new RangeError("time zone returned inconsistent Instants");
            var v, D, g = t.BigInt(Je[u] * i), y = l.time.round(g, s), T = y.subtract(p), S = T.sign() !== -e;
            return S ? (v = e, D = (y = T.round(g, s)).addToEpochNs(f)) : (v = 0, D = y.addToEpochNs(h)), {
                duration: CombineDateAndTimeDuration(AdjustDateDurationRecord(l.date, l.date.days + v), y),
                nudgedEpochNs: D,
                didExpandCalendarUnit: S
            };
        }(h, d, r, a, o, u, s, l) : function NudgeToDayOrTime(e, n, r, a, o, i) {
            var u = e, s = u.time.add24HourDays(u.date.days), l = s.round(t.BigInt(a * Je[o]), i), c = l.subtract(s), d = s.divmod(Te).quotient, m = l.divmod(Te).quotient, h = Math.sign(m - d) === s.sign(), f = c.addToEpochNs(n), p = 0, v = l;
            return "date" === TemporalUnitCategory(r) && (p = m, v = l.add(te.fromComponents(24 * -m, 0, 0, 0, 0, 0))), {
                duration: {
                    date: AdjustDateDurationRecord(u.date, p),
                    time: v
                },
                nudgedEpochNs: f,
                didExpandCalendarUnit: h
            };
        }(d, n, i, u, s, l), d = c.duration, c.didExpandCalendarUnit && "week" !== s && (d = function BubbleRelativeDuration(e, t, n, r, a, o, i, u) {
            var s = t;
            if (u === i) return s;
            for(var l = Ye.indexOf(i), c = Ye.indexOf(u) - 1; c >= l; c--){
                var d = Ye[c];
                if ("week" !== d || "week" === i) {
                    var m = void 0;
                    switch(d){
                        case "year":
                            m = {
                                years: s.date.years + e,
                                months: 0,
                                weeks: 0,
                                days: 0
                            };
                            break;
                        case "month":
                            var h = s.date.months + e;
                            m = AdjustDateDurationRecord(s.date, 0, 0, h);
                            break;
                        case "week":
                            var f = s.date.weeks + e;
                            m = AdjustDateDurationRecord(s.date, 0, f);
                    }
                    var p = CombineISODateAndTimeRecord(CalendarDateAdd(o, r.isoDate, m, "constrain"), r.time);
                    if (compare(n, a ? GetEpochNanosecondsFor(a, p, "compatible") : GetUTCEpochNanoseconds(p)) === -e) break;
                    s = {
                        date: m,
                        time: te.ZERO
                    };
                }
            }
            return s;
        }(h, d, c.nudgedEpochNs, r, a, o, i, LargerOfTwoTemporalUnits(s, "day"))), d;
    }
    function TotalRelativeDuration(e, t, n, r, a, o) {
        return IsCalendarUnit(o) || r && "day" === o ? NudgeToCalendarUnit(InternalDurationSign(e) < 0 ? -1 : 1, e, t, n, r, a, 1, o, "trunc").total : TotalTimeDuration(e.time.add24HourDays(e.date.days), o);
    }
    function DifferencePlainDateTimeWithRounding(e, t, n, r, a, o, i) {
        if (0 == CompareISODateTime(e, t)) return {
            date: {
                years: 0,
                months: 0,
                weeks: 0,
                days: 0
            },
            time: te.ZERO
        };
        RejectDateTimeRange(e), RejectDateTimeRange(t);
        var u = DifferenceISODateTime(e, t, n, r);
        return "nanosecond" === o && 1 === a ? u : RoundRelativeDuration(u, GetUTCEpochNanoseconds(t), e, null, n, r, a, o, i);
    }
    function DifferenceZonedDateTimeWithRounding(e, t, n, r, a, o, i, u) {
        if ("time" === TemporalUnitCategory(a)) return DifferenceInstant(e, t, o, i, u);
        var s = DifferenceZonedDateTime(e, t, n, r, a);
        return "nanosecond" === i && 1 === o ? s : RoundRelativeDuration(s, t, GetISODateTimeFor(n, e), n, r, a, o, i, u);
    }
    function GetDifferenceSettings(e, t, n, r, a, o) {
        var i = Pe.reduce(function(e, t) {
            var a = t[0], o = t[1], i = t[2];
            return "datetime" !== n && i !== n || r.includes(o) || e.push(o, a), e;
        }, []), u = GetTemporalUnitValuedOption(t, "largestUnit", n, "auto");
        if (r.includes(u)) throw new RangeError("largestUnit must be one of ".concat(i.join(", "), ", not ").concat(u));
        var s = GetTemporalRoundingIncrementOption(t), l = GetRoundingModeOption(t, "trunc");
        "since" === e && (l = function NegateRoundingMode(e) {
            switch(e){
                case "ceil":
                    return "floor";
                case "floor":
                    return "ceil";
                case "halfCeil":
                    return "halfFloor";
                case "halfFloor":
                    return "halfCeil";
                default:
                    return e;
            }
        }(l));
        var c = GetTemporalUnitValuedOption(t, "smallestUnit", n, a);
        if (r.includes(c)) throw new RangeError("smallestUnit must be one of ".concat(i.join(", "), ", not ").concat(c));
        var d = LargerOfTwoTemporalUnits(o, c);
        if ("auto" === u && (u = d), LargerOfTwoTemporalUnits(u, c) !== u) throw new RangeError("largestUnit ".concat(u, " cannot be smaller than smallestUnit ").concat(c));
        var m = {
            hour: 24,
            minute: 60,
            second: 60,
            millisecond: 1e3,
            microsecond: 1e3,
            nanosecond: 1e3
        }[c];
        return void 0 !== m && ValidateTemporalRoundingIncrement(s, m, !1), {
            largestUnit: u,
            roundingIncrement: s,
            roundingMode: l,
            smallestUnit: c
        };
    }
    function DifferenceTemporalInstant(e, t, n, r) {
        var a = ToTemporalInstant(n), o = GetDifferenceSettings(e, GetOptionsObject(r), "time", [], "nanosecond", "second"), i = TemporalDurationFromInternal(DifferenceInstant(GetSlot(t, v), GetSlot(a, v), o.roundingIncrement, o.smallestUnit, o.roundingMode), o.largestUnit);
        return "since" === e && (i = CreateNegatedTemporalDuration(i)), i;
    }
    function DifferenceTemporalPlainDate(e, t, n, r) {
        var a = ToTemporalDate(n), o = GetSlot(t, T), i = GetSlot(a, T);
        if (!CalendarEquals(o, i)) throw new RangeError("cannot compute difference between dates of ".concat(o, " and ").concat(i, " calendars"));
        var u = GetDifferenceSettings(e, GetOptionsObject(r), "date", [], "day", "day"), s = GetIntrinsic("%Temporal.Duration%"), l = GetSlot(t, D), c = GetSlot(a, D);
        if (0 === CompareISODate(l, c)) return new s;
        var d = {
            date: CalendarDateUntil(o, l, c, u.largestUnit),
            time: te.ZERO
        };
        if ("day" !== u.smallestUnit || 1 !== u.roundingIncrement) {
            var m = CombineISODateAndTimeRecord(l, {
                deltaDays: 0,
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
                microsecond: 0,
                nanosecond: 0
            });
            d = RoundRelativeDuration(d, GetUTCEpochNanoseconds(CombineISODateAndTimeRecord(c, {
                deltaDays: 0,
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
                microsecond: 0,
                nanosecond: 0
            })), m, null, o, u.largestUnit, u.roundingIncrement, u.smallestUnit, u.roundingMode);
        }
        var h = TemporalDurationFromInternal(d, "day");
        return "since" === e && (h = CreateNegatedTemporalDuration(h)), h;
    }
    function DifferenceTemporalPlainDateTime(e, t, n, r) {
        var a = ToTemporalDateTime(n), o = GetSlot(t, T), i = GetSlot(a, T);
        if (!CalendarEquals(o, i)) throw new RangeError("cannot compute difference between dates of ".concat(o, " and ").concat(i, " calendars"));
        var u = GetDifferenceSettings(e, GetOptionsObject(r), "datetime", [], "nanosecond", "day"), s = GetIntrinsic("%Temporal.Duration%"), l = GetSlot(t, g), c = GetSlot(a, g);
        if (0 === CompareISODateTime(l, c)) return new s;
        var d = TemporalDurationFromInternal(DifferencePlainDateTimeWithRounding(l, c, o, u.largestUnit, u.roundingIncrement, u.smallestUnit, u.roundingMode), u.largestUnit);
        return "since" === e && (d = CreateNegatedTemporalDuration(d)), d;
    }
    function DifferenceTemporalPlainTime(e, t, n, r) {
        var a = ToTemporalTime(n), o = GetDifferenceSettings(e, GetOptionsObject(r), "time", [], "nanosecond", "hour"), i = DifferenceTime(GetSlot(t, y), GetSlot(a, y)), u = TemporalDurationFromInternal(CombineDateAndTimeDuration({
            years: 0,
            months: 0,
            weeks: 0,
            days: 0
        }, i = RoundTimeDuration(i, o.roundingIncrement, o.smallestUnit, o.roundingMode)), o.largestUnit);
        return "since" === e && (u = CreateNegatedTemporalDuration(u)), u;
    }
    function DifferenceTemporalPlainYearMonth(e, t, n, r) {
        var a = ToTemporalYearMonth(n), o = GetSlot(t, T), i = GetSlot(a, T);
        if (!CalendarEquals(o, i)) throw new RangeError("cannot compute difference between months of ".concat(o, " and ").concat(i, " calendars"));
        var u = GetDifferenceSettings(e, GetOptionsObject(r), "date", [
            "week",
            "day"
        ], "month", "year"), s = GetIntrinsic("%Temporal.Duration%");
        if (0 == CompareISODate(GetSlot(t, D), GetSlot(a, D))) return new s;
        var l = ISODateToFields(o, GetSlot(t, D), "year-month");
        l.day = 1;
        var c = CalendarDateFromFields(o, l, "constrain"), d = ISODateToFields(o, GetSlot(a, D), "year-month");
        d.day = 1;
        var m = CalendarDateFromFields(o, d, "constrain"), h = {
            date: AdjustDateDurationRecord(CalendarDateUntil(o, c, m, u.largestUnit), 0, 0),
            time: te.ZERO
        };
        if ("month" !== u.smallestUnit || 1 !== u.roundingIncrement) {
            var f = CombineISODateAndTimeRecord(c, {
                deltaDays: 0,
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
                microsecond: 0,
                nanosecond: 0
            });
            h = RoundRelativeDuration(h, GetUTCEpochNanoseconds(CombineISODateAndTimeRecord(m, {
                deltaDays: 0,
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
                microsecond: 0,
                nanosecond: 0
            })), f, null, o, u.largestUnit, u.roundingIncrement, u.smallestUnit, u.roundingMode);
        }
        var p = TemporalDurationFromInternal(h, "day");
        return "since" === e && (p = CreateNegatedTemporalDuration(p)), p;
    }
    function DifferenceTemporalZonedDateTime(e, n, r, a) {
        var o = ToTemporalZonedDateTime(r), i = GetSlot(n, T), u = GetSlot(o, T);
        if (!CalendarEquals(i, u)) throw new RangeError("cannot compute difference between dates of ".concat(i, " and ").concat(u, " calendars"));
        var s, l = GetDifferenceSettings(e, GetOptionsObject(a), "datetime", [], "nanosecond", "hour"), c = GetSlot(n, v), d = GetSlot(o, v), m = GetIntrinsic("%Temporal.Duration%");
        if ("date" !== TemporalUnitCategory(l.largestUnit)) s = TemporalDurationFromInternal(DifferenceInstant(c, d, l.roundingIncrement, l.smallestUnit, l.roundingMode), l.largestUnit);
        else {
            var h = GetSlot(n, _);
            if (!TimeZoneEquals(h, GetSlot(o, _))) throw new RangeError("When calculating difference between time zones, largestUnit must be 'hours' or smaller because day lengths can vary between time zones due to DST or time zone offset changes.");
            if (t.equal(c, d)) return new m;
            s = TemporalDurationFromInternal(DifferenceZonedDateTimeWithRounding(c, d, h, i, l.largestUnit, l.roundingIncrement, l.smallestUnit, l.roundingMode), "hour");
        }
        return "since" === e && (s = CreateNegatedTemporalDuration(s)), s;
    }
    function AddTime(e, t) {
        var n = e.hour, r = e.minute, a = e.second, o = e.millisecond, i = e.microsecond, u = a, s = e.nanosecond;
        return BalanceTime(n, r, u += t.sec, o, i, s += t.subsec);
    }
    function AddInstant(e, t) {
        var n = t.addToEpochNs(e);
        return ValidateEpochNanoseconds(n), n;
    }
    function AddZonedDateTime(e, t, n, r) {
        var a = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "constrain";
        if (0 === DateDurationSign(r.date)) return AddInstant(e, r.time);
        var o = GetISODateTimeFor(t, e);
        return AddInstant(GetEpochNanosecondsFor(t, CombineISODateAndTimeRecord(CalendarDateAdd(n, o.isoDate, r.date, a), o.time), "compatible"), r.time);
    }
    function AddDurations(e, t, n) {
        var r = ToTemporalDuration(n);
        "subtract" === e && (r = CreateNegatedTemporalDuration(r));
        var a = LargerOfTwoTemporalUnits(DefaultTemporalLargestUnit(t), DefaultTemporalLargestUnit(r));
        if (IsCalendarUnit(a)) throw new RangeError("For years, months, or weeks arithmetic, use date arithmetic relative to a starting point");
        var o = ToInternalDurationRecordWith24HourDays(t), i = ToInternalDurationRecordWith24HourDays(r);
        return TemporalDurationFromInternal(CombineDateAndTimeDuration({
            years: 0,
            months: 0,
            weeks: 0,
            days: 0
        }, o.time.add(i.time)), a);
    }
    function AddDurationToInstant(e, t, n) {
        var r = ToTemporalDuration(n);
        "subtract" === e && (r = CreateNegatedTemporalDuration(r));
        var a = DefaultTemporalLargestUnit(r);
        if ("date" === TemporalUnitCategory(a)) throw new RangeError("Duration field ".concat(a, " not supported by Temporal.Instant. Try Temporal.ZonedDateTime instead."));
        var o = ToInternalDurationRecordWith24HourDays(r);
        return CreateTemporalInstant(AddInstant(GetSlot(t, v), o.time));
    }
    function AddDurationToDate(e, t, n, r) {
        var a = GetSlot(t, T), o = ToTemporalDuration(n);
        "subtract" === e && (o = CreateNegatedTemporalDuration(o));
        var i = ToDateDurationRecordWithoutTime(o), u = GetTemporalOverflowOption(GetOptionsObject(r));
        return CreateTemporalDate(CalendarDateAdd(a, GetSlot(t, D), i, u), a);
    }
    function AddDurationToDateTime(e, t, n, r) {
        var a = ToTemporalDuration(n);
        "subtract" === e && (a = CreateNegatedTemporalDuration(a));
        var o = GetTemporalOverflowOption(GetOptionsObject(r)), i = GetSlot(t, T), u = ToInternalDurationRecordWith24HourDays(a), s = GetSlot(t, g), l = AddTime(s.time, u.time), c = AdjustDateDurationRecord(u.date, l.deltaDays);
        return RejectDuration(c.years, c.months, c.weeks, c.days, 0, 0, 0, 0, 0, 0), CreateTemporalDateTime(CombineISODateAndTimeRecord(CalendarDateAdd(i, s.isoDate, c, o), l), i);
    }
    function AddDurationToTime(e, t, n) {
        var r = ToTemporalDuration(n);
        "subtract" === e && (r = CreateNegatedTemporalDuration(r));
        var a = ToInternalDurationRecordWith24HourDays(r), o = AddTime(GetSlot(t, y), a.time);
        return CreateTemporalTime(RegulateTime(o.hour, o.minute, o.second, o.millisecond, o.microsecond, o.nanosecond, "reject"));
    }
    function AddDurationToYearMonth(e, t, n, r) {
        var a = ToTemporalDuration(n);
        "subtract" === e && (a = CreateNegatedTemporalDuration(a));
        var o = GetTemporalOverflowOption(GetOptionsObject(r)), i = DurationSign(a), u = GetSlot(t, T), s = ISODateToFields(u, GetSlot(t, D), "year-month");
        s.day = 1;
        var l = CalendarDateFromFields(u, s, "constrain");
        if (i < 0) {
            var c = CalendarDateAdd(u, l, {
                months: 1
            }, "constrain");
            l = BalanceISODate(c.year, c.month, c.day - 1);
        }
        var d = ToDateDurationRecordWithoutTime(a);
        return RejectDateRange(l), CreateTemporalYearMonth(CalendarYearMonthFromFields(u, ISODateToFields(u, CalendarDateAdd(u, l, d, o), "year-month"), o), u);
    }
    function AddDurationToZonedDateTime(e, t, n, r) {
        var a = ToTemporalDuration(n);
        "subtract" === e && (a = CreateNegatedTemporalDuration(a));
        var o = GetTemporalOverflowOption(GetOptionsObject(r)), i = GetSlot(t, _), u = GetSlot(t, T), s = ToInternalDurationRecord(a);
        return CreateTemporalZonedDateTime(AddZonedDateTime(GetSlot(t, v), i, u, s, o), i, u);
    }
    function RoundNumberToIncrement(e, t, n) {
        var r = Math.trunc(e / t), a = e % t, o = e < 0 ? "negative" : "positive", i = Math.abs(r), u = i + 1, s = ComparisonResult(Math.abs(2 * a) - t), l = i % 2 == 0, c = GetUnsignedRoundingMode(n, o), d = 0 === a ? i : ApplyUnsignedRoundingMode(i, u, s, l, c);
        return t * ("positive" === o ? d : -d);
    }
    function RoundTemporalInstant(e, n, r, u) {
        var s = Je[r] * n;
        return function RoundNumberToIncrementAsIfPositive(e, n, r) {
            var u, s, l = ensureJSBI(e), c = ensureJSBI(n), d = t.divide(l, c), m = t.remainder(l, c), h = GetUnsignedRoundingMode(r, "positive");
            t.lessThan(l, a) ? (u = t.subtract(d, o), s = d) : (u = d, s = t.add(d, o));
            var f = compare(abs(t.multiply(m, i)), c) * (t.lessThan(l, a) ? -1 : 1) + 0, p = t.equal(m, a) ? d : ApplyUnsignedRoundingMode(u, s, f, isEven(u), h);
            return t.multiply(p, c);
        }(e, t.BigInt(s), u);
    }
    function RoundISODateTime(e, t, n, r) {
        AssertISODateTimeWithinLimits(e);
        var a = e.isoDate, o = a.year, i = a.month, u = a.day, s = RoundTime(e.time, t, n, r);
        return CombineISODateAndTimeRecord(BalanceISODate(o, i, u + s.deltaDays), s);
    }
    function RoundTime(e, t, n, r) {
        var a, o = e.hour, i = e.minute, u = e.second, s = e.millisecond, l = e.microsecond, c = e.nanosecond;
        switch(n){
            case "day":
            case "hour":
                a = 1e3 * (1e3 * (1e3 * (60 * (60 * o + i) + u) + s) + l) + c;
                break;
            case "minute":
                a = 1e3 * (1e3 * (1e3 * (60 * i + u) + s) + l) + c;
                break;
            case "second":
                a = 1e3 * (1e3 * (1e3 * u + s) + l) + c;
                break;
            case "millisecond":
                a = 1e3 * (1e3 * s + l) + c;
                break;
            case "microsecond":
                a = 1e3 * l + c;
                break;
            case "nanosecond":
                a = c;
        }
        var d = Je[n], m = RoundNumberToIncrement(a, d * t, r) / d;
        switch(n){
            case "day":
                return {
                    deltaDays: m,
                    hour: 0,
                    minute: 0,
                    second: 0,
                    millisecond: 0,
                    microsecond: 0,
                    nanosecond: 0
                };
            case "hour":
                return BalanceTime(m, 0, 0, 0, 0, 0);
            case "minute":
                return BalanceTime(o, m, 0, 0, 0, 0);
            case "second":
                return BalanceTime(o, i, m, 0, 0, 0);
            case "millisecond":
                return BalanceTime(o, i, u, m, 0, 0);
            case "microsecond":
                return BalanceTime(o, i, u, s, m, 0);
            case "nanosecond":
                return BalanceTime(o, i, u, s, l, m);
            default:
                throw new Error("Invalid unit ".concat(n));
        }
    }
    function RoundTimeDuration(e, n, r, a) {
        var o = Je[r];
        return e.round(t.BigInt(o * n), a);
    }
    function TotalTimeDuration(e, n) {
        var r = Je[n];
        return e.fdiv(t.BigInt(r));
    }
    function CompareISODate(e, t) {
        return e.year !== t.year ? ComparisonResult(e.year - t.year) : e.month !== t.month ? ComparisonResult(e.month - t.month) : e.day !== t.day ? ComparisonResult(e.day - t.day) : 0;
    }
    function CompareTimeRecord(e, t) {
        return e.hour !== t.hour ? ComparisonResult(e.hour - t.hour) : e.minute !== t.minute ? ComparisonResult(e.minute - t.minute) : e.second !== t.second ? ComparisonResult(e.second - t.second) : e.millisecond !== t.millisecond ? ComparisonResult(e.millisecond - t.millisecond) : e.microsecond !== t.microsecond ? ComparisonResult(e.microsecond - t.microsecond) : e.nanosecond !== t.nanosecond ? ComparisonResult(e.nanosecond - t.nanosecond) : 0;
    }
    function CompareISODateTime(e, t) {
        var n = CompareISODate(e.isoDate, t.isoDate);
        return 0 !== n ? n : CompareTimeRecord(e.time, t.time);
    }
    function ToBigIntExternal(e) {
        var t = ToBigInt(e);
        return void 0 !== globalThis.BigInt ? globalThis.BigInt(t.toString(10)) : t;
    }
    function epochNsToMs(e, n) {
        var r = divmod(ensureJSBI(e), d), a = r.quotient, o = r.remainder, i = t.toNumber(a);
        return "floor" === n && t.toNumber(o) < 0 && (i -= 1), "ceil" === n && t.toNumber(o) > 0 && (i += 1), i;
    }
    function epochMsToNs(e) {
        if (!Number.isInteger(e)) throw new RangeError("epoch milliseconds must be an integer");
        return t.multiply(t.BigInt(e), d);
    }
    function ToBigInt(e) {
        var n = e;
        if ("object" === _typeof(e)) {
            var r = e[Symbol.toPrimitive];
            r && "function" == typeof r && (n = r.call(e, "number"));
        }
        if ("number" == typeof n) throw new TypeError("cannot convert number to bigint");
        return "bigint" == typeof n ? t.BigInt(n.toString(10)) : t.BigInt(n);
    }
    var $e, Ve = ($e = t.BigInt(Date.now() % 1e6), function() {
        var e = Date.now(), n = t.BigInt(e), r = t.add(epochMsToNs(e), $e);
        return $e = t.remainder(n, d), t.greaterThan(r, Ce) ? Ce : t.lessThan(r, _e) ? _e : r;
    });
    function DefaultTimeZone() {
        return (new Intl.DateTimeFormat).resolvedOptions().timeZone;
    }
    function ComparisonResult(e) {
        return e < 0 ? -1 : e > 0 ? 1 : e;
    }
    function GetOptionsObject(e) {
        if (void 0 === e) return Object.create(null);
        if (IsObject(e) && null !== e) return e;
        throw new TypeError("Options parameter must be an object, not ".concat(null === e ? "null" : "".concat(_typeof(e))));
    }
    function CreateOnePropObject(e, t) {
        var n = Object.create(null);
        return n[e] = t, n;
    }
    function GetOption(e, t, n, r) {
        var a = e[t];
        if (void 0 !== a) {
            if (a = ToString(a), !n.includes(a)) throw new RangeError("".concat(t, " must be one of ").concat(n.join(", "), ", not ").concat(a));
            return a;
        }
        if (r === We) throw new RangeError("".concat(t, " option is required"));
        return r;
    }
    function CanonicalizeCalendar(e) {
        var t = ASCIILowercase(e);
        if (!Be.includes(ASCIILowercase(t))) throw new RangeError("invalid calendar identifier ".concat(t));
        switch(t){
            case "ethiopic-amete-alem":
                return "ethioaa";
            case "islamicc":
                return "islamic-civil";
        }
        return t;
    }
    function ASCIILowercase(e) {
        for(var t = "", n = 0; n < e.length; n++){
            var r = e.charCodeAt(n);
            t += r >= 65 && r <= 90 ? String.fromCharCode(r + 32) : String.fromCharCode(r);
        }
        return t;
    }
    function ValueOfThrows(e) {
        var t = "PlainMonthDay" === e ? "Temporal.PlainDate.compare(obj1.toPlainDate(year), obj2.toPlainDate(year))" : "Temporal.".concat(e, ".compare(obj1, obj2)");
        throw new TypeError("Do not use built-in arithmetic operators with Temporal objects. " + "When comparing, use ".concat(t, ", not obj1 > obj2. ") + "When coercing to strings, use `${obj}` or String(obj), not '' + obj. When coercing to numbers, use properties or methods of the object, not `+obj`. When concatenating with strings, use `${str}${obj}` or str.concat(obj), not str + obj. In React, coerce to a string before rendering a Temporal object.");
    }
    var Ke = new RegExp("^".concat(le.source, "$")), Xe = new RegExp("^".concat(/([+-])([01][0-9]|2[0-3])(?::?([0-5][0-9])(?::?([0-5][0-9])(?:[.,](\d{1,9}))?)?)?/.source, "$"));
    function bisect(e, t, n) {
        for(var r = t, a = n, o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : e(t), i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : e(n); a - r > 1;){
            var u = Math.trunc((r + a) / 2), s = e(u);
            s === o ? (r = u, o = s) : s === i && (a = u, i = s);
        }
        return a;
    }
    function arrayFromSet(e) {
        return _toConsumableArray(e);
    }
    function calendarDateWeekOfYear(e, t) {
        if ("gregory" === e || "iso8601" === e) {
            var n = Qe[e], r = t.year, a = n.isoToDate(t, {
                dayOfWeek: !0,
                dayOfYear: !0,
                daysInYear: !0
            }), o = a.dayOfWeek, i = a.dayOfYear, u = a.daysInYear, s = n.getFirstDayOfWeek(), l = n.getMinimalDaysInFirstWeek(), c = (o + 7 - s) % 7, d = (o - i + 7001 - s) % 7, m = Math.floor((i - 1 + d) / 7);
            if (7 - d >= l && ++m, 0 == m) m = function weekNumber(e, t, n, r) {
                var a = (r - e - n + 1) % 7;
                a < 0 && (a += 7);
                var o = Math.floor((n + a - 1) / 7);
                return 7 - a >= t && ++o, o;
            }(s, l, i + n.isoToDate(n.dateAdd(t, {
                years: -1
            }, "constrain"), {
                daysInYear: !0
            }).daysInYear, o), r--;
            else if (i >= u - 5) {
                var h = (c + u - i) % 7;
                h < 0 && (h += 7), 6 - h >= l && i + 7 - c > u && (m = 1, r++);
            }
            return {
                week: m,
                year: r
            };
        }
    }
    function ISODateSurpasses(e, t, n, r, a) {
        if (t !== a.year) {
            if (e * (t - a.year) > 0) return !0;
        } else if (n !== a.month) {
            if (e * (n - a.month) > 0) return !0;
        } else if (r !== a.day && e * (r - a.day) > 0) return !0;
        return !1;
    }
    var Qe = {};
    function nonLeapMonthCodeNumberPart(e) {
        if (!e.startsWith("M")) throw new RangeError("Invalid month code: ".concat(e, ".  Month codes must start with M."));
        var t = +e.slice(1);
        if (Number.isNaN(t)) throw new RangeError("Invalid month code: ".concat(e));
        return t;
    }
    function buildMonthCode(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = "".concat(e).padStart(2, "0"), r = t ? "L" : "";
        return "M".concat(n).concat(r);
    }
    function resolveNonLunisolarMonth(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 12, r = e.month, a = e.monthCode;
        if (void 0 === a) {
            if (void 0 === r) throw new TypeError("Either month or monthCode are required");
            "reject" === t && RejectToRange(r, 1, n), "constrain" === t && (r = ConstrainToRange(r, 1, n)), a = buildMonthCode(r);
        } else {
            var o = nonLeapMonthCodeNumberPart(a);
            if (a !== buildMonthCode(o)) throw new RangeError("Invalid month code: ".concat(a));
            if (void 0 !== r && r !== o) throw new RangeError("monthCode ".concat(a, " and month ").concat(r, " must match if both are present"));
            if ((r = o) < 1 || r > n) throw new RangeError("Invalid monthCode: ".concat(a));
        }
        return _objectSpread2(_objectSpread2({}, e), {}, {
            month: r,
            monthCode: a
        });
    }
    Qe.iso8601 = {
        resolveFields: function resolveFields(e, t) {
            if (("date" === t || "year-month" === t) && void 0 === e.year) throw new TypeError("year is required");
            if (("date" === t || "month-day" === t) && void 0 === e.day) throw new TypeError("day is required");
            Object.assign(e, resolveNonLunisolarMonth(e));
        },
        dateToISO: function dateToISO(e, t) {
            return RegulateISODate(e.year, e.month, e.day, t);
        },
        monthDayToISOReferenceDate: function monthDayToISOReferenceDate(e, t) {
            var n, r = RegulateISODate(null !== (n = e.year) && void 0 !== n ? n : 1972, e.month, e.day, t);
            return {
                month: r.month,
                day: r.day,
                year: 1972
            };
        },
        extraFields: function extraFields() {
            return [];
        },
        fieldKeysToIgnore: function fieldKeysToIgnore(e) {
            for(var t = new Set, n = 0; n < e.length; n++){
                var r = e[n];
                t.add(r), "month" === r ? t.add("monthCode") : "monthCode" === r && t.add("month");
            }
            return arrayFromSet(t);
        },
        dateAdd: function dateAdd(e, t, n) {
            var r = t.years, a = void 0 === r ? 0 : r, o = t.months, i = void 0 === o ? 0 : o, u = t.weeks, s = void 0 === u ? 0 : u, l = t.days, c = void 0 === l ? 0 : l, d = e.year, m = e.month, h = e.day, f = BalanceISOYearMonth(d += a, m += i), p = RegulateISODate(d = f.year, m = f.month, h, n);
            return d = p.year, m = p.month, h = p.day, BalanceISODate(d, m, h += c + 7 * s);
        },
        dateUntil: function dateUntil(e, t, n) {
            var r = -CompareISODate(e, t);
            if (0 === r) return {
                years: 0,
                months: 0,
                weeks: 0,
                days: 0
            };
            var a, o = 0, i = 0;
            if ("year" === n || "month" === n) {
                var u = t.year - e.year;
                for(0 !== u && (u -= r); !ISODateSurpasses(r, e.year + u, e.month, e.day, t);)o = u, u += r;
                var s = r;
                for(a = BalanceISOYearMonth(e.year + o, e.month + s); !ISODateSurpasses(r, a.year, a.month, e.day, t);)i = s, s += r, a = BalanceISOYearMonth(a.year, a.month + r);
                "month" === n && (i += 12 * o, o = 0);
            }
            var l = ConstrainISODate((a = BalanceISOYearMonth(e.year + o, e.month + i)).year, a.month, e.day), c = 0, d = ISODateToEpochDays(t.year, t.month - 1, t.day) - ISODateToEpochDays(l.year, l.month - 1, l.day);
            return "week" === n && (c = Math.trunc(d / 7), d %= 7), {
                years: o,
                months: i,
                weeks: c,
                days: d
            };
        },
        isoToDate: function isoToDate(e, t) {
            var n = e.year, r = e.month, a = e.day, o = {
                era: void 0,
                eraYear: void 0,
                year: n,
                month: r,
                day: a,
                daysInWeek: 7,
                monthsInYear: 12
            };
            if (t.monthCode && (o.monthCode = buildMonthCode(r)), t.dayOfWeek) {
                var i = r + (r < 3 ? 10 : -2), u = n - (r < 3 ? 1 : 0), s = Math.floor(u / 100), l = u - 100 * s, c = (a + Math.floor(2.6 * i - .2) + (l + Math.floor(l / 4)) + (Math.floor(s / 4) - 2 * s)) % 7;
                o.dayOfWeek = c + (c <= 0 ? 7 : 0);
            }
            if (t.dayOfYear) {
                for(var d = a, m = r - 1; m > 0; m--)d += ISODaysInMonth(n, m);
                o.dayOfYear = d;
            }
            return t.weekOfYear && (o.weekOfYear = calendarDateWeekOfYear("iso8601", {
                year: n,
                month: r,
                day: a
            })), t.daysInMonth && (o.daysInMonth = ISODaysInMonth(n, r)), (t.daysInYear || t.inLeapYear) && (o.inLeapYear = LeapYear(n), o.daysInYear = o.inLeapYear ? 366 : 365), o;
        },
        getFirstDayOfWeek: function getFirstDayOfWeek() {
            return 1;
        },
        getMinimalDaysInFirstWeek: function getMinimalDaysInFirstWeek() {
            return 4;
        }
    };
    var et = function() {
        function OneObjectCache(e) {
            if (_classCallCheck(this, OneObjectCache), this.map = new Map, this.calls = 0, this.hits = 0, this.misses = 0, void 0 !== e) {
                var t, n = 0, r = _createForOfIteratorHelper(e.map.entries());
                try {
                    for(r.s(); !(t = r.n()).done;){
                        var a, o = t.value;
                        if (++n > OneObjectCache.MAX_CACHE_ENTRIES) break;
                        (a = this.map).set.apply(a, _toConsumableArray(o));
                    }
                } catch (e) {
                    r.e(e);
                } finally{
                    r.f();
                }
            }
        }
        return _createClass(OneObjectCache, [
            {
                key: "get",
                value: function get(e) {
                    var t = this.map.get(e);
                    return t && (this.hits++, this.report()), this.calls++, t;
                }
            },
            {
                key: "set",
                value: function set(e, t) {
                    this.map.set(e, t), this.misses++, this.report();
                }
            },
            {
                key: "report",
                value: function report() {}
            },
            {
                key: "setObject",
                value: function setObject(e) {
                    if (OneObjectCache.objectMap.get(e)) throw new RangeError("object already cached");
                    OneObjectCache.objectMap.set(e, this), this.report();
                }
            }
        ], [
            {
                key: "getCacheForObject",
                value: function getCacheForObject(e) {
                    var t = OneObjectCache.objectMap.get(e);
                    return t || (t = new OneObjectCache, OneObjectCache.objectMap.set(e, t)), t;
                }
            }
        ]), OneObjectCache;
    }();
    function toUtcIsoDateString(e) {
        var t = e.isoYear, n = e.isoMonth, r = e.isoDay, a = ISOYearString(t), o = ISODateTimePartString(n), i = ISODateTimePartString(r);
        return "".concat(a, "-").concat(o, "-").concat(i, "T00:00Z");
    }
    function simpleDateDiff(e, t) {
        return {
            years: e.year - t.year,
            months: e.month - t.month,
            days: e.day - t.day
        };
    }
    et.objectMap = new WeakMap, et.MAX_CACHE_ENTRIES = 1e3;
    var tt = function() {
        function HelperBase() {
            _classCallCheck(this, HelperBase), this.eras = [], this.hasEra = !1, this.erasBeginMidYear = !1;
        }
        return _createClass(HelperBase, [
            {
                key: "getFormatter",
                value: function getFormatter() {
                    return void 0 === this.formatter && (this.formatter = new Intl.DateTimeFormat("en-US-u-ca-".concat(this.id), {
                        day: "numeric",
                        month: "numeric",
                        year: "numeric",
                        era: "short",
                        timeZone: "UTC"
                    })), this.formatter;
                }
            },
            {
                key: "getCalendarParts",
                value: function getCalendarParts(e) {
                    var t = this.getFormatter(), n = new Date(e);
                    if ("-271821-04-19T00:00Z" === e) {
                        var r = t.resolvedOptions();
                        t = new Intl.DateTimeFormat(r.locale, _objectSpread2(_objectSpread2({}, r), {}, {
                            timeZone: "Etc/GMT+1"
                        })), n = new Date("-271821-04-20T00:00Z");
                    }
                    try {
                        return t.formatToParts(n);
                    } catch (t) {
                        throw new RangeError("Invalid ISO date: ".concat(e));
                    }
                }
            },
            {
                key: "isoToCalendarDate",
                value: function isoToCalendarDate(e, t) {
                    var n = this, r = e.year, a = e.month, o = e.day, i = JSON.stringify({
                        func: "isoToCalendarDate",
                        isoYear: r,
                        isoMonth: a,
                        isoDay: o,
                        id: this.id
                    }), u = t.get(i);
                    if (u) return u;
                    for(var s = toUtcIsoDateString({
                        isoYear: r,
                        isoMonth: a,
                        isoDay: o
                    }), l = this.getCalendarParts(s), c = {}, d = 0; d < l.length; d++){
                        var m = l[d], h = m.type, f = m.value;
                        if ("year" !== h && "relatedYear" !== h || (this.hasEra ? c.eraYear = +f : c.year = +f), "month" === h) {
                            var p = /^([0-9]*)(.*?)$/.exec(f);
                            if (!p || 3 != p.length || !p[1] && !p[2]) throw new RangeError("Unexpected month: ".concat(f));
                            if (c.month = p[1] ? +p[1] : 1, c.month < 1) throw new RangeError("Invalid month ".concat(f, " from ").concat(s, "[u-ca-").concat(this.id, "]") + " (probably due to https://bugs.chromium.org/p/v8/issues/detail?id=10527)");
                            if (c.month > 13) throw new RangeError("Invalid month ".concat(f, " from ").concat(s, "[u-ca-").concat(this.id, "]") + " (probably due to https://bugs.chromium.org/p/v8/issues/detail?id=10529)");
                            p[2] && (c.monthExtra = p[2]);
                        }
                        "day" === h && (c.day = +f), this.hasEra && "era" === h && null != f && "" !== f && (c.era = f.split(" (")[0].normalize("NFD").replace(/(?:[\0-\x1F!-,\.\/:-@\[-`\{-\xA9\xAB-\xB4\xB6-\xB9\xBB-\xBF\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u036F\u0375\u0378\u0379\u037E\u0380-\u0385\u0387\u038B\u038D\u03A2\u03F6\u0482-\u0489\u0530\u0557\u0558\u055A-\u055F\u0589-\u05CF\u05EB-\u05EE\u05F3-\u061F\u064B-\u066D\u0670\u06D4\u06D6-\u06E4\u06E7-\u06ED\u06F0-\u06F9\u06FD\u06FE\u0700-\u070F\u0711\u0730-\u074C\u07A6-\u07B0\u07B2-\u07C9\u07EB-\u07F3\u07F6-\u07F9\u07FB-\u07FF\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u083F\u0859-\u085F\u086B-\u086F\u0888\u088F-\u089F\u08CA-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962-\u0970\u0981-\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA-\u09BC\u09BE-\u09CD\u09CF-\u09DB\u09DE\u09E2-\u09EF\u09F2-\u09FB\u09FD-\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A-\u0A58\u0A5D\u0A5F-\u0A71\u0A75-\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA-\u0ABC\u0ABE-\u0ACF\u0AD1-\u0ADF\u0AE2-\u0AF8\u0AFA-\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A-\u0B3C\u0B3E-\u0B5B\u0B5E\u0B62-\u0B70\u0B72-\u0B82\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BCF\u0BD1-\u0C04\u0C0D\u0C11\u0C29\u0C3A-\u0C3C\u0C3E-\u0C57\u0C5B\u0C5C\u0C5E\u0C5F\u0C62-\u0C7F\u0C81-\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA-\u0CBC\u0CBE-\u0CDC\u0CDF\u0CE2-\u0CF0\u0CF3-\u0D03\u0D0D\u0D11\u0D3B\u0D3C\u0D3E-\u0D4D\u0D4F-\u0D53\u0D57-\u0D5E\u0D62-\u0D79\u0D80-\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0E00\u0E31\u0E34-\u0E3F\u0E47-\u0E80\u0E83\u0E85\u0E8B\u0EA4\u0EA6\u0EB1\u0EB4-\u0EBC\u0EBE\u0EBF\u0EC5\u0EC7-\u0EDB\u0EE0-\u0EFF\u0F01-\u0F3F\u0F48\u0F6D-\u0F87\u0F8D-\u0FFF\u102B-\u103E\u1040-\u104F\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109F\u10C6\u10C8-\u10CC\u10CE\u10CF\u10FB\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B-\u137F\u1390-\u139F\u13F6\u13F7\u13FE-\u1400\u166D\u166E\u1680\u169B-\u169F\u16EB-\u16F0\u16F9-\u16FF\u1712-\u171E\u1732-\u173F\u1752-\u175F\u176D\u1771-\u177F\u17B4-\u17D6\u17D8-\u17DB\u17DD-\u181F\u1879-\u187F\u1885\u1886\u18A9\u18AB-\u18AF\u18F6-\u18FF\u191F-\u194F\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19FF\u1A17-\u1A1F\u1A55-\u1AA6\u1AA8-\u1B04\u1B34-\u1B44\u1B4D-\u1B82\u1BA1-\u1BAD\u1BB0-\u1BB9\u1BE6-\u1BFF\u1C24-\u1C4C\u1C50-\u1C59\u1C7E\u1C7F\u1C89-\u1C8F\u1CBB\u1CBC\u1CC0-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1CFB-\u1CFF\u1DC0-\u1DFF\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FBD\u1FBF-\u1FC1\u1FC5\u1FCD-\u1FCF\u1FD4\u1FD5\u1FDC-\u1FDF\u1FED-\u1FF1\u1FF5\u1FFD-\u2070\u2072-\u207E\u2080-\u208F\u209D-\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F-\u2182\u2185-\u2BFF\u2CE5-\u2CEA\u2CEF-\u2CF1\u2CF4-\u2CFF\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D70-\u2D7F\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF-\u2E2E\u2E30-\u3004\u3007-\u3030\u3036-\u303A\u303D-\u3040\u3097-\u309C\u30A0\u30FB\u3100-\u3104\u3130\u318F-\u319F\u31C0-\u31EF\u3200-\u33FF\u4DC0-\u4DFF\uA48D-\uA4CF\uA4FE\uA4FF\uA60D-\uA60F\uA620-\uA629\uA62C-\uA63F\uA66F-\uA67E\uA69E\uA69F\uA6E6-\uA716\uA720\uA721\uA789\uA78A\uA7CB-\uA7CF\uA7D2\uA7D4\uA7DA-\uA7F1\uA802\uA806\uA80B\uA823-\uA83F\uA874-\uA881\uA8B4-\uA8F1\uA8F8-\uA8FA\uA8FC\uA8FF-\uA909\uA926-\uA92F\uA947-\uA95F\uA97D-\uA983\uA9B3-\uA9CE\uA9D0-\uA9DF\uA9E5\uA9F0-\uA9F9\uA9FF\uAA29-\uAA3F\uAA43\uAA4C-\uAA5F\uAA77-\uAA79\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAC3-\uAADA\uAADE\uAADF\uAAEB-\uAAF1\uAAF5-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F\uAB5B\uAB6A-\uAB6F\uABE3-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uD7FF\uE000-\uF8FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB1E\uFB29\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBB2-\uFBD2\uFD3E-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFC-\uFE6F\uFE75\uFEFD-\uFF20\uFF3B-\uFF40\uFF5B-\uFF65\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFFF]|\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEFF\uDF20-\uDF2C\uDF41\uDF4A-\uDF4F\uDF76-\uDF7F\uDF9E\uDF9F\uDFC4-\uDFC7\uDFD0-\uDFFF]|\uD801[\uDC9E-\uDCAF\uDCD4-\uDCD7\uDCFC-\uDCFF\uDD28-\uDD2F\uDD64-\uDD6F\uDD7B\uDD8B\uDD93\uDD96\uDDA2\uDDB2\uDDBA\uDDBD-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDF7F\uDF86\uDFB1\uDFBB-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56-\uDC5F\uDC77-\uDC7F\uDC9F-\uDCDF\uDCF3\uDCF6-\uDCFF\uDD16-\uDD1F\uDD3A-\uDD7F\uDDB8-\uDDBD\uDDC0-\uDDFF\uDE01-\uDE0F\uDE14\uDE18\uDE36-\uDE5F\uDE7D-\uDE7F\uDE9D-\uDEBF\uDEC8\uDEE5-\uDEFF\uDF36-\uDF3F\uDF56-\uDF5F\uDF73-\uDF7F\uDF92-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCFF\uDD24-\uDE7F\uDEAA-\uDEAF\uDEB2-\uDEFF\uDF1D-\uDF26\uDF28-\uDF2F\uDF46-\uDF6F\uDF82-\uDFAF\uDFC5-\uDFDF\uDFF7-\uDFFF]|\uD804[\uDC00-\uDC02\uDC38-\uDC70\uDC73\uDC74\uDC76-\uDC82\uDCB0-\uDCCF\uDCE9-\uDD02\uDD27-\uDD43\uDD45\uDD46\uDD48-\uDD4F\uDD73-\uDD75\uDD77-\uDD82\uDDB3-\uDDC0\uDDC5-\uDDD9\uDDDB\uDDDD-\uDDFF\uDE12\uDE2C-\uDE3E\uDE41-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEA9-\uDEAF\uDEDF-\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A-\uDF3C\uDF3E-\uDF4F\uDF51-\uDF5C\uDF62-\uDFFF]|\uD805[\uDC35-\uDC46\uDC4B-\uDC5E\uDC62-\uDC7F\uDCB0-\uDCC3\uDCC6\uDCC8-\uDD7F\uDDAF-\uDDD7\uDDDC-\uDDFF\uDE30-\uDE43\uDE45-\uDE7F\uDEAB-\uDEB7\uDEB9-\uDEFF\uDF1B-\uDF3F\uDF47-\uDFFF]|\uD806[\uDC2C-\uDC9F\uDCE0-\uDCFE\uDD07\uDD08\uDD0A\uDD0B\uDD14\uDD17\uDD30-\uDD3E\uDD40\uDD42-\uDD9F\uDDA8\uDDA9\uDDD1-\uDDE0\uDDE2\uDDE4-\uDDFF\uDE01-\uDE0A\uDE33-\uDE39\uDE3B-\uDE4F\uDE51-\uDE5B\uDE8A-\uDE9C\uDE9E-\uDEAF\uDEF9-\uDFFF]|\uD807[\uDC09\uDC2F-\uDC3F\uDC41-\uDC71\uDC90-\uDCFF\uDD07\uDD0A\uDD31-\uDD45\uDD47-\uDD5F\uDD66\uDD69\uDD8A-\uDD97\uDD99-\uDEDF\uDEF3-\uDF01\uDF03\uDF11\uDF34-\uDFAF\uDFB1-\uDFFF]|\uD808[\uDF9A-\uDFFF]|\uD809[\uDC00-\uDC7F\uDD44-\uDFFF]|[\uD80A\uD80E-\uD810\uD812-\uD819\uD824-\uD82A\uD82D\uD82E\uD830-\uD834\uD836\uD83C-\uD83F\uD87B-\uD87D\uD87F\uD889-\uDBFF][\uDC00-\uDFFF]|\uD80B[\uDC00-\uDF8F\uDFF1-\uDFFF]|\uD80D[\uDC30-\uDC40\uDC47-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD81A[\uDE39-\uDE3F\uDE5F-\uDE6F\uDEBF-\uDECF\uDEEE-\uDEFF\uDF30-\uDF3F\uDF44-\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD81B[\uDC00-\uDE3F\uDE80-\uDEFF\uDF4B-\uDF4F\uDF51-\uDF92\uDFA0-\uDFDF\uDFE2\uDFE4-\uDFFF]|\uD821[\uDFF8-\uDFFF]|\uD823[\uDCD6-\uDCFF\uDD09-\uDFFF]|\uD82B[\uDC00-\uDFEF\uDFF4\uDFFC\uDFFF]|\uD82C[\uDD23-\uDD31\uDD33-\uDD4F\uDD53\uDD54\uDD56-\uDD63\uDD68-\uDD6F\uDEFC-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3\uDFCC-\uDFFF]|\uD837[\uDC00-\uDEFF\uDF1F-\uDF24\uDF2B-\uDFFF]|\uD838[\uDC00-\uDC2F\uDC6E-\uDCFF\uDD2D-\uDD36\uDD3E-\uDD4D\uDD4F-\uDE8F\uDEAE-\uDEBF\uDEEC-\uDFFF]|\uD839[\uDC00-\uDCCF\uDCEC-\uDFDF\uDFE7\uDFEC\uDFEF\uDFFF]|\uD83A[\uDCC5-\uDCFF\uDD44-\uDD4A\uDD4C-\uDFFF]|\uD83B[\uDC00-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDFFF]|\uD869[\uDEE0-\uDEFF]|\uD86D[\uDF3A-\uDF3F]|\uD86E[\uDC1E\uDC1F]|\uD873[\uDEA2-\uDEAF]|\uD87A[\uDFE1-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uD884[\uDF4B-\uDF4F]|\uD888[\uDFB0-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g, "").replace(/ /g, "-").toLowerCase());
                    }
                    if (this.hasEra && void 0 === c.eraYear) throw new RangeError("Intl.DateTimeFormat.formatToParts lacks relatedYear in ".concat(this.id, " calendar. Try Node 14+ or modern browsers."));
                    if (this.hasEra) {
                        var v = this.eras.find(function(e) {
                            return c.era === e.genericName;
                        });
                        v && (c.era = v.code);
                    }
                    if (this.reviseIntlEra) {
                        var D = this.reviseIntlEra(c, e), g = D.era, y = D.eraYear;
                        c.era = g, c.eraYear = y;
                    }
                    this.checkIcuBugs && this.checkIcuBugs(e);
                    var T = this.adjustCalendarDate(c, t, "constrain", !0);
                    if (void 0 === T.year) throw new RangeError("Missing year converting ".concat(JSON.stringify(e)));
                    if (void 0 === T.month) throw new RangeError("Missing month converting ".concat(JSON.stringify(e)));
                    if (void 0 === T.day) throw new RangeError("Missing day converting ".concat(JSON.stringify(e)));
                    return t.set(i, T), [
                        "constrain",
                        "reject"
                    ].forEach(function cacheReverse(r) {
                        var a = JSON.stringify({
                            func: "calendarToIsoDate",
                            year: T.year,
                            month: T.month,
                            day: T.day,
                            overflow: r,
                            id: n.id
                        });
                        t.set(a, e);
                    }), T;
                }
            },
            {
                key: "validateCalendarDate",
                value: function validateCalendarDate(e) {
                    var t = e.month, n = e.year, r = e.day, a = e.eraYear, o = e.monthCode;
                    if (void 0 !== e.monthExtra) throw new RangeError("Unexpected `monthExtra` value");
                    if (void 0 === n && void 0 === a) throw new TypeError("year or eraYear is required");
                    if (void 0 === t && void 0 === o) throw new TypeError("month or monthCode is required");
                    if (void 0 === r) throw new RangeError("Missing day");
                    if (void 0 !== o) {
                        if ("string" != typeof o) throw new RangeError("monthCode must be a string, not ".concat(_typeof(o)));
                        if (!/^M([01]?\d)(L?)$/.test(o)) throw new RangeError("Invalid monthCode: ".concat(o));
                    }
                    if (this.hasEra && void 0 === e.era != (void 0 === e.eraYear)) throw new TypeError("properties era and eraYear must be provided together");
                }
            },
            {
                key: "adjustCalendarDate",
                value: function adjustCalendarDate(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "constrain";
                    if ("lunisolar" === this.calendarType) throw new RangeError("Override required for lunisolar calendars");
                    var r = e;
                    this.validateCalendarDate(r);
                    var a = this.monthsInYear(r, t), o = r.month, i = r.monthCode, u = resolveNonLunisolarMonth(r, n, a);
                    return o = u.month, i = u.monthCode, _objectSpread2(_objectSpread2({}, r), {}, {
                        month: o,
                        monthCode: i
                    });
                }
            },
            {
                key: "regulateMonthDayNaive",
                value: function regulateMonthDayNaive(e, t, n) {
                    var r = this.monthsInYear(e, n), a = e.month, o = e.day;
                    return "reject" === t ? (RejectToRange(a, 1, r), RejectToRange(o, 1, this.maximumMonthLength(e))) : (a = ConstrainToRange(a, 1, r), o = ConstrainToRange(o, 1, this.maximumMonthLength(_objectSpread2(_objectSpread2({}, e), {}, {
                        month: a
                    })))), _objectSpread2(_objectSpread2({}, e), {}, {
                        month: a,
                        day: o
                    });
                }
            },
            {
                key: "calendarToIsoDate",
                value: function calendarToIsoDate(e) {
                    var t, n = this, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "constrain", a = arguments.length > 2 ? arguments[2] : void 0, o = e, i = this.adjustCalendarDate(e, a, r, !1), u = i = this.regulateMonthDayNaive(i, r, a), s = u.year, l = u.month, c = u.day, d = JSON.stringify({
                        func: "calendarToIsoDate",
                        year: s,
                        month: l,
                        day: c,
                        overflow: r,
                        id: this.id
                    }), m = a.get(d);
                    if (m) return m;
                    if (void 0 !== o.year && void 0 !== o.month && void 0 !== o.day && (o.year !== i.year || o.month !== i.month || o.day !== i.day) && (t = JSON.stringify({
                        func: "calendarToIsoDate",
                        year: o.year,
                        month: o.month,
                        day: o.day,
                        overflow: r,
                        id: this.id
                    }), m = a.get(t))) return m;
                    var h = this.estimateIsoDate({
                        year: s,
                        month: l,
                        day: c
                    }), f = function calculateSameMonthResult(e) {
                        var t = n.addDaysIso(h, e);
                        if (i.day > n.minimumMonthLength(i)) for(var o = n.isoToCalendarDate(t, a); o.month !== l || o.year !== s;){
                            if ("reject" === r) throw new RangeError("day ".concat(c, " does not exist in month ").concat(l, " of year ").concat(s));
                            t = n.addDaysIso(t, -1), o = n.isoToCalendarDate(t, a);
                        }
                        return t;
                    }, p = 0, v = this.isoToCalendarDate(h, a), D = simpleDateDiff(i, v);
                    if (0 !== D.years || 0 !== D.months || 0 !== D.days) {
                        var g = 365 * D.years + 30 * D.months + D.days;
                        h = this.addDaysIso(h, g), v = this.isoToCalendarDate(h, a), 0 === (D = simpleDateDiff(i, v)).years && 0 === D.months ? h = f(D.days) : p = this.compareCalendarDates(i, v);
                    }
                    for(var y = 8; p;){
                        h = this.addDaysIso(h, p * y);
                        var T = v;
                        v = this.isoToCalendarDate(h, a);
                        var S = p;
                        if (p = this.compareCalendarDates(i, v)) {
                            if (0 === (D = simpleDateDiff(i, v)).years && 0 === D.months) h = f(D.days), p = 0;
                            else if (S && p !== S) {
                                if (y > 1) y /= 2;
                                else {
                                    if ("reject" === r) throw new RangeError("Can't find ISO date from calendar date: ".concat(JSON.stringify(_objectSpread2({}, o))));
                                    this.compareCalendarDates(v, T) > 0 && (h = this.addDaysIso(h, -1)), p = 0;
                                }
                            }
                        }
                    }
                    if (a.set(d, h), t && a.set(t, h), void 0 === i.year || void 0 === i.month || void 0 === i.day || void 0 === i.monthCode || this.hasEra && (void 0 === i.era || void 0 === i.eraYear)) throw new RangeError("Unexpected missing property");
                    return h;
                }
            },
            {
                key: "compareCalendarDates",
                value: function compareCalendarDates(e, t) {
                    return e.year !== t.year ? ComparisonResult(e.year - t.year) : e.month !== t.month ? ComparisonResult(e.month - t.month) : e.day !== t.day ? ComparisonResult(e.day - t.day) : 0;
                }
            },
            {
                key: "regulateDate",
                value: function regulateDate(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "constrain", n = arguments.length > 2 ? arguments[2] : void 0, r = this.calendarToIsoDate(e, t, n);
                    return this.isoToCalendarDate(r, n);
                }
            },
            {
                key: "addDaysIso",
                value: function addDaysIso(e, t) {
                    return BalanceISODate(e.year, e.month, e.day + t);
                }
            },
            {
                key: "addDaysCalendar",
                value: function addDaysCalendar(e, t, n) {
                    var r = this.calendarToIsoDate(e, "constrain", n), a = this.addDaysIso(r, t);
                    return this.isoToCalendarDate(a, n);
                }
            },
            {
                key: "addMonthsCalendar",
                value: function addMonthsCalendar(e, t, n, r) {
                    for(var a = e, o = a.day, i = 0, u = Math.abs(t); i < u; i++){
                        var s = a.month, l = a, c = t < 0 ? -Math.max(o, this.daysInPreviousMonth(a, r)) : this.daysInMonth(a, r), d = this.calendarToIsoDate(a, "constrain", r), m = this.addDaysIso(d, c);
                        if (a = this.isoToCalendarDate(m, r), t > 0) for(var h = this.monthsInYear(l, r); a.month - 1 != s % h;)m = this.addDaysIso(m, -1), a = this.isoToCalendarDate(m, r);
                        a.day !== o && (a = this.regulateDate(_objectSpread2(_objectSpread2({}, a), {}, {
                            day: o
                        }), "constrain", r));
                    }
                    if ("reject" === n && a.day !== o) throw new RangeError("Day ".concat(o, " does not exist in resulting calendar month"));
                    return a;
                }
            },
            {
                key: "addCalendar",
                value: function addCalendar(e, t, n, r) {
                    var a = t.years, o = void 0 === a ? 0 : a, i = t.months, u = void 0 === i ? 0 : i, s = t.weeks, l = void 0 === s ? 0 : s, c = t.days, d = void 0 === c ? 0 : c, m = e.year, h = e.day, f = e.monthCode, p = this.adjustCalendarDate({
                        year: m + o,
                        monthCode: f,
                        day: h
                    }, r), v = this.addMonthsCalendar(p, u, n, r), D = d + 7 * l;
                    return this.addDaysCalendar(v, D, r);
                }
            },
            {
                key: "untilCalendar",
                value: function untilCalendar(e, t, n, r) {
                    var a = 0, o = 0, i = 0, u = 0;
                    switch(n){
                        case "day":
                            a = this.calendarDaysUntil(e, t, r);
                            break;
                        case "week":
                            var s = this.calendarDaysUntil(e, t, r);
                            o = (s - (a = s % 7)) / 7;
                            break;
                        case "month":
                        case "year":
                            var l = this.compareCalendarDates(t, e);
                            if (!l) return {
                                years: 0,
                                months: 0,
                                weeks: 0,
                                days: 0
                            };
                            var c = t.year - e.year, d = t.day - e.day;
                            if ("year" === n && c) {
                                var m = 0;
                                t.monthCode > e.monthCode && (m = 1), t.monthCode < e.monthCode && (m = -1), m || (m = Math.sign(d)), u = m * l < 0 ? c - l : c;
                            }
                            var h, f = u ? this.addCalendar(e, {
                                years: u
                            }, "constrain", r) : e;
                            do i += l, h = f, (f = this.addMonthsCalendar(h, l, "constrain", r)).day !== e.day && (f = this.regulateDate(_objectSpread2(_objectSpread2({}, f), {}, {
                                day: e.day
                            }), "constrain", r));
                            while (this.compareCalendarDates(t, f) * l >= 0);
                            i -= l, a = this.calendarDaysUntil(h, t, r);
                    }
                    return {
                        years: u,
                        months: i,
                        weeks: o,
                        days: a
                    };
                }
            },
            {
                key: "daysInMonth",
                value: function daysInMonth(e, t) {
                    var n = e.day, r = this.maximumMonthLength(e), a = this.minimumMonthLength(e);
                    if (a === r) return a;
                    var o = n <= r - a ? r : a, i = this.calendarToIsoDate(e, "constrain", t), u = this.addDaysIso(i, o), s = this.isoToCalendarDate(u, t), l = this.addDaysIso(u, -s.day);
                    return this.isoToCalendarDate(l, t).day;
                }
            },
            {
                key: "daysInPreviousMonth",
                value: function daysInPreviousMonth(e, t) {
                    var n = e.day, r = e.month, a = e.year, o = {
                        year: r > 1 ? a : a - 1,
                        month: r,
                        day: 1
                    }, i = r > 1 ? r - 1 : this.monthsInYear(o, t);
                    o = _objectSpread2(_objectSpread2({}, o), {}, {
                        month: i
                    });
                    var u = this.minimumMonthLength(o), s = this.maximumMonthLength(o);
                    if (u === s) return s;
                    var l = this.calendarToIsoDate(e, "constrain", t), c = this.addDaysIso(l, -n);
                    return this.isoToCalendarDate(c, t).day;
                }
            },
            {
                key: "startOfCalendarYear",
                value: function startOfCalendarYear(e) {
                    return {
                        year: e.year,
                        month: 1,
                        monthCode: "M01",
                        day: 1
                    };
                }
            },
            {
                key: "startOfCalendarMonth",
                value: function startOfCalendarMonth(e) {
                    return {
                        year: e.year,
                        month: e.month,
                        day: 1
                    };
                }
            },
            {
                key: "calendarDaysUntil",
                value: function calendarDaysUntil(e, t, n) {
                    var r = this.calendarToIsoDate(e, "constrain", n), a = this.calendarToIsoDate(t, "constrain", n);
                    return ISODateToEpochDays(a.year, a.month - 1, a.day) - ISODateToEpochDays(r.year, r.month - 1, r.day);
                }
            },
            {
                key: "monthDaySearchStartYear",
                value: function monthDaySearchStartYear(e, t) {
                    return 1972;
                }
            },
            {
                key: "monthDayFromFields",
                value: function monthDayFromFields(e, t, n) {
                    var r, a, o, i, u, s = e.era, l = e.eraYear, c = e.year, d = e.month, m = e.monthCode, h = e.day;
                    if (void 0 !== d && void 0 === c && (!this.hasEra || void 0 === s || void 0 === l)) throw new TypeError("when month is present, year (or era and eraYear) are required");
                    if (void 0 === m || void 0 !== c || this.hasEra && void 0 !== l) {
                        var f = this.isoToCalendarDate(this.calendarToIsoDate(e, t, n), n);
                        m = f.monthCode, h = f.day;
                    }
                    for(var p = {
                        year: this.monthDaySearchStartYear(m, h),
                        month: 12,
                        day: 31
                    }, v = this.isoToCalendarDate(p, n), D = v.monthCode > m || v.monthCode === m && v.day >= h ? v.year : v.year - 1, g = 0; g < 20; g++){
                        var y = this.adjustCalendarDate({
                            day: h,
                            monthCode: m,
                            year: D - g
                        }, n), T = this.calendarToIsoDate(y, "constrain", n), S = this.isoToCalendarDate(T, n);
                        if (r = T.year, a = T.month, o = T.day, S.monthCode === m && S.day === h) return {
                            month: a,
                            day: o,
                            year: r
                        };
                        if ("constrain" === t) {
                            var I = this.maxLengthOfMonthCodeInAnyYear(S.monthCode);
                            if (S.monthCode === m && S.day === I && h > I) return {
                                month: a,
                                day: o,
                                year: r
                            };
                            (void 0 === i || S.monthCode === i.monthCode && S.day > i.day) && (i = S, u = T);
                        }
                    }
                    if ("constrain" === t && void 0 !== u) return u;
                    throw new RangeError("No recent ".concat(this.id, " year with monthCode ").concat(m, " and day ").concat(h));
                }
            },
            {
                key: "getFirstDayOfWeek",
                value: function getFirstDayOfWeek() {}
            },
            {
                key: "getMinimalDaysInFirstWeek",
                value: function getMinimalDaysInFirstWeek() {}
            }
        ]), HelperBase;
    }(), nt = function(e) {
        _inherits(HebrewHelper, e);
        var t = _createSuper(HebrewHelper);
        function HebrewHelper() {
            var e;
            return _classCallCheck(this, HebrewHelper), (e = t.apply(this, arguments)).id = "hebrew", e.calendarType = "lunisolar", e.months = {
                Tishri: {
                    leap: 1,
                    regular: 1,
                    monthCode: "M01",
                    days: 30
                },
                Heshvan: {
                    leap: 2,
                    regular: 2,
                    monthCode: "M02",
                    days: {
                        min: 29,
                        max: 30
                    }
                },
                Kislev: {
                    leap: 3,
                    regular: 3,
                    monthCode: "M03",
                    days: {
                        min: 29,
                        max: 30
                    }
                },
                Tevet: {
                    leap: 4,
                    regular: 4,
                    monthCode: "M04",
                    days: 29
                },
                Shevat: {
                    leap: 5,
                    regular: 5,
                    monthCode: "M05",
                    days: 30
                },
                Adar: {
                    leap: void 0,
                    regular: 6,
                    monthCode: "M06",
                    days: 29
                },
                "Adar I": {
                    leap: 6,
                    regular: void 0,
                    monthCode: "M05L",
                    days: 30
                },
                "Adar II": {
                    leap: 7,
                    regular: void 0,
                    monthCode: "M06",
                    days: 29
                },
                Nisan: {
                    leap: 8,
                    regular: 7,
                    monthCode: "M07",
                    days: 30
                },
                Iyar: {
                    leap: 9,
                    regular: 8,
                    monthCode: "M08",
                    days: 29
                },
                Sivan: {
                    leap: 10,
                    regular: 9,
                    monthCode: "M09",
                    days: 30
                },
                Tamuz: {
                    leap: 11,
                    regular: 10,
                    monthCode: "M10",
                    days: 29
                },
                Av: {
                    leap: 12,
                    regular: 11,
                    monthCode: "M11",
                    days: 30
                },
                Elul: {
                    leap: 13,
                    regular: 12,
                    monthCode: "M12",
                    days: 29
                }
            }, e;
        }
        return _createClass(HebrewHelper, [
            {
                key: "inLeapYear",
                value: function inLeapYear(e) {
                    return (7 * e.year + 1) % 19 < 7;
                }
            },
            {
                key: "monthsInYear",
                value: function monthsInYear(e) {
                    return this.inLeapYear(e) ? 13 : 12;
                }
            },
            {
                key: "minimumMonthLength",
                value: function minimumMonthLength(e) {
                    return this.minMaxMonthLength(e, "min");
                }
            },
            {
                key: "maximumMonthLength",
                value: function maximumMonthLength(e) {
                    return this.minMaxMonthLength(e, "max");
                }
            },
            {
                key: "minMaxMonthLength",
                value: function minMaxMonthLength(e, t) {
                    var n = e.month, r = e.year, a = this.getMonthCode(r, n), o = Object.entries(this.months).find(function(e) {
                        return e[1].monthCode === a;
                    });
                    if (void 0 === o) throw new RangeError("unmatched Hebrew month: ".concat(n));
                    var i = o[1].days;
                    return "number" == typeof i ? i : i[t];
                }
            },
            {
                key: "maxLengthOfMonthCodeInAnyYear",
                value: function maxLengthOfMonthCodeInAnyYear(e) {
                    return [
                        "M04",
                        "M06",
                        "M08",
                        "M10",
                        "M12"
                    ].includes(e) ? 29 : 30;
                }
            },
            {
                key: "estimateIsoDate",
                value: function estimateIsoDate(e) {
                    return {
                        year: e.year - 3760,
                        month: 1,
                        day: 1
                    };
                }
            },
            {
                key: "getMonthCode",
                value: function getMonthCode(e, t) {
                    return this.inLeapYear({
                        year: e
                    }) ? 6 === t ? buildMonthCode(5, !0) : buildMonthCode(t < 6 ? t : t - 1) : buildMonthCode(t);
                }
            },
            {
                key: "adjustCalendarDate",
                value: function adjustCalendarDate(e, t) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "constrain", r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3], a = e.year, o = e.month, i = e.monthCode, u = e.day, s = e.monthExtra;
                    if (void 0 === a) throw new TypeError("Missing property: year");
                    if (r) {
                        if (s) {
                            var l = this.months[s];
                            if (!l) throw new RangeError("Unrecognized month from formatToParts: ".concat(s));
                            o = this.inLeapYear({
                                year: a
                            }) ? l.leap : l.regular;
                        }
                        return {
                            year: a,
                            month: o,
                            day: u,
                            monthCode: i = this.getMonthCode(a, o)
                        };
                    }
                    if (this.validateCalendarDate(e), void 0 === o) {
                        if (i.endsWith("L")) {
                            if ("M05L" !== i) throw new RangeError("Hebrew leap month must have monthCode M05L, not ".concat(i));
                            if (o = 6, !this.inLeapYear({
                                year: a
                            })) {
                                if ("reject" === n) throw new RangeError("Hebrew monthCode M05L is invalid in year ".concat(a, " which is not a leap year"));
                                o = 6, i = "M06";
                            }
                        } else {
                            o = nonLeapMonthCodeNumberPart(i), this.inLeapYear({
                                year: a
                            }) && o >= 6 && o++;
                            var c = this.monthsInYear({
                                year: a
                            });
                            if (o < 1 || o > c) throw new RangeError("Invalid monthCode: ".concat(i));
                        }
                    } else if ("reject" === n ? (RejectToRange(o, 1, this.monthsInYear({
                        year: a
                    })), RejectToRange(u, 1, this.maximumMonthLength({
                        year: a,
                        month: o
                    }))) : (o = ConstrainToRange(o, 1, this.monthsInYear({
                        year: a
                    })), u = ConstrainToRange(u, 1, this.maximumMonthLength({
                        year: a,
                        month: o
                    }))), void 0 === i) i = this.getMonthCode(a, o);
                    else if (this.getMonthCode(a, o) !== i) throw new RangeError("monthCode ".concat(i, " doesn't correspond to month ").concat(o, " in Hebrew year ").concat(a));
                    return _objectSpread2(_objectSpread2({}, e), {}, {
                        day: u,
                        month: o,
                        monthCode: i,
                        year: a
                    });
                }
            }
        ]), HebrewHelper;
    }(tt), rt = function(e) {
        _inherits(IslamicBaseHelper, e);
        var t = _createSuper(IslamicBaseHelper);
        function IslamicBaseHelper() {
            var e;
            return _classCallCheck(this, IslamicBaseHelper), (e = t.apply(this, arguments)).calendarType = "lunar", e.DAYS_PER_ISLAMIC_YEAR = 354 + 11 / 30, e.DAYS_PER_ISO_YEAR = 365.2425, e;
        }
        return _createClass(IslamicBaseHelper, [
            {
                key: "inLeapYear",
                value: function inLeapYear(e, t) {
                    var n = {
                        year: e.year,
                        month: 1,
                        monthCode: "M01",
                        day: 1
                    }, r = {
                        year: e.year + 1,
                        month: 1,
                        monthCode: "M01",
                        day: 1
                    };
                    return 355 === this.calendarDaysUntil(n, r, t);
                }
            },
            {
                key: "monthsInYear",
                value: function monthsInYear() {
                    return 12;
                }
            },
            {
                key: "minimumMonthLength",
                value: function minimumMonthLength() {
                    return 29;
                }
            },
            {
                key: "maximumMonthLength",
                value: function maximumMonthLength() {
                    return 30;
                }
            },
            {
                key: "maxLengthOfMonthCodeInAnyYear",
                value: function maxLengthOfMonthCodeInAnyYear() {
                    return 30;
                }
            },
            {
                key: "estimateIsoDate",
                value: function estimateIsoDate(e) {
                    var t = this.adjustCalendarDate(e).year;
                    return {
                        year: Math.floor(t * this.DAYS_PER_ISLAMIC_YEAR / this.DAYS_PER_ISO_YEAR) + 622,
                        month: 1,
                        day: 1
                    };
                }
            }
        ]), IslamicBaseHelper;
    }(tt), at = function(e) {
        _inherits(IslamicHelper, e);
        var t = _createSuper(IslamicHelper);
        function IslamicHelper() {
            var e;
            return _classCallCheck(this, IslamicHelper), (e = t.apply(this, arguments)).id = "islamic", e;
        }
        return _createClass(IslamicHelper);
    }(rt), ot = function(e) {
        _inherits(IslamicUmalquraHelper, e);
        var t = _createSuper(IslamicUmalquraHelper);
        function IslamicUmalquraHelper() {
            var e;
            return _classCallCheck(this, IslamicUmalquraHelper), (e = t.apply(this, arguments)).id = "islamic-umalqura", e;
        }
        return _createClass(IslamicUmalquraHelper);
    }(rt), it = function(e) {
        _inherits(IslamicTblaHelper, e);
        var t = _createSuper(IslamicTblaHelper);
        function IslamicTblaHelper() {
            var e;
            return _classCallCheck(this, IslamicTblaHelper), (e = t.apply(this, arguments)).id = "islamic-tbla", e;
        }
        return _createClass(IslamicTblaHelper);
    }(rt), ut = function(e) {
        _inherits(IslamicCivilHelper, e);
        var t = _createSuper(IslamicCivilHelper);
        function IslamicCivilHelper() {
            var e;
            return _classCallCheck(this, IslamicCivilHelper), (e = t.apply(this, arguments)).id = "islamic-civil", e;
        }
        return _createClass(IslamicCivilHelper);
    }(rt), st = function(e) {
        _inherits(IslamicRgsaHelper, e);
        var t = _createSuper(IslamicRgsaHelper);
        function IslamicRgsaHelper() {
            var e;
            return _classCallCheck(this, IslamicRgsaHelper), (e = t.apply(this, arguments)).id = "islamic-rgsa", e;
        }
        return _createClass(IslamicRgsaHelper);
    }(rt), lt = function(e) {
        _inherits(IslamicCcHelper, e);
        var t = _createSuper(IslamicCcHelper);
        function IslamicCcHelper() {
            var e;
            return _classCallCheck(this, IslamicCcHelper), (e = t.apply(this, arguments)).id = "islamicc", e;
        }
        return _createClass(IslamicCcHelper);
    }(rt), ct = function(e) {
        _inherits(PersianHelper, e);
        var t = _createSuper(PersianHelper);
        function PersianHelper() {
            var e;
            return _classCallCheck(this, PersianHelper), (e = t.apply(this, arguments)).id = "persian", e.calendarType = "solar", e;
        }
        return _createClass(PersianHelper, [
            {
                key: "inLeapYear",
                value: function inLeapYear(e, t) {
                    return 30 === this.daysInMonth({
                        year: e.year,
                        month: 12,
                        day: 1
                    }, t);
                }
            },
            {
                key: "monthsInYear",
                value: function monthsInYear() {
                    return 12;
                }
            },
            {
                key: "minimumMonthLength",
                value: function minimumMonthLength(e) {
                    var t = e.month;
                    return 12 === t ? 29 : t <= 6 ? 31 : 30;
                }
            },
            {
                key: "maximumMonthLength",
                value: function maximumMonthLength(e) {
                    var t = e.month;
                    return 12 === t ? 30 : t <= 6 ? 31 : 30;
                }
            },
            {
                key: "maxLengthOfMonthCodeInAnyYear",
                value: function maxLengthOfMonthCodeInAnyYear(e) {
                    return nonLeapMonthCodeNumberPart(e) <= 6 ? 31 : 30;
                }
            },
            {
                key: "estimateIsoDate",
                value: function estimateIsoDate(e) {
                    return {
                        year: this.adjustCalendarDate(e).year + 621,
                        month: 1,
                        day: 1
                    };
                }
            }
        ]), PersianHelper;
    }(tt), dt = function(e) {
        _inherits(IndianHelper, e);
        var t = _createSuper(IndianHelper);
        function IndianHelper() {
            var e;
            return _classCallCheck(this, IndianHelper), (e = t.apply(this, arguments)).id = "indian", e.calendarType = "solar", e.months = {
                1: {
                    length: 30,
                    month: 3,
                    day: 22,
                    leap: {
                        length: 31,
                        month: 3,
                        day: 21
                    }
                },
                2: {
                    length: 31,
                    month: 4,
                    day: 21
                },
                3: {
                    length: 31,
                    month: 5,
                    day: 22
                },
                4: {
                    length: 31,
                    month: 6,
                    day: 22
                },
                5: {
                    length: 31,
                    month: 7,
                    day: 23
                },
                6: {
                    length: 31,
                    month: 8,
                    day: 23
                },
                7: {
                    length: 30,
                    month: 9,
                    day: 23
                },
                8: {
                    length: 30,
                    month: 10,
                    day: 23
                },
                9: {
                    length: 30,
                    month: 11,
                    day: 22
                },
                10: {
                    length: 30,
                    month: 12,
                    day: 22
                },
                11: {
                    length: 30,
                    month: 1,
                    nextYear: !0,
                    day: 21
                },
                12: {
                    length: 30,
                    month: 2,
                    nextYear: !0,
                    day: 20
                }
            }, e.vulnerableToBceBug = "10/11/-79 Saka" !== new Date("0000-01-01T00:00Z").toLocaleDateString("en-US-u-ca-indian", {
                timeZone: "UTC"
            }), e;
        }
        return _createClass(IndianHelper, [
            {
                key: "inLeapYear",
                value: function inLeapYear(e) {
                    return isGregorianLeapYear(e.year + 78);
                }
            },
            {
                key: "monthsInYear",
                value: function monthsInYear() {
                    return 12;
                }
            },
            {
                key: "minimumMonthLength",
                value: function minimumMonthLength(e) {
                    return this.getMonthInfo(e).length;
                }
            },
            {
                key: "maximumMonthLength",
                value: function maximumMonthLength(e) {
                    return this.getMonthInfo(e).length;
                }
            },
            {
                key: "maxLengthOfMonthCodeInAnyYear",
                value: function maxLengthOfMonthCodeInAnyYear(e) {
                    var t, n = nonLeapMonthCodeNumberPart(e), r = this.months[n];
                    return (r = null !== (t = r.leap) && void 0 !== t ? t : r).length;
                }
            },
            {
                key: "getMonthInfo",
                value: function getMonthInfo(e) {
                    var t = e.month, n = this.months[t];
                    if (void 0 === n) throw new RangeError("Invalid month: ".concat(t));
                    return this.inLeapYear(e) && n.leap && (n = n.leap), n;
                }
            },
            {
                key: "estimateIsoDate",
                value: function estimateIsoDate(e) {
                    var t = this.adjustCalendarDate(e), n = this.getMonthInfo(t);
                    return BalanceISODate(t.year + 78 + (n.nextYear ? 1 : 0), n.month, n.day + t.day - 1);
                }
            },
            {
                key: "checkIcuBugs",
                value: function checkIcuBugs(e) {
                    if (this.vulnerableToBceBug && e.year < 1) throw new RangeError("calendar '".concat(this.id, "' is broken for ISO dates before 0001-01-01") + " (see https://bugs.chromium.org/p/v8/issues/detail?id=10529)");
                }
            }
        ]), IndianHelper;
    }(tt);
    function isGregorianLeapYear(e) {
        return e % 4 == 0 && (e % 100 != 0 || e % 400 == 0);
    }
    for(var mt, ht, ft, pt = function(e) {
        _inherits(GregorianBaseHelperFixedEpoch, e);
        var t = _createSuper(GregorianBaseHelperFixedEpoch);
        function GregorianBaseHelperFixedEpoch(e, n) {
            var r;
            return _classCallCheck(this, GregorianBaseHelperFixedEpoch), (r = t.call(this)).calendarType = "solar", r.id = e, r.isoEpoch = n, r;
        }
        return _createClass(GregorianBaseHelperFixedEpoch, [
            {
                key: "inLeapYear",
                value: function inLeapYear(e) {
                    return isGregorianLeapYear(this.estimateIsoDate({
                        month: 1,
                        day: 1,
                        year: e.year
                    }).year);
                }
            },
            {
                key: "monthsInYear",
                value: function monthsInYear() {
                    return 12;
                }
            },
            {
                key: "minimumMonthLength",
                value: function minimumMonthLength(e) {
                    var t = e.month;
                    return 2 === t ? this.inLeapYear(e) ? 29 : 28 : [
                        4,
                        6,
                        9,
                        11
                    ].indexOf(t) >= 0 ? 30 : 31;
                }
            },
            {
                key: "maximumMonthLength",
                value: function maximumMonthLength(e) {
                    return this.minimumMonthLength(e);
                }
            },
            {
                key: "maxLengthOfMonthCodeInAnyYear",
                value: function maxLengthOfMonthCodeInAnyYear(e) {
                    return [
                        31,
                        29,
                        31,
                        30,
                        31,
                        30,
                        31,
                        31,
                        30,
                        31,
                        30,
                        31
                    ][nonLeapMonthCodeNumberPart(e) - 1];
                }
            },
            {
                key: "estimateIsoDate",
                value: function estimateIsoDate(e) {
                    var t = this.adjustCalendarDate(e);
                    return RegulateISODate(t.year + this.isoEpoch.year, t.month + this.isoEpoch.month, t.day + this.isoEpoch.day, "constrain");
                }
            }
        ]), GregorianBaseHelperFixedEpoch;
    }(tt), vt = function(e) {
        _inherits(GregorianBaseHelper, e);
        var t = _createSuper(GregorianBaseHelper);
        function GregorianBaseHelper(e, n) {
            var r;
            _classCallCheck(this, GregorianBaseHelper), (r = t.call(this)).hasEra = !0, r.calendarType = "solar", r.id = e;
            var a = function adjustEras(e) {
                var t, n = e;
                if (0 === n.length) throw new RangeError("Invalid era data: eras are required");
                if (1 === n.length && n[0].reverseOf) throw new RangeError("Invalid era data: anchor era cannot count years backwards");
                if (1 === n.length && !n[0].code) throw new RangeError("Invalid era data: at least one named era is required");
                if (n.filter(function(e) {
                    return null != e.reverseOf;
                }).length > 1) throw new RangeError("Invalid era data: only one era can count years backwards");
                n.forEach(function(e) {
                    if (e.isAnchor || !e.anchorEpoch && !e.reverseOf) {
                        if (t) throw new RangeError("Invalid era data: cannot have multiple anchor eras");
                        t = e, e.anchorEpoch = {
                            year: e.hasYearZero ? 0 : 1
                        };
                    } else if (!e.code) throw new RangeError("If era name is blank, it must be the anchor era");
                }), (n = n.filter(function(e) {
                    return e.code;
                })).forEach(function(e) {
                    var t = e.reverseOf;
                    if (t) {
                        var r = n.find(function(e) {
                            return e.code === t;
                        });
                        if (void 0 === r) throw new RangeError("Invalid era data: unmatched reverseOf era: ".concat(t));
                        e.reverseOf = r, e.anchorEpoch = r.anchorEpoch, e.isoEpoch = r.isoEpoch;
                    }
                    void 0 === e.anchorEpoch.month && (e.anchorEpoch.month = 1), void 0 === e.anchorEpoch.day && (e.anchorEpoch.day = 1);
                }), n.sort(function(e, t) {
                    if (e.reverseOf) return 1;
                    if (t.reverseOf) return -1;
                    if (!e.isoEpoch || !t.isoEpoch) throw new RangeError("Invalid era data: missing ISO epoch");
                    return t.isoEpoch.year - e.isoEpoch.year;
                });
                var r = n[n.length - 1].reverseOf;
                if (r && r !== n[n.length - 2]) throw new RangeError("Invalid era data: invalid reverse-sign era");
                return n.forEach(function(e, t) {
                    e.genericName = "era".concat(n.length - 1 - t);
                }), {
                    eras: n,
                    anchorEra: t || n[0]
                };
            }(n), o = a.eras, i = a.anchorEra;
            return r.anchorEra = i, r.eras = o, r;
        }
        return _createClass(GregorianBaseHelper, [
            {
                key: "inLeapYear",
                value: function inLeapYear(e) {
                    return isGregorianLeapYear(this.estimateIsoDate({
                        month: 1,
                        day: 1,
                        year: e.year
                    }).year);
                }
            },
            {
                key: "monthsInYear",
                value: function monthsInYear() {
                    return 12;
                }
            },
            {
                key: "minimumMonthLength",
                value: function minimumMonthLength(e) {
                    var t = e.month;
                    return 2 === t ? this.inLeapYear(e) ? 29 : 28 : [
                        4,
                        6,
                        9,
                        11
                    ].indexOf(t) >= 0 ? 30 : 31;
                }
            },
            {
                key: "maximumMonthLength",
                value: function maximumMonthLength(e) {
                    return this.minimumMonthLength(e);
                }
            },
            {
                key: "maxLengthOfMonthCodeInAnyYear",
                value: function maxLengthOfMonthCodeInAnyYear(e) {
                    return [
                        31,
                        29,
                        31,
                        30,
                        31,
                        30,
                        31,
                        31,
                        30,
                        31,
                        30,
                        31
                    ][nonLeapMonthCodeNumberPart(e) - 1];
                }
            },
            {
                key: "completeEraYear",
                value: function completeEraYear(e) {
                    var t = this, n = function checkField(t, n, r) {
                        var a = e[t];
                        if (null != a && a != n && !(r || []).includes(a)) {
                            var o = null == r ? void 0 : r[0], i = o ? "".concat(n, " (also called ").concat(o, ")") : n;
                            throw new RangeError("Input ".concat(t, " ").concat(a, " doesn't match calculated value ").concat(i));
                        }
                    }, r = function eraFromYear(n) {
                        var r, a = _objectSpread2(_objectSpread2({}, e), {}, {
                            year: n
                        }), o = t.eras.find(function(e, o) {
                            if (o === t.eras.length - 1) {
                                if (e.reverseOf) {
                                    if (n > 0) throw new RangeError("Signed year ".concat(n, " is invalid for era ").concat(e.code));
                                    return r = e.anchorEpoch.year - n, !0;
                                }
                                return r = n - e.anchorEpoch.year + (e.hasYearZero ? 0 : 1), !0;
                            }
                            return t.compareCalendarDates(a, e.anchorEpoch) >= 0 && (r = n - e.anchorEpoch.year + (e.hasYearZero ? 0 : 1), !0);
                        });
                        if (!o) throw new RangeError("Year ".concat(n, " was not matched by any era"));
                        return {
                            eraYear: r,
                            era: o.code,
                            eraNames: o.names
                        };
                    }, a = e.year, o = e.eraYear, i = e.era;
                    if (null != a) {
                        var u = r(a);
                        o = u.eraYear, n("era", i = u.era, null == u ? void 0 : u.eraNames), n("eraYear", o);
                    } else {
                        if (null == o) throw new RangeError("Either year or eraYear and era are required");
                        if (void 0 === i) throw new RangeError("era and eraYear must be provided together");
                        var s = this.eras.find(function(e) {
                            var t = e.code, n = e.names;
                            return t === i || (void 0 === n ? [] : n).includes(i);
                        });
                        if (!s) throw new RangeError("Era ".concat(i, " (ISO year ").concat(o, ") was not matched by any era"));
                        n("year", a = s.reverseOf ? s.anchorEpoch.year - o : o + s.anchorEpoch.year - (s.hasYearZero ? 0 : 1));
                        var l = r(a);
                        o = l.eraYear, i = l.era;
                    }
                    return _objectSpread2(_objectSpread2({}, e), {}, {
                        year: a,
                        eraYear: o,
                        era: i
                    });
                }
            },
            {
                key: "adjustCalendarDate",
                value: function adjustCalendarDate(e, t) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "constrain", r = e, a = r, o = a.month, i = a.monthCode;
                    return void 0 === o && (r = _objectSpread2(_objectSpread2({}, r), {}, {
                        month: nonLeapMonthCodeNumberPart(i)
                    })), this.validateCalendarDate(r), r = this.completeEraYear(r), _get(_getPrototypeOf(GregorianBaseHelper.prototype), "adjustCalendarDate", this).call(this, r, t, n);
                }
            },
            {
                key: "estimateIsoDate",
                value: function estimateIsoDate(e) {
                    var t = this.adjustCalendarDate(e), n = t.year, r = t.month, a = t.day, o = this.anchorEra;
                    return RegulateISODate(n + o.isoEpoch.year - (o.hasYearZero ? 0 : 1), r, a, "constrain");
                }
            }
        ]), GregorianBaseHelper;
    }(tt), Dt = function(e) {
        _inherits(SameMonthDayAsGregorianBaseHelper, e);
        var t = _createSuper(SameMonthDayAsGregorianBaseHelper);
        function SameMonthDayAsGregorianBaseHelper(e, n) {
            return _classCallCheck(this, SameMonthDayAsGregorianBaseHelper), t.call(this, e, n);
        }
        return _createClass(SameMonthDayAsGregorianBaseHelper, [
            {
                key: "isoToCalendarDate",
                value: function isoToCalendarDate(e) {
                    var t = e.year, n = e.month, r = e.day, a = buildMonthCode(n), o = t - this.anchorEra.isoEpoch.year + 1;
                    return this.completeEraYear({
                        year: o,
                        month: n,
                        monthCode: a,
                        day: r
                    });
                }
            }
        ]), SameMonthDayAsGregorianBaseHelper;
    }(vt), gt = function inLeapYear(e) {
        return (e.year + 1) % 4 == 0;
    }, yt = function monthsInYear() {
        return 13;
    }, Tt = function minimumMonthLength(e) {
        return 13 === e.month ? this.inLeapYear(e) ? 6 : 5 : 30;
    }, St = function maximumMonthLength(e) {
        return this.minimumMonthLength(e);
    }, It = function maxLengthOfMonthCodeInAnyYear(e) {
        return "M13" === e ? 6 : 30;
    }, Ct = function(e) {
        _inherits(OrthodoxBaseHelperFixedEpoch, e);
        var t = _createSuper(OrthodoxBaseHelperFixedEpoch);
        function OrthodoxBaseHelperFixedEpoch(e, n) {
            var r;
            return _classCallCheck(this, OrthodoxBaseHelperFixedEpoch), (r = t.call(this, e, n)).inLeapYear = gt, r.monthsInYear = yt, r.minimumMonthLength = Tt, r.maximumMonthLength = St, r.maxLengthOfMonthCodeInAnyYear = It, r;
        }
        return _createClass(OrthodoxBaseHelperFixedEpoch);
    }(pt), _t = function(e) {
        _inherits(OrthodoxBaseHelper, e);
        var t = _createSuper(OrthodoxBaseHelper);
        function OrthodoxBaseHelper(e, n) {
            var r;
            return _classCallCheck(this, OrthodoxBaseHelper), (r = t.call(this, e, n)).inLeapYear = gt, r.monthsInYear = yt, r.minimumMonthLength = Tt, r.maximumMonthLength = St, r.maxLengthOfMonthCodeInAnyYear = It, r;
        }
        return _createClass(OrthodoxBaseHelper);
    }(vt), Ot = function(e) {
        _inherits(EthioaaHelper, e);
        var t = _createSuper(EthioaaHelper);
        function EthioaaHelper() {
            return _classCallCheck(this, EthioaaHelper), t.call(this, "ethioaa", {
                year: -5492,
                month: 7,
                day: 17
            });
        }
        return _createClass(EthioaaHelper);
    }(Ct), bt = function(e) {
        _inherits(CopticHelper, e);
        var t = _createSuper(CopticHelper);
        function CopticHelper() {
            return _classCallCheck(this, CopticHelper), t.call(this, "coptic", [
                {
                    code: "coptic",
                    isoEpoch: {
                        year: 284,
                        month: 8,
                        day: 29
                    }
                },
                {
                    code: "coptic-inverse",
                    reverseOf: "coptic"
                }
            ]);
        }
        return _createClass(CopticHelper);
    }(_t), wt = function(e) {
        _inherits(EthiopicHelper, e);
        var t = _createSuper(EthiopicHelper);
        function EthiopicHelper() {
            return _classCallCheck(this, EthiopicHelper), t.call(this, "ethiopic", [
                {
                    code: "ethioaa",
                    names: [
                        "ethiopic-amete-alem",
                        "mundi"
                    ],
                    isoEpoch: {
                        year: -5492,
                        month: 7,
                        day: 17
                    }
                },
                {
                    code: "ethiopic",
                    names: [
                        "incar"
                    ],
                    isoEpoch: {
                        year: 8,
                        month: 8,
                        day: 27
                    },
                    anchorEpoch: {
                        year: 5501
                    }
                }
            ]);
        }
        return _createClass(EthiopicHelper);
    }(_t), Ft = function(e) {
        _inherits(RocHelper, e);
        var t = _createSuper(RocHelper);
        function RocHelper() {
            return _classCallCheck(this, RocHelper), t.call(this, "roc", [
                {
                    code: "roc",
                    names: [
                        "minguo"
                    ],
                    isoEpoch: {
                        year: 1912,
                        month: 1,
                        day: 1
                    }
                },
                {
                    code: "roc-inverse",
                    names: [
                        "before-roc"
                    ],
                    reverseOf: "roc"
                }
            ]);
        }
        return _createClass(RocHelper);
    }(Dt), kt = function(e) {
        _inherits(BuddhistHelper, e);
        var t = _createSuper(BuddhistHelper);
        function BuddhistHelper() {
            return _classCallCheck(this, BuddhistHelper), t.call(this, "buddhist", {
                year: -543,
                month: 1,
                day: 1
            });
        }
        return _createClass(BuddhistHelper);
    }(pt), Et = function(e) {
        _inherits(GregoryHelper, e);
        var t = _createSuper(GregoryHelper);
        function GregoryHelper() {
            return _classCallCheck(this, GregoryHelper), t.call(this, "gregory", [
                {
                    code: "gregory",
                    names: [
                        "ad",
                        "ce"
                    ],
                    isoEpoch: {
                        year: 1,
                        month: 1,
                        day: 1
                    }
                },
                {
                    code: "gregory-inverse",
                    names: [
                        "be",
                        "bce"
                    ],
                    reverseOf: "gregory"
                }
            ]);
        }
        return _createClass(GregoryHelper, [
            {
                key: "reviseIntlEra",
                value: function reviseIntlEra(e) {
                    var t = e.era;
                    return "b" === t && (t = "gregory-inverse"), "a" === t && (t = "gregory"), {
                        era: t,
                        eraYear: e.eraYear
                    };
                }
            },
            {
                key: "getFirstDayOfWeek",
                value: function getFirstDayOfWeek() {
                    return 1;
                }
            },
            {
                key: "getMinimalDaysInFirstWeek",
                value: function getMinimalDaysInFirstWeek() {
                    return 1;
                }
            }
        ]), GregoryHelper;
    }(Dt), Bt = function(e) {
        _inherits(JapaneseHelper, e);
        var t = _createSuper(JapaneseHelper);
        function JapaneseHelper() {
            var e;
            return _classCallCheck(this, JapaneseHelper), (e = t.call(this, "japanese", [
                {
                    code: "reiwa",
                    isoEpoch: {
                        year: 2019,
                        month: 5,
                        day: 1
                    },
                    anchorEpoch: {
                        year: 2019,
                        month: 5,
                        day: 1
                    }
                },
                {
                    code: "heisei",
                    isoEpoch: {
                        year: 1989,
                        month: 1,
                        day: 8
                    },
                    anchorEpoch: {
                        year: 1989,
                        month: 1,
                        day: 8
                    }
                },
                {
                    code: "showa",
                    isoEpoch: {
                        year: 1926,
                        month: 12,
                        day: 25
                    },
                    anchorEpoch: {
                        year: 1926,
                        month: 12,
                        day: 25
                    }
                },
                {
                    code: "taisho",
                    isoEpoch: {
                        year: 1912,
                        month: 7,
                        day: 30
                    },
                    anchorEpoch: {
                        year: 1912,
                        month: 7,
                        day: 30
                    }
                },
                {
                    code: "meiji",
                    isoEpoch: {
                        year: 1868,
                        month: 9,
                        day: 8
                    },
                    anchorEpoch: {
                        year: 1868,
                        month: 9,
                        day: 8
                    }
                },
                {
                    code: "japanese",
                    names: [
                        "japanese",
                        "gregory",
                        "ad",
                        "ce"
                    ],
                    isoEpoch: {
                        year: 1,
                        month: 1,
                        day: 1
                    }
                },
                {
                    code: "japanese-inverse",
                    names: [
                        "japanese-inverse",
                        "gregory-inverse",
                        "bc",
                        "bce"
                    ],
                    reverseOf: "japanese"
                }
            ])).erasBeginMidYear = !0, e;
        }
        return _createClass(JapaneseHelper, [
            {
                key: "reviseIntlEra",
                value: function reviseIntlEra(e, t) {
                    var n = e.era, r = e.eraYear, a = t.year;
                    return this.eras.find(function(e) {
                        return e.code === n;
                    }) ? {
                        era: n,
                        eraYear: r
                    } : a < 1 ? {
                        era: "japanese-inverse",
                        eraYear: 1 - a
                    } : {
                        era: "japanese",
                        eraYear: a
                    };
                }
            }
        ]), JapaneseHelper;
    }(Dt), Rt = function(e) {
        _inherits(ChineseBaseHelper, e);
        var t = _createSuper(ChineseBaseHelper);
        function ChineseBaseHelper() {
            var e;
            return _classCallCheck(this, ChineseBaseHelper), (e = t.apply(this, arguments)).calendarType = "lunisolar", e;
        }
        return _createClass(ChineseBaseHelper, [
            {
                key: "inLeapYear",
                value: function inLeapYear(e, t) {
                    var n = this.getMonthList(e.year, t);
                    return 13 === Object.entries(n).length;
                }
            },
            {
                key: "monthsInYear",
                value: function monthsInYear(e, t) {
                    return this.inLeapYear(e, t) ? 13 : 12;
                }
            },
            {
                key: "minimumMonthLength",
                value: function minimumMonthLength() {
                    return 29;
                }
            },
            {
                key: "maximumMonthLength",
                value: function maximumMonthLength() {
                    return 30;
                }
            },
            {
                key: "maxLengthOfMonthCodeInAnyYear",
                value: function maxLengthOfMonthCodeInAnyYear(e) {
                    return [
                        "M01L",
                        "M09L",
                        "M10L",
                        "M11L",
                        "M12L"
                    ].includes(e) ? 29 : 30;
                }
            },
            {
                key: "monthDaySearchStartYear",
                value: function monthDaySearchStartYear(e, t) {
                    var n, r = null !== (n = ({
                        M01L: [
                            1651,
                            1651
                        ],
                        M02L: [
                            1947,
                            1765
                        ],
                        M03L: [
                            1966,
                            1955
                        ],
                        M04L: [
                            1963,
                            1944
                        ],
                        M05L: [
                            1971,
                            1952
                        ],
                        M06L: [
                            1960,
                            1941
                        ],
                        M07L: [
                            1968,
                            1938
                        ],
                        M08L: [
                            1957,
                            1718
                        ],
                        M09L: [
                            1832,
                            1832
                        ],
                        M10L: [
                            1870,
                            1870
                        ],
                        M11L: [
                            1814,
                            1814
                        ],
                        M12L: [
                            1890,
                            1890
                        ]
                    })[e]) && void 0 !== n ? n : [
                        1972,
                        1972
                    ];
                    return t < 30 ? r[0] : r[1];
                }
            },
            {
                key: "getMonthList",
                value: function getMonthList(e, t) {
                    var n = this;
                    if (void 0 === e) throw new TypeError("Missing year");
                    var r = JSON.stringify({
                        func: "getMonthList",
                        calendarYear: e,
                        id: this.id
                    }), a = t.get(r);
                    if (a) return a;
                    var o = this.getFormatter(), i = function getCalendarDate(e, t) {
                        var r = toUtcIsoDateString({
                            isoYear: e,
                            isoMonth: 2,
                            isoDay: 1
                        }), a = new Date(r);
                        a.setUTCDate(t + 1);
                        var i = o.formatToParts(a), u = i.find(function(e) {
                            return "month" === e.type;
                        }).value, s = +i.find(function(e) {
                            return "day" === e.type;
                        }).value, l = i.find(function(e) {
                            return "relatedYear" === e.type;
                        });
                        if (void 0 === l) throw new RangeError("Intl.DateTimeFormat.formatToParts lacks relatedYear in ".concat(n.id, " calendar. Try Node 14+ or modern browsers."));
                        return {
                            calendarMonthString: u,
                            calendarDay: s,
                            calendarYearToVerify: +l.value
                        };
                    }, u = 17, s = i(e, u), l = s.calendarMonthString, c = s.calendarDay, d = s.calendarYearToVerify;
                    if ("1" !== l) {
                        var m = i(e, u += 29);
                        l = m.calendarMonthString, c = m.calendarDay;
                    }
                    u -= c - 5;
                    var h, f, p = {}, v = 1, D = !1;
                    do {
                        var g = i(e, u);
                        l = g.calendarMonthString, c = g.calendarDay, d = g.calendarYearToVerify, h && (p[f].daysInMonth = h + 30 - c), d !== e ? D = !0 : (p[l] = {
                            monthIndex: v++
                        }, u += 30), h = c, f = l;
                    }while (!D);
                    return p[f].daysInMonth = h + 30 - c, t.set(r, p), p;
                }
            },
            {
                key: "estimateIsoDate",
                value: function estimateIsoDate(e) {
                    var t = e.year, n = e.month;
                    return {
                        year: t,
                        month: n >= 12 ? 12 : n + 1,
                        day: 1
                    };
                }
            },
            {
                key: "adjustCalendarDate",
                value: function adjustCalendarDate(e, t) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "constrain", r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3], a = e.year, o = e.month, i = e.monthExtra, u = e.day, s = e.monthCode;
                    if (void 0 === a) throw new TypeError("Missing property: year");
                    if (r) {
                        if (i && "bis" !== i) throw new RangeError("Unexpected leap month suffix: ".concat(i));
                        var l = buildMonthCode(o, void 0 !== i), c = "".concat(o).concat(i || ""), d = this.getMonthList(a, t)[c];
                        if (void 0 === d) throw new RangeError("Unmatched month ".concat(c, " in Chinese year ").concat(a));
                        return {
                            year: a,
                            month: o = d.monthIndex,
                            day: u,
                            monthCode: l
                        };
                    }
                    if (this.validateCalendarDate(e), void 0 === o) {
                        var m = this.getMonthList(a, t), h = s.replace(/^M|L$/g, function(e) {
                            return "L" === e ? "bis" : "";
                        });
                        "0" === h[0] && (h = h.slice(1));
                        var f = m[h];
                        if (void 0 === (o = f && f.monthIndex) && s.endsWith("L") && "M13L" != s && "constrain" === n) {
                            var p = +s.replace(/^M0?|L$/g, "");
                            (f = m[p]) && (o = f.monthIndex, s = buildMonthCode(p));
                        }
                        if (void 0 === o) throw new RangeError("Unmatched month ".concat(s, " in Chinese year ").concat(a));
                    } else if (void 0 === s) {
                        var v = this.getMonthList(a, t), D = Object.entries(v), g = D.length;
                        "reject" === n ? (RejectToRange(o, 1, g), RejectToRange(u, 1, this.maximumMonthLength())) : (o = ConstrainToRange(o, 1, g), u = ConstrainToRange(u, 1, this.maximumMonthLength()));
                        var y = D.find(function(e) {
                            return e[1].monthIndex === o;
                        });
                        if (void 0 === y) throw new RangeError("Invalid month ".concat(o, " in Chinese year ").concat(a));
                        s = buildMonthCode(+y[0].replace("bis", ""), -1 !== y[0].indexOf("bis"));
                    } else {
                        var T = this.getMonthList(a, t), S = s.replace(/^M|L$/g, function(e) {
                            return "L" === e ? "bis" : "";
                        });
                        "0" === S[0] && (S = S.slice(1));
                        var I = T[S];
                        if (!I) throw new RangeError("Unmatched monthCode ".concat(s, " in Chinese year ").concat(a));
                        if (o !== I.monthIndex) throw new RangeError("monthCode ".concat(s, " doesn't correspond to month ").concat(o, " in Chinese year ").concat(a));
                    }
                    return _objectSpread2(_objectSpread2({}, e), {}, {
                        year: a,
                        month: o,
                        monthCode: s,
                        day: u
                    });
                }
            }
        ]), ChineseBaseHelper;
    }(tt), Gt = function(e) {
        _inherits(ChineseHelper, e);
        var t = _createSuper(ChineseHelper);
        function ChineseHelper() {
            var e;
            return _classCallCheck(this, ChineseHelper), (e = t.apply(this, arguments)).id = "chinese", e;
        }
        return _createClass(ChineseHelper);
    }(Rt), Mt = function(e) {
        _inherits(DangiHelper, e);
        var t = _createSuper(DangiHelper);
        function DangiHelper() {
            var e;
            return _classCallCheck(this, DangiHelper), (e = t.apply(this, arguments)).id = "dangi", e;
        }
        return _createClass(DangiHelper);
    }(Rt), At = function() {
        function NonIsoCalendar(e) {
            _classCallCheck(this, NonIsoCalendar), this.helper = e;
        }
        return _createClass(NonIsoCalendar, [
            {
                key: "extraFields",
                value: function extraFields(e) {
                    return this.helper.hasEra && e.includes("year") ? [
                        "era",
                        "eraYear"
                    ] : [];
                }
            },
            {
                key: "resolveFields",
                value: function resolveFields(e) {
                    if ("lunisolar" !== this.helper.calendarType) {
                        var t, n = new et;
                        resolveNonLunisolarMonth(e, void 0, this.helper.monthsInYear({
                            year: null !== (t = e.year) && void 0 !== t ? t : 1972
                        }, n));
                    }
                }
            },
            {
                key: "dateToISO",
                value: function dateToISO(e, t) {
                    var n = new et, r = this.helper.calendarToIsoDate(e, t, n);
                    return n.setObject(r), r;
                }
            },
            {
                key: "monthDayToISOReferenceDate",
                value: function monthDayToISOReferenceDate(e, t) {
                    var n = new et, r = this.helper.monthDayFromFields(e, t, n);
                    return n.setObject(r), r;
                }
            },
            {
                key: "fieldKeysToIgnore",
                value: function fieldKeysToIgnore(e) {
                    for(var t = new Set, n = 0; n < e.length; n++){
                        var r = e[n];
                        switch(t.add(r), r){
                            case "era":
                                t.add("eraYear"), t.add("year");
                                break;
                            case "eraYear":
                                t.add("era"), t.add("year");
                                break;
                            case "year":
                                t.add("era"), t.add("eraYear");
                                break;
                            case "month":
                                t.add("monthCode"), this.helper.erasBeginMidYear && (t.add("era"), t.add("eraYear"));
                                break;
                            case "monthCode":
                                t.add("month"), this.helper.erasBeginMidYear && (t.add("era"), t.add("eraYear"));
                                break;
                            case "day":
                                this.helper.erasBeginMidYear && (t.add("era"), t.add("eraYear"));
                        }
                    }
                    return arrayFromSet(t);
                }
            },
            {
                key: "dateAdd",
                value: function dateAdd(e, t, n) {
                    var r = t.years, a = t.months, o = t.weeks, i = t.days, u = et.getCacheForObject(e), s = this.helper.isoToCalendarDate(e, u), l = this.helper.addCalendar(s, {
                        years: r,
                        months: a,
                        weeks: o,
                        days: i
                    }, n, u), c = this.helper.calendarToIsoDate(l, "constrain", u);
                    return et.getCacheForObject(c) || new et(u).setObject(c), c;
                }
            },
            {
                key: "dateUntil",
                value: function dateUntil(e, t, n) {
                    var r = et.getCacheForObject(e), a = et.getCacheForObject(t), o = this.helper.isoToCalendarDate(e, r), i = this.helper.isoToCalendarDate(t, a);
                    return this.helper.untilCalendar(o, i, n, r);
                }
            },
            {
                key: "isoToDate",
                value: function isoToDate(e, t) {
                    var n = et.getCacheForObject(e), r = this.helper.isoToCalendarDate(e, n);
                    if (t.dayOfWeek && (r.dayOfWeek = Qe.iso8601.isoToDate(e, {
                        dayOfWeek: !0
                    }).dayOfWeek), t.dayOfYear) {
                        var a = this.helper.startOfCalendarYear(r), o = this.helper.calendarDaysUntil(a, r, n);
                        r.dayOfYear = o + 1;
                    }
                    if (t.weekOfYear && (r.weekOfYear = calendarDateWeekOfYear(this.helper.id, e)), r.daysInWeek = 7, t.daysInMonth && (r.daysInMonth = this.helper.daysInMonth(r, n)), t.daysInYear) {
                        var i = this.helper.startOfCalendarYear(r), u = this.helper.addCalendar(i, {
                            years: 1
                        }, "constrain", n);
                        r.daysInYear = this.helper.calendarDaysUntil(i, u, n);
                    }
                    return t.monthsInYear && (r.monthsInYear = this.helper.monthsInYear(r, n)), t.inLeapYear && (r.inLeapYear = this.helper.inLeapYear(r, n)), r;
                }
            },
            {
                key: "getFirstDayOfWeek",
                value: function getFirstDayOfWeek() {
                    return this.helper.getFirstDayOfWeek();
                }
            },
            {
                key: "getMinimalDaysInFirstWeek",
                value: function getMinimalDaysInFirstWeek() {
                    return this.helper.getMinimalDaysInFirstWeek();
                }
            }
        ]), NonIsoCalendar;
    }(), Pt = 0, jt = [
        nt,
        ct,
        wt,
        Ot,
        bt,
        Gt,
        Mt,
        Ft,
        dt,
        kt,
        Et,
        Bt,
        at,
        ot,
        it,
        ut,
        st,
        lt
    ]; Pt < jt.length; Pt++){
        var Nt = new jt[Pt];
        Qe[Nt.id] = new At(Nt);
    }
    DefineIntrinsic("calendarImpl", function calendarImpl(e) {
        return Qe[e];
    });
    var Yt = Intl.DateTimeFormat;
    function getSlotLazy(e, t) {
        var n = GetSlot(e, t);
        return "function" == typeof n && function ResetSlot(e, t, n) {
            var r = V(e);
            if (void 0 === r) throw new TypeError("Missing slots for the given container");
            if (void 0 === r[t]) throw new TypeError("tried to reset ".concat(t, " which was not set"));
            r[t] = n;
        }(e, t, n = new Yt(GetSlot(e, W), n(GetSlot(e, z)))), n;
    }
    function IsPatchedDateTimeFormat(e) {
        return HasSlot(e, Z);
    }
    var Jt = function() {
        function DateTimeFormatImpl() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
            _classCallCheck(this, DateTimeFormatImpl), function createDateTimeFormat(e, t, n) {
                var r, a = void 0 !== n;
                if (a) {
                    var o = [
                        "localeMatcher",
                        "calendar",
                        "numberingSystem",
                        "hour12",
                        "hourCycle",
                        "timeZone",
                        "weekday",
                        "era",
                        "year",
                        "month",
                        "day",
                        "dayPeriod",
                        "hour",
                        "minute",
                        "second",
                        "fractionalSecondDigits",
                        "timeZoneName",
                        "formatMatcher",
                        "dateStyle",
                        "timeStyle"
                    ];
                    r = function ToObject(e) {
                        if (null == e) throw new TypeError("Expected object not ".concat(e));
                        return Object(e);
                    }(n);
                    for(var i = Object.create(null), u = 0; u < o.length; u++){
                        var s = o[u];
                        Object.prototype.hasOwnProperty.call(r, s) && (i[s] = r[s]);
                    }
                    r = i;
                } else r = Object.create(null);
                var l = new Yt(t, r), c = l.resolvedOptions();
                if (Q(e), a) {
                    var d = Object.assign(Object.create(null), c);
                    for(var m in d)Object.prototype.hasOwnProperty.call(r, m) || delete d[m];
                    d.hour12 = r.hour12, d.hourCycle = r.hourCycle, SetSlot(e, z, d);
                } else SetSlot(e, z, r);
                SetSlot(e, W, c.locale), SetSlot(e, Z, l), SetSlot(e, U, c.timeZone), SetSlot(e, H, c.calendar), SetSlot(e, P, dateAmend), SetSlot(e, j, yearMonthAmend), SetSlot(e, N, monthDayAmend), SetSlot(e, Y, timeAmend), SetSlot(e, J, datetimeAmend), SetSlot(e, L, instantAmend);
                var h = a ? r.timeZone : void 0;
                if (void 0 === h) SetSlot(e, x, c.timeZone);
                else {
                    var f = ToString(h);
                    if (f.startsWith("\u2212")) throw new RangeError("Unicode minus (U+2212) is not supported in time zone offsets");
                    SetSlot(e, x, ToTemporalTimeZoneIdentifier(f));
                }
            }(this, e, t);
        }
        return _createClass(DateTimeFormatImpl, [
            {
                key: "format",
                get: function get() {
                    CheckReceiver(this, IsPatchedDateTimeFormat);
                    var e = format.bind(this);
                    return Object.defineProperties(e, {
                        length: {
                            value: 1,
                            enumerable: !1,
                            writable: !1,
                            configurable: !0
                        },
                        name: {
                            value: "",
                            enumerable: !1,
                            writable: !1,
                            configurable: !0
                        }
                    }), e;
                }
            },
            {
                key: "formatRange",
                value: function formatRange(e, t) {
                    return CheckReceiver(this, IsPatchedDateTimeFormat), _formatRange.call(this, e, t);
                }
            },
            {
                key: "formatToParts",
                value: function formatToParts(e) {
                    CheckReceiver(this, IsPatchedDateTimeFormat);
                    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
                    return _formatToParts.call.apply(_formatToParts, [
                        this,
                        e
                    ].concat(n));
                }
            },
            {
                key: "formatRangeToParts",
                value: function formatRangeToParts(e, t) {
                    return CheckReceiver(this, IsPatchedDateTimeFormat), _formatRangeToParts.call(this, e, t);
                }
            },
            {
                key: "resolvedOptions",
                value: function resolvedOptions() {
                    return CheckReceiver(this, IsPatchedDateTimeFormat), _resolvedOptions.call(this);
                }
            }
        ]), DateTimeFormatImpl;
    }();
    "formatToParts" in Yt.prototype || delete Jt.prototype.formatToParts, "formatRangeToParts" in Yt.prototype || delete Jt.prototype.formatRangeToParts;
    var Lt = function DateTimeFormat() {
        return new Jt(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0);
    };
    function _resolvedOptions() {
        var e = GetSlot(this, Z).resolvedOptions();
        return e.timeZone = GetSlot(this, x), e;
    }
    function format(e) {
        var t, n, r, a = extractOverrides(e, this);
        if (a.formatter) n = a.formatter, r = [
            epochNsToMs(a.epochNs, "floor")
        ];
        else {
            n = GetSlot(this, Z);
            for(var o = arguments.length, i = new Array(o > 1 ? o - 1 : 0), u = 1; u < o; u++)i[u - 1] = arguments[u];
            r = [
                e
            ].concat(i);
        }
        return (t = n).format.apply(t, _toConsumableArray(r));
    }
    function _formatToParts(e) {
        var t, n, r, a = extractOverrides(e, this);
        if (a.formatter) n = a.formatter, r = [
            epochNsToMs(a.epochNs, "floor")
        ];
        else {
            n = GetSlot(this, Z);
            for(var o = arguments.length, i = new Array(o > 1 ? o - 1 : 0), u = 1; u < o; u++)i[u - 1] = arguments[u];
            r = [
                e
            ].concat(i);
        }
        return (t = n).formatToParts.apply(t, _toConsumableArray(r));
    }
    function _formatRange(e, t) {
        var n;
        if (void 0 === e || void 0 === t) throw new TypeError("Intl.DateTimeFormat.formatRange requires two values");
        var r, a = toDateTimeFormattable(e), o = toDateTimeFormattable(t), i = [
            a,
            o
        ];
        if (isTemporalObject(a) !== isTemporalObject(o)) throw new TypeError("Intl.DateTimeFormat.formatRange accepts two values of the same type");
        if (isTemporalObject(a)) {
            if (!sameTemporalType(a, o)) throw new TypeError("Intl.DateTimeFormat.formatRange accepts two values of the same type");
            var u = extractOverrides(a, this), s = u.epochNs, l = u.formatter, c = extractOverrides(o, this), d = c.epochNs;
            c.formatter, l && (r = l, i = [
                epochNsToMs(s, "floor"),
                epochNsToMs(d, "floor")
            ]);
        }
        return r || (r = GetSlot(this, Z)), (n = r).formatRange.apply(n, _toConsumableArray(i));
    }
    function _formatRangeToParts(e, t) {
        var n;
        if (void 0 === e || void 0 === t) throw new TypeError("Intl.DateTimeFormat.formatRange requires two values");
        var r, a = toDateTimeFormattable(e), o = toDateTimeFormattable(t), i = [
            a,
            o
        ];
        if (isTemporalObject(a) !== isTemporalObject(o)) throw new TypeError("Intl.DateTimeFormat.formatRangeToParts accepts two values of the same type");
        if (isTemporalObject(a)) {
            if (!sameTemporalType(a, o)) throw new TypeError("Intl.DateTimeFormat.formatRangeToParts accepts two values of the same type");
            var u = extractOverrides(a, this), s = u.epochNs, l = u.formatter, c = extractOverrides(o, this), d = c.epochNs;
            c.formatter, l && (r = l, i = [
                epochNsToMs(s, "floor"),
                epochNsToMs(d, "floor")
            ]);
        }
        return r || (r = GetSlot(this, Z)), (n = r).formatRangeToParts.apply(n, _toConsumableArray(i));
    }
    function amend() {
        for(var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = Object.assign({}, e), r = [
            "year",
            "month",
            "day",
            "hour",
            "minute",
            "second",
            "weekday",
            "dayPeriod",
            "timeZoneName",
            "dateStyle",
            "timeStyle"
        ], a = 0; a < r.length; a++){
            var o = r[a];
            n[o] = o in t ? t[o] : n[o], !1 !== n[o] && void 0 !== n[o] || delete n[o];
        }
        return n;
    }
    function timeAmend(e) {
        var t = amend(e, {
            year: !1,
            month: !1,
            day: !1,
            weekday: !1,
            timeZoneName: !1,
            dateStyle: !1
        });
        if ("long" !== t.timeStyle && "full" !== t.timeStyle || (delete t.timeStyle, Object.assign(t, {
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit"
        })), !hasTimeOptions(t)) {
            if (hasAnyDateTimeOptions(e)) throw new TypeError("cannot format Temporal.PlainTime with options [".concat(Object.keys(e), "]"));
            Object.assign(t, {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            });
        }
        return t;
    }
    function yearMonthAmend(e) {
        var t = amend(e, {
            day: !1,
            hour: !1,
            minute: !1,
            second: !1,
            weekday: !1,
            dayPeriod: !1,
            timeZoneName: !1,
            timeStyle: !1
        });
        if ("dateStyle" in t && t.dateStyle) {
            var n = t.dateStyle;
            delete t.dateStyle, Object.assign(t, {
                short: {
                    year: "2-digit",
                    month: "numeric"
                },
                medium: {
                    year: "numeric",
                    month: "short"
                },
                long: {
                    year: "numeric",
                    month: "long"
                },
                full: {
                    year: "numeric",
                    month: "long"
                }
            }[n]);
        }
        if (!("year" in t || "month" in t || "era" in t)) {
            if (hasAnyDateTimeOptions(e)) throw new TypeError("cannot format PlainYearMonth with options [".concat(Object.keys(e), "]"));
            Object.assign(t, {
                year: "numeric",
                month: "numeric"
            });
        }
        return t;
    }
    function monthDayAmend(e) {
        var t = amend(e, {
            year: !1,
            hour: !1,
            minute: !1,
            second: !1,
            weekday: !1,
            dayPeriod: !1,
            timeZoneName: !1,
            timeStyle: !1
        });
        if ("dateStyle" in t && t.dateStyle) {
            var n = t.dateStyle;
            delete t.dateStyle, Object.assign(t, {
                short: {
                    month: "numeric",
                    day: "numeric"
                },
                medium: {
                    month: "short",
                    day: "numeric"
                },
                long: {
                    month: "long",
                    day: "numeric"
                },
                full: {
                    month: "long",
                    day: "numeric"
                }
            }[n]);
        }
        if (!("month" in t) && !("day" in t)) {
            if (hasAnyDateTimeOptions(e)) throw new TypeError("cannot format PlainMonthDay with options [".concat(Object.keys(e), "]"));
            Object.assign(t, {
                month: "numeric",
                day: "numeric"
            });
        }
        return t;
    }
    function dateAmend(e) {
        var t = amend(e, {
            hour: !1,
            minute: !1,
            second: !1,
            dayPeriod: !1,
            timeZoneName: !1,
            timeStyle: !1
        });
        if (!hasDateOptions(t)) {
            if (hasAnyDateTimeOptions(e)) throw new TypeError("cannot format PlainDate with options [".concat(Object.keys(e), "]"));
            Object.assign(t, {
                year: "numeric",
                month: "numeric",
                day: "numeric"
            });
        }
        return t;
    }
    function datetimeAmend(e) {
        var t = amend(e, {
            timeZoneName: !1
        });
        if ("long" !== t.timeStyle && "full" !== t.timeStyle || (delete t.timeStyle, Object.assign(t, {
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit"
        }), !t.dateStyle) || (Object.assign(t, {
            short: {
                year: "numeric",
                month: "numeric",
                day: "numeric"
            },
            medium: {
                year: "numeric",
                month: "short",
                day: "numeric"
            },
            long: {
                year: "numeric",
                month: "long",
                day: "numeric"
            },
            full: {
                year: "numeric",
                month: "long",
                day: "numeric",
                weekday: "long"
            }
        }[t.dateStyle]), delete t.dateStyle), !hasTimeOptions(t) && !hasDateOptions(t)) {
            if (hasAnyDateTimeOptions(e)) throw new TypeError("cannot format PlainDateTime with options [".concat(Object.keys(e), "]"));
            Object.assign(t, {
                year: "numeric",
                month: "numeric",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            });
        }
        return t;
    }
    function instantAmend(e) {
        var t = e;
        return hasTimeOptions(t) || hasDateOptions(t) || (t = Object.assign({}, t, {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric"
        })), t;
    }
    function hasDateOptions(e) {
        return "year" in e || "month" in e || "day" in e || "weekday" in e || "dateStyle" in e || "era" in e;
    }
    function hasTimeOptions(e) {
        return "hour" in e || "minute" in e || "second" in e || "timeStyle" in e || "dayPeriod" in e || "fractionalSecondDigits" in e;
    }
    function hasAnyDateTimeOptions(e) {
        return hasDateOptions(e) || hasTimeOptions(e) || "dateStyle" in e || "timeStyle" in e || "timeZoneName" in e;
    }
    function isTemporalObject(e) {
        return IsTemporalDate(e) || IsTemporalTime(e) || IsTemporalDateTime(e) || IsTemporalZonedDateTime(e) || IsTemporalYearMonth(e) || IsTemporalMonthDay(e) || IsTemporalInstant(e);
    }
    function toDateTimeFormattable(e) {
        return isTemporalObject(e) ? e : ToNumber(e);
    }
    function sameTemporalType(e, t) {
        return !(!isTemporalObject(e) || !isTemporalObject(t) || IsTemporalTime(e) && !IsTemporalTime(t) || IsTemporalDate(e) && !IsTemporalDate(t) || IsTemporalDateTime(e) && !IsTemporalDateTime(t) || IsTemporalZonedDateTime(e) && !IsTemporalZonedDateTime(t) || IsTemporalYearMonth(e) && !IsTemporalYearMonth(t) || IsTemporalMonthDay(e) && !IsTemporalMonthDay(t) || IsTemporalInstant(e) && !IsTemporalInstant(t));
    }
    function extractOverrides(e, t) {
        if (IsTemporalTime(e)) {
            var n = {
                isoDate: {
                    year: 1970,
                    month: 1,
                    day: 1
                },
                time: GetSlot(e, y)
            };
            return {
                epochNs: GetEpochNanosecondsFor(GetSlot(t, U), n, "compatible"),
                formatter: getSlotLazy(t, Y)
            };
        }
        if (IsTemporalYearMonth(e)) {
            var r = GetSlot(e, T), a = GetSlot(t, H);
            if (r !== a) throw new RangeError("cannot format PlainYearMonth with calendar ".concat(r, " in locale with calendar ").concat(a));
            var o = CombineISODateAndTimeRecord(GetSlot(e, D), {
                deltaDays: 0,
                hour: 12,
                minute: 0,
                second: 0,
                millisecond: 0,
                microsecond: 0,
                nanosecond: 0
            });
            return {
                epochNs: GetEpochNanosecondsFor(GetSlot(t, U), o, "compatible"),
                formatter: getSlotLazy(t, j)
            };
        }
        if (IsTemporalMonthDay(e)) {
            var i = GetSlot(e, T), u = GetSlot(t, H);
            if (i !== u) throw new RangeError("cannot format PlainMonthDay with calendar ".concat(i, " in locale with calendar ").concat(u));
            var s = CombineISODateAndTimeRecord(GetSlot(e, D), {
                deltaDays: 0,
                hour: 12,
                minute: 0,
                second: 0,
                millisecond: 0,
                microsecond: 0,
                nanosecond: 0
            });
            return {
                epochNs: GetEpochNanosecondsFor(GetSlot(t, U), s, "compatible"),
                formatter: getSlotLazy(t, N)
            };
        }
        if (IsTemporalDate(e)) {
            var l = GetSlot(e, T), c = GetSlot(t, H);
            if ("iso8601" !== l && l !== c) throw new RangeError("cannot format PlainDate with calendar ".concat(l, " in locale with calendar ").concat(c));
            var d = CombineISODateAndTimeRecord(GetSlot(e, D), {
                deltaDays: 0,
                hour: 12,
                minute: 0,
                second: 0,
                millisecond: 0,
                microsecond: 0,
                nanosecond: 0
            });
            return {
                epochNs: GetEpochNanosecondsFor(GetSlot(t, U), d, "compatible"),
                formatter: getSlotLazy(t, P)
            };
        }
        if (IsTemporalDateTime(e)) {
            var m = GetSlot(e, T), h = GetSlot(t, H);
            if ("iso8601" !== m && m !== h) throw new RangeError("cannot format PlainDateTime with calendar ".concat(m, " in locale with calendar ").concat(h));
            var f = GetSlot(e, g);
            return {
                epochNs: GetEpochNanosecondsFor(GetSlot(t, U), f, "compatible"),
                formatter: getSlotLazy(t, J)
            };
        }
        if (IsTemporalZonedDateTime(e)) throw new TypeError("Temporal.ZonedDateTime not supported in DateTimeFormat methods. Use toLocaleString() instead.");
        return IsTemporalInstant(e) ? {
            epochNs: GetSlot(e, v),
            formatter: getSlotLazy(t, L)
        } : {};
    }
    function temporalDurationToCompatibilityRecord(e) {
        var t = Object.create(null);
        return t.years = GetSlot(e, O), t.months = GetSlot(e, b), t.weeks = GetSlot(e, w), t.days = GetSlot(e, k), t.hours = GetSlot(e, E), t.minutes = GetSlot(e, B), t.seconds = GetSlot(e, R), t.milliseconds = GetSlot(e, G), t.microseconds = GetSlot(e, M), t.nanoseconds = GetSlot(e, A), t;
    }
    Jt.prototype.constructor = Lt, Object.defineProperty(Lt, "prototype", {
        value: Jt.prototype,
        writable: !1,
        enumerable: !1,
        configurable: !1
    }), Lt.supportedLocalesOf = Yt.supportedLocalesOf, MakeIntrinsicClass(Lt, "Intl.DateTimeFormat");
    var Zt = null !== (mt = null === (ht = Intl.DurationFormat) || void 0 === ht ? void 0 : ht.prototype) && void 0 !== mt ? mt : Object.create(null), Ut = Zt.format, xt = Zt.formatToParts;
    function ModifiedIntlDurationFormatPrototypeFormat(e) {
        Intl.DurationFormat.prototype.resolvedOptions.call(this);
        var t = temporalDurationToCompatibilityRecord(ToTemporalDuration(e));
        return Ut.call(this, t);
    }
    null !== (ft = Intl.DurationFormat) && void 0 !== ft && ft.prototype && (Intl.DurationFormat.prototype.format = ModifiedIntlDurationFormatPrototypeFormat, Intl.DurationFormat.prototype.formatToParts = function formatToParts(e) {
        Intl.DurationFormat.prototype.resolvedOptions.call(this);
        var t = temporalDurationToCompatibilityRecord(ToTemporalDuration(e));
        return xt.call(this, t);
    });
    var Ht = Object.freeze({
        __proto__: null,
        DateTimeFormat: Lt,
        ModifiedIntlDurationFormatPrototypeFormat: ModifiedIntlDurationFormatPrototypeFormat
    }), Wt = function() {
        function Instant(e) {
            if (_classCallCheck(this, Instant), arguments.length < 1) throw new TypeError("missing argument: epochNanoseconds is required");
            CreateTemporalInstantSlots(this, ToBigInt(e));
        }
        return _createClass(Instant, [
            {
                key: "epochMilliseconds",
                get: function get() {
                    return CheckReceiver(this, IsTemporalInstant), epochNsToMs(GetSlot(this, v), "floor");
                }
            },
            {
                key: "epochNanoseconds",
                get: function get() {
                    return CheckReceiver(this, IsTemporalInstant), ToBigIntExternal(t.BigInt(GetSlot(this, v)));
                }
            },
            {
                key: "add",
                value: function add(e) {
                    return CheckReceiver(this, IsTemporalInstant), AddDurationToInstant("add", this, e);
                }
            },
            {
                key: "subtract",
                value: function subtract(e) {
                    return CheckReceiver(this, IsTemporalInstant), AddDurationToInstant("subtract", this, e);
                }
            },
            {
                key: "until",
                value: function until(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    return CheckReceiver(this, IsTemporalInstant), DifferenceTemporalInstant("until", this, e, t);
                }
            },
            {
                key: "since",
                value: function since(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    return CheckReceiver(this, IsTemporalInstant), DifferenceTemporalInstant("since", this, e, t);
                }
            },
            {
                key: "round",
                value: function round(e) {
                    if (CheckReceiver(this, IsTemporalInstant), void 0 === e) throw new TypeError("options parameter is required");
                    var t = "string" == typeof e ? CreateOnePropObject("smallestUnit", e) : GetOptionsObject(e), n = GetTemporalRoundingIncrementOption(t), r = GetRoundingModeOption(t, "halfExpand"), a = GetTemporalUnitValuedOption(t, "smallestUnit", "time", We);
                    return ValidateTemporalRoundingIncrement(n, {
                        hour: 24,
                        minute: 1440,
                        second: 86400,
                        millisecond: 864e5,
                        microsecond: 864e8,
                        nanosecond: 864e11
                    }[a], !0), CreateTemporalInstant(RoundTemporalInstant(GetSlot(this, v), n, a, r));
                }
            },
            {
                key: "equals",
                value: function equals(e) {
                    CheckReceiver(this, IsTemporalInstant);
                    var n = ToTemporalInstant(e), r = GetSlot(this, v), a = GetSlot(n, v);
                    return t.equal(t.BigInt(r), t.BigInt(a));
                }
            },
            {
                key: "toString",
                value: function toString() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0;
                    CheckReceiver(this, IsTemporalInstant);
                    var t = GetOptionsObject(e), n = GetTemporalFractionalSecondDigitsOption(t), r = GetRoundingModeOption(t, "trunc"), a = GetTemporalUnitValuedOption(t, "smallestUnit", "time", void 0);
                    if ("hour" === a) throw new RangeError('smallestUnit must be a time unit other than "hour"');
                    var o = t.timeZone;
                    void 0 !== o && (o = ToTemporalTimeZoneIdentifier(o));
                    var i = ToSecondsStringPrecisionRecord(a, n), u = i.precision, s = i.unit, l = i.increment;
                    return TemporalInstantToString(CreateTemporalInstant(RoundTemporalInstant(GetSlot(this, v), l, s, r)), o, u);
                }
            },
            {
                key: "toJSON",
                value: function toJSON() {
                    return CheckReceiver(this, IsTemporalInstant), TemporalInstantToString(this, void 0, "auto");
                }
            },
            {
                key: "toLocaleString",
                value: function toLocaleString() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    return CheckReceiver(this, IsTemporalInstant), new Lt(e, t).format(this);
                }
            },
            {
                key: "valueOf",
                value: function valueOf() {
                    ValueOfThrows("Instant");
                }
            },
            {
                key: "toZonedDateTimeISO",
                value: function toZonedDateTimeISO(e) {
                    CheckReceiver(this, IsTemporalInstant);
                    var t = ToTemporalTimeZoneIdentifier(e);
                    return CreateTemporalZonedDateTime(GetSlot(this, v), t, "iso8601");
                }
            }
        ], [
            {
                key: "fromEpochMilliseconds",
                value: function fromEpochMilliseconds(e) {
                    return CreateTemporalInstant(epochMsToNs(ToNumber(e)));
                }
            },
            {
                key: "fromEpochNanoseconds",
                value: function fromEpochNanoseconds(e) {
                    return CreateTemporalInstant(ToBigInt(e));
                }
            },
            {
                key: "from",
                value: function from(e) {
                    return ToTemporalInstant(e);
                }
            },
            {
                key: "compare",
                value: function compare(e, n) {
                    var r = ToTemporalInstant(e), a = ToTemporalInstant(n), o = GetSlot(r, v), i = GetSlot(a, v);
                    return t.lessThan(o, i) ? -1 : t.greaterThan(o, i) ? 1 : 0;
                }
            }
        ]), Instant;
    }();
    MakeIntrinsicClass(Wt, "Temporal.Instant");
    var zt = function() {
        function PlainDate(e, t, n) {
            var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "iso8601";
            _classCallCheck(this, PlainDate);
            var a = ToIntegerWithTruncation(e), o = ToIntegerWithTruncation(t), i = ToIntegerWithTruncation(n), u = CanonicalizeCalendar(void 0 === r ? "iso8601" : RequireString(r));
            RejectISODate(a, o, i), CreateTemporalDateSlots(this, {
                year: a,
                month: o,
                day: i
            }, u);
        }
        return _createClass(PlainDate, [
            {
                key: "calendarId",
                get: function get() {
                    return CheckReceiver(this, IsTemporalDate), GetSlot(this, T);
                }
            },
            {
                key: "era",
                get: function get() {
                    return getCalendarProperty$4(this, "era");
                }
            },
            {
                key: "eraYear",
                get: function get() {
                    return getCalendarProperty$4(this, "eraYear");
                }
            },
            {
                key: "year",
                get: function get() {
                    return getCalendarProperty$4(this, "year");
                }
            },
            {
                key: "month",
                get: function get() {
                    return getCalendarProperty$4(this, "month");
                }
            },
            {
                key: "monthCode",
                get: function get() {
                    return getCalendarProperty$4(this, "monthCode");
                }
            },
            {
                key: "day",
                get: function get() {
                    return getCalendarProperty$4(this, "day");
                }
            },
            {
                key: "dayOfWeek",
                get: function get() {
                    return getCalendarProperty$4(this, "dayOfWeek");
                }
            },
            {
                key: "dayOfYear",
                get: function get() {
                    return getCalendarProperty$4(this, "dayOfYear");
                }
            },
            {
                key: "weekOfYear",
                get: function get() {
                    var e;
                    return null === (e = getCalendarProperty$4(this, "weekOfYear")) || void 0 === e ? void 0 : e.week;
                }
            },
            {
                key: "yearOfWeek",
                get: function get() {
                    var e;
                    return null === (e = getCalendarProperty$4(this, "weekOfYear")) || void 0 === e ? void 0 : e.year;
                }
            },
            {
                key: "daysInWeek",
                get: function get() {
                    return getCalendarProperty$4(this, "daysInWeek");
                }
            },
            {
                key: "daysInMonth",
                get: function get() {
                    return getCalendarProperty$4(this, "daysInMonth");
                }
            },
            {
                key: "daysInYear",
                get: function get() {
                    return getCalendarProperty$4(this, "daysInYear");
                }
            },
            {
                key: "monthsInYear",
                get: function get() {
                    return getCalendarProperty$4(this, "monthsInYear");
                }
            },
            {
                key: "inLeapYear",
                get: function get() {
                    return getCalendarProperty$4(this, "inLeapYear");
                }
            },
            {
                key: "with",
                value: function _with(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    if (CheckReceiver(this, IsTemporalDate), !IsObject(e)) throw new TypeError("invalid argument");
                    RejectTemporalLikeObject(e);
                    var n = GetSlot(this, T), r = ISODateToFields(n, GetSlot(this, D));
                    return CreateTemporalDate(CalendarDateFromFields(n, r = CalendarMergeFields(n, r, PrepareCalendarFields(n, e, [
                        "year",
                        "month",
                        "monthCode",
                        "day"
                    ], [], "partial")), GetTemporalOverflowOption(GetOptionsObject(t))), n);
                }
            },
            {
                key: "withCalendar",
                value: function withCalendar(e) {
                    CheckReceiver(this, IsTemporalDate);
                    var t = ToTemporalCalendarIdentifier(e);
                    return CreateTemporalDate(GetSlot(this, D), t);
                }
            },
            {
                key: "add",
                value: function add(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    return CheckReceiver(this, IsTemporalDate), AddDurationToDate("add", this, e, t);
                }
            },
            {
                key: "subtract",
                value: function subtract(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    return CheckReceiver(this, IsTemporalDate), AddDurationToDate("subtract", this, e, t);
                }
            },
            {
                key: "until",
                value: function until(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    return CheckReceiver(this, IsTemporalDate), DifferenceTemporalPlainDate("until", this, e, t);
                }
            },
            {
                key: "since",
                value: function since(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    return CheckReceiver(this, IsTemporalDate), DifferenceTemporalPlainDate("since", this, e, t);
                }
            },
            {
                key: "equals",
                value: function equals(e) {
                    CheckReceiver(this, IsTemporalDate);
                    var t = ToTemporalDate(e);
                    return 0 === CompareISODate(GetSlot(this, D), GetSlot(t, D)) && CalendarEquals(GetSlot(this, T), GetSlot(t, T));
                }
            },
            {
                key: "toString",
                value: function toString() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0;
                    return CheckReceiver(this, IsTemporalDate), TemporalDateToString(this, GetTemporalShowCalendarNameOption(GetOptionsObject(e)));
                }
            },
            {
                key: "toJSON",
                value: function toJSON() {
                    return CheckReceiver(this, IsTemporalDate), TemporalDateToString(this);
                }
            },
            {
                key: "toLocaleString",
                value: function toLocaleString() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    return CheckReceiver(this, IsTemporalDate), new Lt(e, t).format(this);
                }
            },
            {
                key: "valueOf",
                value: function valueOf() {
                    ValueOfThrows("PlainDate");
                }
            },
            {
                key: "toPlainDateTime",
                value: function toPlainDateTime() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0;
                    CheckReceiver(this, IsTemporalDate);
                    var t = ToTimeRecordOrMidnight(e);
                    return CreateTemporalDateTime(CombineISODateAndTimeRecord(GetSlot(this, D), t), GetSlot(this, T));
                }
            },
            {
                key: "toZonedDateTime",
                value: function toZonedDateTime(e) {
                    var t, n;
                    if (CheckReceiver(this, IsTemporalDate), IsObject(e)) {
                        var r = e.timeZone;
                        void 0 === r ? t = ToTemporalTimeZoneIdentifier(e) : (t = ToTemporalTimeZoneIdentifier(r), n = e.plainTime);
                    } else t = ToTemporalTimeZoneIdentifier(e);
                    var a = GetSlot(this, D);
                    return CreateTemporalZonedDateTime(void 0 === n ? GetStartOfDay(t, a) : GetEpochNanosecondsFor(t, CombineISODateAndTimeRecord(a, GetSlot(n = ToTemporalTime(n), y)), "compatible"), t, GetSlot(this, T));
                }
            },
            {
                key: "toPlainYearMonth",
                value: function toPlainYearMonth() {
                    CheckReceiver(this, IsTemporalDate);
                    var e = GetSlot(this, T);
                    return CreateTemporalYearMonth(CalendarYearMonthFromFields(e, ISODateToFields(e, GetSlot(this, D)), "constrain"), e);
                }
            },
            {
                key: "toPlainMonthDay",
                value: function toPlainMonthDay() {
                    CheckReceiver(this, IsTemporalDate);
                    var e = GetSlot(this, T);
                    return CreateTemporalMonthDay(CalendarMonthDayFromFields(e, ISODateToFields(e, GetSlot(this, D)), "constrain"), e);
                }
            }
        ], [
            {
                key: "from",
                value: function from(e) {
                    return ToTemporalDate(e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0);
                }
            },
            {
                key: "compare",
                value: function compare(e, t) {
                    var n = ToTemporalDate(e), r = ToTemporalDate(t);
                    return CompareISODate(GetSlot(n, D), GetSlot(r, D));
                }
            }
        ]), PlainDate;
    }();
    function getCalendarProperty$4(e, t) {
        CheckReceiver(e, IsTemporalDate);
        var n = GetSlot(e, D);
        return calendarImplForObj(e).isoToDate(n, _defineProperty({}, t, !0))[t];
    }
    MakeIntrinsicClass(zt, "Temporal.PlainDate");
    var qt = function() {
        function PlainDateTime(e, t, n) {
            var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0, a = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0, o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0, i = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : 0, u = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : 0, s = arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : 0, l = arguments.length > 9 && void 0 !== arguments[9] ? arguments[9] : "iso8601";
            _classCallCheck(this, PlainDateTime);
            var c = ToIntegerWithTruncation(e), d = ToIntegerWithTruncation(t), m = ToIntegerWithTruncation(n), h = void 0 === r ? 0 : ToIntegerWithTruncation(r), f = void 0 === a ? 0 : ToIntegerWithTruncation(a), p = void 0 === o ? 0 : ToIntegerWithTruncation(o), v = void 0 === i ? 0 : ToIntegerWithTruncation(i), D = void 0 === u ? 0 : ToIntegerWithTruncation(u), g = void 0 === s ? 0 : ToIntegerWithTruncation(s), y = CanonicalizeCalendar(void 0 === l ? "iso8601" : RequireString(l));
            RejectDateTime(c, d, m, h, f, p, v, D, g), CreateTemporalDateTimeSlots(this, {
                isoDate: {
                    year: c,
                    month: d,
                    day: m
                },
                time: {
                    hour: h,
                    minute: f,
                    second: p,
                    millisecond: v,
                    microsecond: D,
                    nanosecond: g
                }
            }, y);
        }
        return _createClass(PlainDateTime, [
            {
                key: "calendarId",
                get: function get() {
                    return CheckReceiver(this, IsTemporalDateTime), GetSlot(this, T);
                }
            },
            {
                key: "year",
                get: function get() {
                    return getCalendarProperty$3(this, "year");
                }
            },
            {
                key: "month",
                get: function get() {
                    return getCalendarProperty$3(this, "month");
                }
            },
            {
                key: "monthCode",
                get: function get() {
                    return getCalendarProperty$3(this, "monthCode");
                }
            },
            {
                key: "day",
                get: function get() {
                    return getCalendarProperty$3(this, "day");
                }
            },
            {
                key: "hour",
                get: function get() {
                    return getTimeProperty$1(this, "hour");
                }
            },
            {
                key: "minute",
                get: function get() {
                    return getTimeProperty$1(this, "minute");
                }
            },
            {
                key: "second",
                get: function get() {
                    return getTimeProperty$1(this, "second");
                }
            },
            {
                key: "millisecond",
                get: function get() {
                    return getTimeProperty$1(this, "millisecond");
                }
            },
            {
                key: "microsecond",
                get: function get() {
                    return getTimeProperty$1(this, "microsecond");
                }
            },
            {
                key: "nanosecond",
                get: function get() {
                    return getTimeProperty$1(this, "nanosecond");
                }
            },
            {
                key: "era",
                get: function get() {
                    return getCalendarProperty$3(this, "era");
                }
            },
            {
                key: "eraYear",
                get: function get() {
                    return getCalendarProperty$3(this, "eraYear");
                }
            },
            {
                key: "dayOfWeek",
                get: function get() {
                    return getCalendarProperty$3(this, "dayOfWeek");
                }
            },
            {
                key: "dayOfYear",
                get: function get() {
                    return getCalendarProperty$3(this, "dayOfYear");
                }
            },
            {
                key: "weekOfYear",
                get: function get() {
                    var e;
                    return null === (e = getCalendarProperty$3(this, "weekOfYear")) || void 0 === e ? void 0 : e.week;
                }
            },
            {
                key: "yearOfWeek",
                get: function get() {
                    var e;
                    return null === (e = getCalendarProperty$3(this, "weekOfYear")) || void 0 === e ? void 0 : e.year;
                }
            },
            {
                key: "daysInWeek",
                get: function get() {
                    return getCalendarProperty$3(this, "daysInWeek");
                }
            },
            {
                key: "daysInYear",
                get: function get() {
                    return getCalendarProperty$3(this, "daysInYear");
                }
            },
            {
                key: "daysInMonth",
                get: function get() {
                    return getCalendarProperty$3(this, "daysInMonth");
                }
            },
            {
                key: "monthsInYear",
                get: function get() {
                    return getCalendarProperty$3(this, "monthsInYear");
                }
            },
            {
                key: "inLeapYear",
                get: function get() {
                    return getCalendarProperty$3(this, "inLeapYear");
                }
            },
            {
                key: "with",
                value: function _with(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    if (CheckReceiver(this, IsTemporalDateTime), !IsObject(e)) throw new TypeError("invalid argument");
                    RejectTemporalLikeObject(e);
                    var n = GetSlot(this, T), r = GetSlot(this, g), a = _objectSpread2(_objectSpread2({}, ISODateToFields(n, r.isoDate)), r.time);
                    return CreateTemporalDateTime(InterpretTemporalDateTimeFields(n, a = CalendarMergeFields(n, a, PrepareCalendarFields(n, e, [
                        "year",
                        "month",
                        "monthCode",
                        "day"
                    ], [
                        "hour",
                        "minute",
                        "second",
                        "millisecond",
                        "microsecond",
                        "nanosecond"
                    ], "partial")), GetTemporalOverflowOption(GetOptionsObject(t))), n);
                }
            },
            {
                key: "withPlainTime",
                value: function withPlainTime() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0;
                    CheckReceiver(this, IsTemporalDateTime);
                    var t = ToTimeRecordOrMidnight(e);
                    return CreateTemporalDateTime(CombineISODateAndTimeRecord(GetSlot(this, g).isoDate, t), GetSlot(this, T));
                }
            },
            {
                key: "withCalendar",
                value: function withCalendar(e) {
                    CheckReceiver(this, IsTemporalDateTime);
                    var t = ToTemporalCalendarIdentifier(e);
                    return CreateTemporalDateTime(GetSlot(this, g), t);
                }
            },
            {
                key: "add",
                value: function add(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    return CheckReceiver(this, IsTemporalDateTime), AddDurationToDateTime("add", this, e, t);
                }
            },
            {
                key: "subtract",
                value: function subtract(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    return CheckReceiver(this, IsTemporalDateTime), AddDurationToDateTime("subtract", this, e, t);
                }
            },
            {
                key: "until",
                value: function until(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    return CheckReceiver(this, IsTemporalDateTime), DifferenceTemporalPlainDateTime("until", this, e, t);
                }
            },
            {
                key: "since",
                value: function since(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    return CheckReceiver(this, IsTemporalDateTime), DifferenceTemporalPlainDateTime("since", this, e, t);
                }
            },
            {
                key: "round",
                value: function round(e) {
                    if (CheckReceiver(this, IsTemporalDateTime), void 0 === e) throw new TypeError("options parameter is required");
                    var t = "string" == typeof e ? CreateOnePropObject("smallestUnit", e) : GetOptionsObject(e), n = GetTemporalRoundingIncrementOption(t), r = GetRoundingModeOption(t, "halfExpand"), a = GetTemporalUnitValuedOption(t, "smallestUnit", "time", We, [
                        "day"
                    ]), o = {
                        day: 1,
                        hour: 24,
                        minute: 60,
                        second: 60,
                        millisecond: 1e3,
                        microsecond: 1e3,
                        nanosecond: 1e3
                    }[a];
                    ValidateTemporalRoundingIncrement(n, o, 1 === o);
                    var i = GetSlot(this, g);
                    return CreateTemporalDateTime(1 === n && "nanosecond" === a ? i : RoundISODateTime(i, n, a, r), GetSlot(this, T));
                }
            },
            {
                key: "equals",
                value: function equals(e) {
                    CheckReceiver(this, IsTemporalDateTime);
                    var t = ToTemporalDateTime(e);
                    return 0 === CompareISODateTime(GetSlot(this, g), GetSlot(t, g)) && CalendarEquals(GetSlot(this, T), GetSlot(t, T));
                }
            },
            {
                key: "toString",
                value: function toString() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0;
                    CheckReceiver(this, IsTemporalDateTime);
                    var t = GetOptionsObject(e), n = GetTemporalShowCalendarNameOption(t), r = GetTemporalFractionalSecondDigitsOption(t), a = GetRoundingModeOption(t, "trunc"), o = GetTemporalUnitValuedOption(t, "smallestUnit", "time", void 0);
                    if ("hour" === o) throw new RangeError('smallestUnit must be a time unit other than "hour"');
                    var i = ToSecondsStringPrecisionRecord(o, r), u = i.precision, s = i.unit, l = i.increment, c = RoundISODateTime(GetSlot(this, g), l, s, a);
                    return RejectDateTimeRange(c), ISODateTimeToString(c, GetSlot(this, T), u, n);
                }
            },
            {
                key: "toJSON",
                value: function toJSON() {
                    return CheckReceiver(this, IsTemporalDateTime), ISODateTimeToString(GetSlot(this, g), GetSlot(this, T), "auto");
                }
            },
            {
                key: "toLocaleString",
                value: function toLocaleString() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    return CheckReceiver(this, IsTemporalDateTime), new Lt(e, t).format(this);
                }
            },
            {
                key: "valueOf",
                value: function valueOf() {
                    ValueOfThrows("PlainDateTime");
                }
            },
            {
                key: "toZonedDateTime",
                value: function toZonedDateTime(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    CheckReceiver(this, IsTemporalDateTime);
                    var n = ToTemporalTimeZoneIdentifier(e), r = GetTemporalDisambiguationOption(GetOptionsObject(t));
                    return CreateTemporalZonedDateTime(GetEpochNanosecondsFor(n, GetSlot(this, g), r), n, GetSlot(this, T));
                }
            },
            {
                key: "toPlainDate",
                value: function toPlainDate() {
                    return CheckReceiver(this, IsTemporalDateTime), CreateTemporalDate(GetSlot(this, g).isoDate, GetSlot(this, T));
                }
            },
            {
                key: "toPlainTime",
                value: function toPlainTime() {
                    return CheckReceiver(this, IsTemporalDateTime), CreateTemporalTime(GetSlot(this, g).time);
                }
            }
        ], [
            {
                key: "from",
                value: function from(e) {
                    return ToTemporalDateTime(e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0);
                }
            },
            {
                key: "compare",
                value: function compare(e, t) {
                    var n = ToTemporalDateTime(e), r = ToTemporalDateTime(t);
                    return CompareISODateTime(GetSlot(n, g), GetSlot(r, g));
                }
            }
        ]), PlainDateTime;
    }();
    function getCalendarProperty$3(e, t) {
        CheckReceiver(e, IsTemporalDateTime);
        var n = GetSlot(e, g).isoDate;
        return calendarImplForObj(e).isoToDate(n, _defineProperty({}, t, !0))[t];
    }
    function getTimeProperty$1(e, t) {
        return CheckReceiver(e, IsTemporalDateTime), GetSlot(e, g).time[t];
    }
    MakeIntrinsicClass(qt, "Temporal.PlainDateTime");
    var $t = function() {
        function Duration() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0, a = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0, o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0, i = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : 0, u = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : 0, s = arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : 0, l = arguments.length > 9 && void 0 !== arguments[9] ? arguments[9] : 0;
            _classCallCheck(this, Duration);
            var c = void 0 === e ? 0 : ToIntegerIfIntegral(e), d = void 0 === t ? 0 : ToIntegerIfIntegral(t), m = void 0 === n ? 0 : ToIntegerIfIntegral(n), h = void 0 === r ? 0 : ToIntegerIfIntegral(r), f = void 0 === a ? 0 : ToIntegerIfIntegral(a), p = void 0 === o ? 0 : ToIntegerIfIntegral(o), v = void 0 === i ? 0 : ToIntegerIfIntegral(i), D = void 0 === u ? 0 : ToIntegerIfIntegral(u), g = void 0 === s ? 0 : ToIntegerIfIntegral(s), y = void 0 === l ? 0 : ToIntegerIfIntegral(l);
            RejectDuration(c, d, m, h, f, p, v, D, g, y), Q(this), SetSlot(this, O, c), SetSlot(this, b, d), SetSlot(this, w, m), SetSlot(this, k, h), SetSlot(this, E, f), SetSlot(this, B, p), SetSlot(this, R, v), SetSlot(this, G, D), SetSlot(this, M, g), SetSlot(this, A, y);
        }
        return _createClass(Duration, [
            {
                key: "years",
                get: function get() {
                    return CheckReceiver(this, IsTemporalDuration), GetSlot(this, O);
                }
            },
            {
                key: "months",
                get: function get() {
                    return CheckReceiver(this, IsTemporalDuration), GetSlot(this, b);
                }
            },
            {
                key: "weeks",
                get: function get() {
                    return CheckReceiver(this, IsTemporalDuration), GetSlot(this, w);
                }
            },
            {
                key: "days",
                get: function get() {
                    return CheckReceiver(this, IsTemporalDuration), GetSlot(this, k);
                }
            },
            {
                key: "hours",
                get: function get() {
                    return CheckReceiver(this, IsTemporalDuration), GetSlot(this, E);
                }
            },
            {
                key: "minutes",
                get: function get() {
                    return CheckReceiver(this, IsTemporalDuration), GetSlot(this, B);
                }
            },
            {
                key: "seconds",
                get: function get() {
                    return CheckReceiver(this, IsTemporalDuration), GetSlot(this, R);
                }
            },
            {
                key: "milliseconds",
                get: function get() {
                    return CheckReceiver(this, IsTemporalDuration), GetSlot(this, G);
                }
            },
            {
                key: "microseconds",
                get: function get() {
                    return CheckReceiver(this, IsTemporalDuration), GetSlot(this, M);
                }
            },
            {
                key: "nanoseconds",
                get: function get() {
                    return CheckReceiver(this, IsTemporalDuration), GetSlot(this, A);
                }
            },
            {
                key: "sign",
                get: function get() {
                    return CheckReceiver(this, IsTemporalDuration), DurationSign(this);
                }
            },
            {
                key: "blank",
                get: function get() {
                    return CheckReceiver(this, IsTemporalDuration), 0 === DurationSign(this);
                }
            },
            {
                key: "with",
                value: function _with(e) {
                    CheckReceiver(this, IsTemporalDuration);
                    var t = ToTemporalPartialDurationRecord(e), n = t.years, r = void 0 === n ? GetSlot(this, O) : n, a = t.months, o = void 0 === a ? GetSlot(this, b) : a, i = t.weeks, u = void 0 === i ? GetSlot(this, w) : i, s = t.days, l = void 0 === s ? GetSlot(this, k) : s, c = t.hours, d = void 0 === c ? GetSlot(this, E) : c, m = t.minutes, h = void 0 === m ? GetSlot(this, B) : m, f = t.seconds, p = void 0 === f ? GetSlot(this, R) : f, v = t.milliseconds, D = void 0 === v ? GetSlot(this, G) : v, g = t.microseconds, y = void 0 === g ? GetSlot(this, M) : g, T = t.nanoseconds;
                    return new Duration(r, o, u, l, d, h, p, D, y, void 0 === T ? GetSlot(this, A) : T);
                }
            },
            {
                key: "negated",
                value: function negated() {
                    return CheckReceiver(this, IsTemporalDuration), CreateNegatedTemporalDuration(this);
                }
            },
            {
                key: "abs",
                value: function abs() {
                    return CheckReceiver(this, IsTemporalDuration), new Duration(Math.abs(GetSlot(this, O)), Math.abs(GetSlot(this, b)), Math.abs(GetSlot(this, w)), Math.abs(GetSlot(this, k)), Math.abs(GetSlot(this, E)), Math.abs(GetSlot(this, B)), Math.abs(GetSlot(this, R)), Math.abs(GetSlot(this, G)), Math.abs(GetSlot(this, M)), Math.abs(GetSlot(this, A)));
                }
            },
            {
                key: "add",
                value: function add(e) {
                    return CheckReceiver(this, IsTemporalDuration), AddDurations("add", this, e);
                }
            },
            {
                key: "subtract",
                value: function subtract(e) {
                    return CheckReceiver(this, IsTemporalDuration), AddDurations("subtract", this, e);
                }
            },
            {
                key: "round",
                value: function round(e) {
                    if (CheckReceiver(this, IsTemporalDuration), void 0 === e) throw new TypeError("options parameter is required");
                    var t = DefaultTemporalLargestUnit(this), n = "string" == typeof e ? CreateOnePropObject("smallestUnit", e) : GetOptionsObject(e), r = GetTemporalUnitValuedOption(n, "largestUnit", "datetime", void 0, [
                        "auto"
                    ]), a = GetTemporalRelativeToOption(n), o = a.plainRelativeTo, i = a.zonedRelativeTo, u = GetTemporalRoundingIncrementOption(n), s = GetRoundingModeOption(n, "halfExpand"), l = GetTemporalUnitValuedOption(n, "smallestUnit", "datetime", void 0), c = !0;
                    l || (c = !1, l = "nanosecond");
                    var d = LargerOfTwoTemporalUnits(t, l), m = !0;
                    if (r || (m = !1, r = d), "auto" === r && (r = d), !c && !m) throw new RangeError("at least one of smallestUnit or largestUnit is required");
                    if (LargerOfTwoTemporalUnits(r, l) !== r) throw new RangeError("largestUnit ".concat(r, " cannot be smaller than smallestUnit ").concat(l));
                    var h = {
                        hour: 24,
                        minute: 60,
                        second: 60,
                        millisecond: 1e3,
                        microsecond: 1e3,
                        nanosecond: 1e3
                    }[l];
                    if (void 0 !== h && ValidateTemporalRoundingIncrement(u, h, !1), u > 1 && "date" === TemporalUnitCategory(l) && r !== l) throw new RangeError("For calendar units with roundingIncrement > 1, use largestUnit = smallestUnit");
                    if (i) {
                        var f = ToInternalDurationRecord(this), p = GetSlot(i, _), g = GetSlot(i, T), y = GetSlot(i, v);
                        return f = DifferenceZonedDateTimeWithRounding(y, AddZonedDateTime(y, p, g, f), p, g, r, u, l, s), "date" === TemporalUnitCategory(r) && (r = "hour"), TemporalDurationFromInternal(f, r);
                    }
                    if (o) {
                        var S = ToInternalDurationRecordWith24HourDays(this), I = AddTime({
                            deltaDays: 0,
                            hour: 0,
                            minute: 0,
                            second: 0,
                            millisecond: 0,
                            microsecond: 0,
                            nanosecond: 0
                        }, S.time), C = GetSlot(o, D), O = GetSlot(o, T), b = CalendarDateAdd(O, C, AdjustDateDurationRecord(S.date, I.deltaDays), "constrain");
                        return TemporalDurationFromInternal(S = DifferencePlainDateTimeWithRounding(CombineISODateAndTimeRecord(C, {
                            deltaDays: 0,
                            hour: 0,
                            minute: 0,
                            second: 0,
                            millisecond: 0,
                            microsecond: 0,
                            nanosecond: 0
                        }), CombineISODateAndTimeRecord(b, I), O, r, u, l, s), r);
                    }
                    if (IsCalendarUnit(t)) throw new RangeError("a starting point is required for ".concat(t, "s balancing"));
                    if (IsCalendarUnit(r)) throw new RangeError("a starting point is required for ".concat(r, "s balancing"));
                    var w = ToInternalDurationRecordWith24HourDays(this);
                    if ("day" === l) {
                        var k = w.time.divmod(Te), E = k.quotient, B = k.remainder, R = w.date.days + E + TotalTimeDuration(B, "day");
                        w = CombineDateAndTimeDuration({
                            years: 0,
                            months: 0,
                            weeks: 0,
                            days: R = RoundNumberToIncrement(R, u, s)
                        }, te.ZERO);
                    } else w = CombineDateAndTimeDuration({
                        years: 0,
                        months: 0,
                        weeks: 0,
                        days: 0
                    }, RoundTimeDuration(w.time, u, l, s));
                    return TemporalDurationFromInternal(w, r);
                }
            },
            {
                key: "total",
                value: function total(e) {
                    if (CheckReceiver(this, IsTemporalDuration), void 0 === e) throw new TypeError("options argument is required");
                    var n = "string" == typeof e ? CreateOnePropObject("unit", e) : GetOptionsObject(e), r = GetTemporalRelativeToOption(n), a = r.plainRelativeTo, o = r.zonedRelativeTo, i = GetTemporalUnitValuedOption(n, "unit", "datetime", We);
                    if (o) {
                        var u = ToInternalDurationRecord(this), s = GetSlot(o, _), l = GetSlot(o, T), c = GetSlot(o, v);
                        return function DifferenceZonedDateTimeWithTotal(e, t, n, r, a) {
                            return "time" === TemporalUnitCategory(a) ? TotalTimeDuration(te.fromEpochNsDiff(t, e), a) : TotalRelativeDuration(DifferenceZonedDateTime(e, t, n, r, a), t, GetISODateTimeFor(n, e), n, r, a);
                        }(c, AddZonedDateTime(c, s, l, u), s, l, i);
                    }
                    if (a) {
                        var d = ToInternalDurationRecordWith24HourDays(this), m = AddTime({
                            deltaDays: 0,
                            hour: 0,
                            minute: 0,
                            second: 0,
                            millisecond: 0,
                            microsecond: 0,
                            nanosecond: 0
                        }, d.time), h = GetSlot(a, D), f = GetSlot(a, T), p = CalendarDateAdd(f, h, AdjustDateDurationRecord(d.date, m.deltaDays), "constrain");
                        return function DifferencePlainDateTimeWithTotal(e, n, r, a) {
                            if (0 == CompareISODateTime(e, n)) return 0;
                            RejectDateTimeRange(e), RejectDateTimeRange(n);
                            var o = DifferenceISODateTime(e, n, r, a);
                            return "nanosecond" === a ? t.toNumber(o.time.totalNs) : TotalRelativeDuration(o, GetUTCEpochNanoseconds(n), e, null, r, a);
                        }(CombineISODateAndTimeRecord(h, {
                            deltaDays: 0,
                            hour: 0,
                            minute: 0,
                            second: 0,
                            millisecond: 0,
                            microsecond: 0,
                            nanosecond: 0
                        }), CombineISODateAndTimeRecord(p, m), f, i);
                    }
                    var g = DefaultTemporalLargestUnit(this);
                    if (IsCalendarUnit(g)) throw new RangeError("a starting point is required for ".concat(g, "s total"));
                    if (IsCalendarUnit(i)) throw new RangeError("a starting point is required for ".concat(i, "s total"));
                    return TotalTimeDuration(ToInternalDurationRecordWith24HourDays(this).time, i);
                }
            },
            {
                key: "toString",
                value: function toString() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0;
                    CheckReceiver(this, IsTemporalDuration);
                    var t = GetOptionsObject(e), n = GetTemporalFractionalSecondDigitsOption(t), r = GetRoundingModeOption(t, "trunc"), a = GetTemporalUnitValuedOption(t, "smallestUnit", "time", void 0);
                    if ("hour" === a || "minute" === a) throw new RangeError('smallestUnit must be a time unit other than "hours" or "minutes"');
                    var o = ToSecondsStringPrecisionRecord(a, n), i = o.precision, u = o.unit, s = o.increment;
                    if ("nanosecond" === u && 1 === s) return TemporalDurationToString(this, i);
                    var l = DefaultTemporalLargestUnit(this), c = ToInternalDurationRecord(this), d = RoundTimeDuration(c.time, s, u, r);
                    return TemporalDurationToString(TemporalDurationFromInternal(c = CombineDateAndTimeDuration(c.date, d), LargerOfTwoTemporalUnits(l, "second")), i);
                }
            },
            {
                key: "toJSON",
                value: function toJSON() {
                    return CheckReceiver(this, IsTemporalDuration), TemporalDurationToString(this, "auto");
                }
            },
            {
                key: "toLocaleString",
                value: function toLocaleString() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    if (CheckReceiver(this, IsTemporalDuration), "function" == typeof Intl.DurationFormat) {
                        var n = new Intl.DurationFormat(e, t);
                        return ModifiedIntlDurationFormatPrototypeFormat.call(n, this);
                    }
                    return console.warn("Temporal.Duration.prototype.toLocaleString() requires Intl.DurationFormat."), TemporalDurationToString(this, "auto");
                }
            },
            {
                key: "valueOf",
                value: function valueOf() {
                    ValueOfThrows("Duration");
                }
            }
        ], [
            {
                key: "from",
                value: function from(e) {
                    return ToTemporalDuration(e);
                }
            },
            {
                key: "compare",
                value: function compare(e, n) {
                    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0, a = ToTemporalDuration(e), o = ToTemporalDuration(n), i = GetTemporalRelativeToOption(GetOptionsObject(r)), u = i.plainRelativeTo, s = i.zonedRelativeTo;
                    if (GetSlot(a, O) === GetSlot(o, O) && GetSlot(a, b) === GetSlot(o, b) && GetSlot(a, w) === GetSlot(o, w) && GetSlot(a, k) === GetSlot(o, k) && GetSlot(a, E) === GetSlot(o, E) && GetSlot(a, B) === GetSlot(o, B) && GetSlot(a, R) === GetSlot(o, R) && GetSlot(a, G) === GetSlot(o, G) && GetSlot(a, M) === GetSlot(o, M) && GetSlot(a, A) === GetSlot(o, A)) return 0;
                    var l = DefaultTemporalLargestUnit(a), c = DefaultTemporalLargestUnit(o), d = ToInternalDurationRecord(a), m = ToInternalDurationRecord(o);
                    if (s && ("date" === TemporalUnitCategory(l) || "date" === TemporalUnitCategory(c))) {
                        var h = GetSlot(s, _), f = GetSlot(s, T), p = GetSlot(s, v), D = AddZonedDateTime(p, h, f, d), g = AddZonedDateTime(p, h, f, m);
                        return ComparisonResult(t.toNumber(t.subtract(D, g)));
                    }
                    var y = d.date.days, S = m.date.days;
                    if (IsCalendarUnit(l) || IsCalendarUnit(c)) {
                        if (!u) throw new RangeError("A starting point is required for years, months, or weeks comparison");
                        y = DateDurationDays(d.date, u), S = DateDurationDays(m.date, u);
                    }
                    var I = d.time.add24HourDays(y), C = m.time.add24HourDays(S);
                    return I.cmp(C);
                }
            }
        ]), Duration;
    }();
    MakeIntrinsicClass($t, "Temporal.Duration");
    var Vt = function() {
        function PlainMonthDay(e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "iso8601", r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1972;
            _classCallCheck(this, PlainMonthDay);
            var a = ToIntegerWithTruncation(e), o = ToIntegerWithTruncation(t), i = CanonicalizeCalendar(void 0 === n ? "iso8601" : RequireString(n)), u = ToIntegerWithTruncation(r);
            RejectISODate(u, a, o), CreateTemporalMonthDaySlots(this, {
                year: u,
                month: a,
                day: o
            }, i);
        }
        return _createClass(PlainMonthDay, [
            {
                key: "monthCode",
                get: function get() {
                    return getCalendarProperty$2(this, "monthCode");
                }
            },
            {
                key: "day",
                get: function get() {
                    return getCalendarProperty$2(this, "day");
                }
            },
            {
                key: "calendarId",
                get: function get() {
                    return CheckReceiver(this, IsTemporalMonthDay), GetSlot(this, T);
                }
            },
            {
                key: "with",
                value: function _with(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    if (CheckReceiver(this, IsTemporalMonthDay), !IsObject(e)) throw new TypeError("invalid argument");
                    RejectTemporalLikeObject(e);
                    var n = GetSlot(this, T), r = ISODateToFields(n, GetSlot(this, D), "month-day");
                    return CreateTemporalMonthDay(CalendarMonthDayFromFields(n, r = CalendarMergeFields(n, r, PrepareCalendarFields(n, e, [
                        "year",
                        "month",
                        "monthCode",
                        "day"
                    ], [], "partial")), GetTemporalOverflowOption(GetOptionsObject(t))), n);
                }
            },
            {
                key: "equals",
                value: function equals(e) {
                    CheckReceiver(this, IsTemporalMonthDay);
                    var t = ToTemporalMonthDay(e);
                    return 0 === CompareISODate(GetSlot(this, D), GetSlot(t, D)) && CalendarEquals(GetSlot(this, T), GetSlot(t, T));
                }
            },
            {
                key: "toString",
                value: function toString() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0;
                    return CheckReceiver(this, IsTemporalMonthDay), TemporalMonthDayToString(this, GetTemporalShowCalendarNameOption(GetOptionsObject(e)));
                }
            },
            {
                key: "toJSON",
                value: function toJSON() {
                    return CheckReceiver(this, IsTemporalMonthDay), TemporalMonthDayToString(this);
                }
            },
            {
                key: "toLocaleString",
                value: function toLocaleString() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    return CheckReceiver(this, IsTemporalMonthDay), new Lt(e, t).format(this);
                }
            },
            {
                key: "valueOf",
                value: function valueOf() {
                    ValueOfThrows("PlainMonthDay");
                }
            },
            {
                key: "toPlainDate",
                value: function toPlainDate(e) {
                    if (CheckReceiver(this, IsTemporalMonthDay), !IsObject(e)) throw new TypeError("argument should be an object");
                    var t = GetSlot(this, T);
                    return CreateTemporalDate(CalendarDateFromFields(t, CalendarMergeFields(t, ISODateToFields(t, GetSlot(this, D), "month-day"), PrepareCalendarFields(t, e, [
                        "year"
                    ], [], [])), "constrain"), t);
                }
            }
        ], [
            {
                key: "from",
                value: function from(e) {
                    return ToTemporalMonthDay(e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0);
                }
            }
        ]), PlainMonthDay;
    }();
    function getCalendarProperty$2(e, t) {
        CheckReceiver(e, IsTemporalMonthDay);
        var n = GetSlot(e, D);
        return calendarImplForObj(e).isoToDate(n, _defineProperty({}, t, !0))[t];
    }
    function SystemDateTime(e) {
        return GetISODateTimeFor(e, Ve());
    }
    MakeIntrinsicClass(Vt, "Temporal.PlainMonthDay");
    var Kt = _defineProperty({
        instant: function instant() {
            return CreateTemporalInstant(Ve());
        },
        plainDateTimeISO: function plainDateTimeISO() {
            return CreateTemporalDateTime(SystemDateTime(ToTemporalTimeZoneIdentifier(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : DefaultTimeZone())), "iso8601");
        },
        plainDateISO: function plainDateISO() {
            return CreateTemporalDate(SystemDateTime(ToTemporalTimeZoneIdentifier(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : DefaultTimeZone())).isoDate, "iso8601");
        },
        plainTimeISO: function plainTimeISO() {
            return CreateTemporalTime(SystemDateTime(ToTemporalTimeZoneIdentifier(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : DefaultTimeZone())).time);
        },
        timeZoneId: function timeZoneId() {
            return DefaultTimeZone();
        },
        zonedDateTimeISO: function zonedDateTimeISO() {
            var e = ToTemporalTimeZoneIdentifier(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : DefaultTimeZone());
            return CreateTemporalZonedDateTime(Ve(), e, "iso8601");
        }
    }, Symbol.toStringTag, "Temporal.Now");
    Object.defineProperty(Kt, Symbol.toStringTag, {
        value: "Temporal.Now",
        writable: !1,
        enumerable: !1,
        configurable: !0
    });
    var Xt = function() {
        function PlainTime() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0, a = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0, o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0;
            _classCallCheck(this, PlainTime);
            var i = void 0 === e ? 0 : ToIntegerWithTruncation(e), u = void 0 === t ? 0 : ToIntegerWithTruncation(t), s = void 0 === n ? 0 : ToIntegerWithTruncation(n), l = void 0 === r ? 0 : ToIntegerWithTruncation(r), c = void 0 === a ? 0 : ToIntegerWithTruncation(a), d = void 0 === o ? 0 : ToIntegerWithTruncation(o);
            RejectTime(i, u, s, l, c, d), CreateTemporalTimeSlots(this, {
                hour: i,
                minute: u,
                second: s,
                millisecond: l,
                microsecond: c,
                nanosecond: d
            });
        }
        return _createClass(PlainTime, [
            {
                key: "hour",
                get: function get() {
                    return CheckReceiver(this, IsTemporalTime), GetSlot(this, y).hour;
                }
            },
            {
                key: "minute",
                get: function get() {
                    return CheckReceiver(this, IsTemporalTime), GetSlot(this, y).minute;
                }
            },
            {
                key: "second",
                get: function get() {
                    return CheckReceiver(this, IsTemporalTime), GetSlot(this, y).second;
                }
            },
            {
                key: "millisecond",
                get: function get() {
                    return CheckReceiver(this, IsTemporalTime), GetSlot(this, y).millisecond;
                }
            },
            {
                key: "microsecond",
                get: function get() {
                    return CheckReceiver(this, IsTemporalTime), GetSlot(this, y).microsecond;
                }
            },
            {
                key: "nanosecond",
                get: function get() {
                    return CheckReceiver(this, IsTemporalTime), GetSlot(this, y).nanosecond;
                }
            },
            {
                key: "with",
                value: function _with(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    if (CheckReceiver(this, IsTemporalTime), !IsObject(e)) throw new TypeError("invalid argument");
                    RejectTemporalLikeObject(e);
                    var n = ToTemporalTimeRecord(e, "partial"), r = ToTemporalTimeRecord(this), a = Object.assign(r, n), o = a.hour, i = a.minute, u = a.second, s = a.millisecond, l = a.microsecond, c = a.nanosecond, d = RegulateTime(o, i, u, s, l, c, GetTemporalOverflowOption(GetOptionsObject(t)));
                    return new PlainTime(o = d.hour, i = d.minute, u = d.second, s = d.millisecond, l = d.microsecond, c = d.nanosecond);
                }
            },
            {
                key: "add",
                value: function add(e) {
                    return CheckReceiver(this, IsTemporalTime), AddDurationToTime("add", this, e);
                }
            },
            {
                key: "subtract",
                value: function subtract(e) {
                    return CheckReceiver(this, IsTemporalTime), AddDurationToTime("subtract", this, e);
                }
            },
            {
                key: "until",
                value: function until(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    return CheckReceiver(this, IsTemporalTime), DifferenceTemporalPlainTime("until", this, e, t);
                }
            },
            {
                key: "since",
                value: function since(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    return CheckReceiver(this, IsTemporalTime), DifferenceTemporalPlainTime("since", this, e, t);
                }
            },
            {
                key: "round",
                value: function round(e) {
                    if (CheckReceiver(this, IsTemporalTime), void 0 === e) throw new TypeError("options parameter is required");
                    var t = "string" == typeof e ? CreateOnePropObject("smallestUnit", e) : GetOptionsObject(e), n = GetTemporalRoundingIncrementOption(t), r = GetRoundingModeOption(t, "halfExpand"), a = GetTemporalUnitValuedOption(t, "smallestUnit", "time", We);
                    return ValidateTemporalRoundingIncrement(n, {
                        hour: 24,
                        minute: 60,
                        second: 60,
                        millisecond: 1e3,
                        microsecond: 1e3,
                        nanosecond: 1e3
                    }[a], !1), CreateTemporalTime(RoundTime(GetSlot(this, y), n, a, r));
                }
            },
            {
                key: "equals",
                value: function equals(e) {
                    CheckReceiver(this, IsTemporalTime);
                    var t = ToTemporalTime(e);
                    return 0 === CompareTimeRecord(GetSlot(this, y), GetSlot(t, y));
                }
            },
            {
                key: "toString",
                value: function toString() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0;
                    CheckReceiver(this, IsTemporalTime);
                    var t = GetOptionsObject(e), n = GetTemporalFractionalSecondDigitsOption(t), r = GetRoundingModeOption(t, "trunc"), a = GetTemporalUnitValuedOption(t, "smallestUnit", "time", void 0);
                    if ("hour" === a) throw new RangeError('smallestUnit must be a time unit other than "hour"');
                    var o = ToSecondsStringPrecisionRecord(a, n), i = o.precision, u = o.unit, s = o.increment;
                    return TimeRecordToString(RoundTime(GetSlot(this, y), s, u, r), i);
                }
            },
            {
                key: "toJSON",
                value: function toJSON() {
                    return CheckReceiver(this, IsTemporalTime), TimeRecordToString(GetSlot(this, y), "auto");
                }
            },
            {
                key: "toLocaleString",
                value: function toLocaleString() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    return CheckReceiver(this, IsTemporalTime), new Lt(e, t).format(this);
                }
            },
            {
                key: "valueOf",
                value: function valueOf() {
                    ValueOfThrows("PlainTime");
                }
            }
        ], [
            {
                key: "from",
                value: function from(e) {
                    return ToTemporalTime(e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0);
                }
            },
            {
                key: "compare",
                value: function compare(e, t) {
                    var n = ToTemporalTime(e), r = ToTemporalTime(t);
                    return CompareTimeRecord(GetSlot(n, y), GetSlot(r, y));
                }
            }
        ]), PlainTime;
    }();
    MakeIntrinsicClass(Xt, "Temporal.PlainTime");
    var Qt = function() {
        function PlainYearMonth(e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "iso8601", r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
            _classCallCheck(this, PlainYearMonth);
            var a = ToIntegerWithTruncation(e), o = ToIntegerWithTruncation(t), i = CanonicalizeCalendar(void 0 === n ? "iso8601" : RequireString(n)), u = ToIntegerWithTruncation(r);
            RejectISODate(a, o, u), CreateTemporalYearMonthSlots(this, {
                year: a,
                month: o,
                day: u
            }, i);
        }
        return _createClass(PlainYearMonth, [
            {
                key: "year",
                get: function get() {
                    return getCalendarProperty$1(this, "year");
                }
            },
            {
                key: "month",
                get: function get() {
                    return getCalendarProperty$1(this, "month");
                }
            },
            {
                key: "monthCode",
                get: function get() {
                    return getCalendarProperty$1(this, "monthCode");
                }
            },
            {
                key: "calendarId",
                get: function get() {
                    return CheckReceiver(this, IsTemporalYearMonth), GetSlot(this, T);
                }
            },
            {
                key: "era",
                get: function get() {
                    return getCalendarProperty$1(this, "era");
                }
            },
            {
                key: "eraYear",
                get: function get() {
                    return getCalendarProperty$1(this, "eraYear");
                }
            },
            {
                key: "daysInMonth",
                get: function get() {
                    return getCalendarProperty$1(this, "daysInMonth");
                }
            },
            {
                key: "daysInYear",
                get: function get() {
                    return getCalendarProperty$1(this, "daysInYear");
                }
            },
            {
                key: "monthsInYear",
                get: function get() {
                    return getCalendarProperty$1(this, "monthsInYear");
                }
            },
            {
                key: "inLeapYear",
                get: function get() {
                    return getCalendarProperty$1(this, "inLeapYear");
                }
            },
            {
                key: "with",
                value: function _with(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    if (CheckReceiver(this, IsTemporalYearMonth), !IsObject(e)) throw new TypeError("invalid argument");
                    RejectTemporalLikeObject(e);
                    var n = GetSlot(this, T), r = ISODateToFields(n, GetSlot(this, D), "year-month");
                    return CreateTemporalYearMonth(CalendarYearMonthFromFields(n, r = CalendarMergeFields(n, r, PrepareCalendarFields(n, e, [
                        "year",
                        "month",
                        "monthCode"
                    ], [], "partial")), GetTemporalOverflowOption(GetOptionsObject(t))), n);
                }
            },
            {
                key: "add",
                value: function add(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    return CheckReceiver(this, IsTemporalYearMonth), AddDurationToYearMonth("add", this, e, t);
                }
            },
            {
                key: "subtract",
                value: function subtract(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    return CheckReceiver(this, IsTemporalYearMonth), AddDurationToYearMonth("subtract", this, e, t);
                }
            },
            {
                key: "until",
                value: function until(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    return CheckReceiver(this, IsTemporalYearMonth), DifferenceTemporalPlainYearMonth("until", this, e, t);
                }
            },
            {
                key: "since",
                value: function since(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    return CheckReceiver(this, IsTemporalYearMonth), DifferenceTemporalPlainYearMonth("since", this, e, t);
                }
            },
            {
                key: "equals",
                value: function equals(e) {
                    CheckReceiver(this, IsTemporalYearMonth);
                    var t = ToTemporalYearMonth(e);
                    return 0 === CompareISODate(GetSlot(this, D), GetSlot(t, D)) && CalendarEquals(GetSlot(this, T), GetSlot(t, T));
                }
            },
            {
                key: "toString",
                value: function toString() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0;
                    return CheckReceiver(this, IsTemporalYearMonth), TemporalYearMonthToString(this, GetTemporalShowCalendarNameOption(GetOptionsObject(e)));
                }
            },
            {
                key: "toJSON",
                value: function toJSON() {
                    return CheckReceiver(this, IsTemporalYearMonth), TemporalYearMonthToString(this);
                }
            },
            {
                key: "toLocaleString",
                value: function toLocaleString() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    return CheckReceiver(this, IsTemporalYearMonth), new Lt(e, t).format(this);
                }
            },
            {
                key: "valueOf",
                value: function valueOf() {
                    ValueOfThrows("PlainYearMonth");
                }
            },
            {
                key: "toPlainDate",
                value: function toPlainDate(e) {
                    if (CheckReceiver(this, IsTemporalYearMonth), !IsObject(e)) throw new TypeError("argument should be an object");
                    var t = GetSlot(this, T);
                    return CreateTemporalDate(CalendarDateFromFields(t, CalendarMergeFields(t, ISODateToFields(t, GetSlot(this, D), "year-month"), PrepareCalendarFields(t, e, [
                        "day"
                    ], [], [])), "constrain"), t);
                }
            }
        ], [
            {
                key: "from",
                value: function from(e) {
                    return ToTemporalYearMonth(e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0);
                }
            },
            {
                key: "compare",
                value: function compare(e, t) {
                    var n = ToTemporalYearMonth(e), r = ToTemporalYearMonth(t);
                    return CompareISODate(GetSlot(n, D), GetSlot(r, D));
                }
            }
        ]), PlainYearMonth;
    }();
    function getCalendarProperty$1(e, t) {
        CheckReceiver(e, IsTemporalYearMonth);
        var n = GetSlot(e, D);
        return calendarImplForObj(e).isoToDate(n, _defineProperty({}, t, !0))[t];
    }
    MakeIntrinsicClass(Qt, "Temporal.PlainYearMonth");
    var en = Lt.prototype.resolvedOptions, tn = function() {
        function ZonedDateTime(e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "iso8601";
            if (_classCallCheck(this, ZonedDateTime), arguments.length < 1) throw new TypeError("missing argument: epochNanoseconds is required");
            var r = ToBigInt(e), a = RequireString(t), o = ParseTimeZoneIdentifier(a), i = o.tzName, u = o.offsetMinutes;
            if (void 0 === u) {
                var s = GetAvailableNamedTimeZoneIdentifier(i);
                if (!s) throw new RangeError("unknown time zone ".concat(i));
                a = s.identifier;
            } else a = FormatOffsetTimeZoneIdentifier(u);
            CreateTemporalZonedDateTimeSlots(this, r, a, CanonicalizeCalendar(void 0 === n ? "iso8601" : RequireString(n)));
        }
        return _createClass(ZonedDateTime, [
            {
                key: "calendarId",
                get: function get() {
                    return CheckReceiver(this, IsTemporalZonedDateTime), GetSlot(this, T);
                }
            },
            {
                key: "timeZoneId",
                get: function get() {
                    return CheckReceiver(this, IsTemporalZonedDateTime), GetSlot(this, _);
                }
            },
            {
                key: "year",
                get: function get() {
                    return getCalendarProperty(this, "year");
                }
            },
            {
                key: "month",
                get: function get() {
                    return getCalendarProperty(this, "month");
                }
            },
            {
                key: "monthCode",
                get: function get() {
                    return getCalendarProperty(this, "monthCode");
                }
            },
            {
                key: "day",
                get: function get() {
                    return getCalendarProperty(this, "day");
                }
            },
            {
                key: "hour",
                get: function get() {
                    return getTimeProperty(this, "hour");
                }
            },
            {
                key: "minute",
                get: function get() {
                    return getTimeProperty(this, "minute");
                }
            },
            {
                key: "second",
                get: function get() {
                    return getTimeProperty(this, "second");
                }
            },
            {
                key: "millisecond",
                get: function get() {
                    return getTimeProperty(this, "millisecond");
                }
            },
            {
                key: "microsecond",
                get: function get() {
                    return getTimeProperty(this, "microsecond");
                }
            },
            {
                key: "nanosecond",
                get: function get() {
                    return getTimeProperty(this, "nanosecond");
                }
            },
            {
                key: "era",
                get: function get() {
                    return getCalendarProperty(this, "era");
                }
            },
            {
                key: "eraYear",
                get: function get() {
                    return getCalendarProperty(this, "eraYear");
                }
            },
            {
                key: "epochMilliseconds",
                get: function get() {
                    return CheckReceiver(this, IsTemporalZonedDateTime), epochNsToMs(GetSlot(this, v), "floor");
                }
            },
            {
                key: "epochNanoseconds",
                get: function get() {
                    return CheckReceiver(this, IsTemporalZonedDateTime), ToBigIntExternal(GetSlot(this, v));
                }
            },
            {
                key: "dayOfWeek",
                get: function get() {
                    return getCalendarProperty(this, "dayOfWeek");
                }
            },
            {
                key: "dayOfYear",
                get: function get() {
                    return getCalendarProperty(this, "dayOfYear");
                }
            },
            {
                key: "weekOfYear",
                get: function get() {
                    var e;
                    return null === (e = getCalendarProperty(this, "weekOfYear")) || void 0 === e ? void 0 : e.week;
                }
            },
            {
                key: "yearOfWeek",
                get: function get() {
                    var e;
                    return null === (e = getCalendarProperty(this, "weekOfYear")) || void 0 === e ? void 0 : e.year;
                }
            },
            {
                key: "hoursInDay",
                get: function get() {
                    CheckReceiver(this, IsTemporalZonedDateTime);
                    var e = GetSlot(this, _), t = dateTime(this).isoDate, n = BalanceISODate(t.year, t.month, t.day + 1), r = GetStartOfDay(e, t), a = GetStartOfDay(e, n);
                    return TotalTimeDuration(te.fromEpochNsDiff(a, r), "hour");
                }
            },
            {
                key: "daysInWeek",
                get: function get() {
                    return getCalendarProperty(this, "daysInWeek");
                }
            },
            {
                key: "daysInMonth",
                get: function get() {
                    return getCalendarProperty(this, "daysInMonth");
                }
            },
            {
                key: "daysInYear",
                get: function get() {
                    return getCalendarProperty(this, "daysInYear");
                }
            },
            {
                key: "monthsInYear",
                get: function get() {
                    return getCalendarProperty(this, "monthsInYear");
                }
            },
            {
                key: "inLeapYear",
                get: function get() {
                    return getCalendarProperty(this, "inLeapYear");
                }
            },
            {
                key: "offset",
                get: function get() {
                    return CheckReceiver(this, IsTemporalZonedDateTime), FormatUTCOffsetNanoseconds(GetOffsetNanosecondsFor(GetSlot(this, _), GetSlot(this, v)));
                }
            },
            {
                key: "offsetNanoseconds",
                get: function get() {
                    return CheckReceiver(this, IsTemporalZonedDateTime), GetOffsetNanosecondsFor(GetSlot(this, _), GetSlot(this, v));
                }
            },
            {
                key: "with",
                value: function _with(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    if (CheckReceiver(this, IsTemporalZonedDateTime), !IsObject(e)) throw new TypeError("invalid zoned-date-time-like");
                    RejectTemporalLikeObject(e);
                    var n = GetSlot(this, T), r = GetSlot(this, _), a = GetOffsetNanosecondsFor(r, GetSlot(this, v)), o = dateTime(this), i = _objectSpread2(_objectSpread2(_objectSpread2({}, ISODateToFields(n, o.isoDate)), o.time), {}, {
                        offset: FormatUTCOffsetNanoseconds(a)
                    });
                    i = CalendarMergeFields(n, i, PrepareCalendarFields(n, e, [
                        "year",
                        "month",
                        "monthCode",
                        "day"
                    ], [
                        "hour",
                        "minute",
                        "second",
                        "millisecond",
                        "microsecond",
                        "nanosecond",
                        "offset"
                    ], "partial"));
                    var u = GetOptionsObject(t), s = GetTemporalDisambiguationOption(u), l = GetTemporalOffsetOption(u, "prefer"), c = InterpretTemporalDateTimeFields(n, i, GetTemporalOverflowOption(u)), d = ParseDateTimeUTCOffset(i.offset);
                    return CreateTemporalZonedDateTime(InterpretISODateTimeOffset(c.isoDate, c.time, "option", d, r, s, l, !1), r, n);
                }
            },
            {
                key: "withPlainTime",
                value: function withPlainTime() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0;
                    CheckReceiver(this, IsTemporalZonedDateTime);
                    var t = GetSlot(this, _), n = GetSlot(this, T), r = dateTime(this).isoDate;
                    return CreateTemporalZonedDateTime(void 0 === e ? GetStartOfDay(t, r) : GetEpochNanosecondsFor(t, CombineISODateAndTimeRecord(r, GetSlot(ToTemporalTime(e), y)), "compatible"), t, n);
                }
            },
            {
                key: "withTimeZone",
                value: function withTimeZone(e) {
                    CheckReceiver(this, IsTemporalZonedDateTime);
                    var t = ToTemporalTimeZoneIdentifier(e);
                    return CreateTemporalZonedDateTime(GetSlot(this, v), t, GetSlot(this, T));
                }
            },
            {
                key: "withCalendar",
                value: function withCalendar(e) {
                    CheckReceiver(this, IsTemporalZonedDateTime);
                    var t = ToTemporalCalendarIdentifier(e);
                    return CreateTemporalZonedDateTime(GetSlot(this, v), GetSlot(this, _), t);
                }
            },
            {
                key: "add",
                value: function add(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    return CheckReceiver(this, IsTemporalZonedDateTime), AddDurationToZonedDateTime("add", this, e, t);
                }
            },
            {
                key: "subtract",
                value: function subtract(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    return CheckReceiver(this, IsTemporalZonedDateTime), AddDurationToZonedDateTime("subtract", this, e, t);
                }
            },
            {
                key: "until",
                value: function until(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    return CheckReceiver(this, IsTemporalZonedDateTime), DifferenceTemporalZonedDateTime("until", this, e, t);
                }
            },
            {
                key: "since",
                value: function since(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    return CheckReceiver(this, IsTemporalZonedDateTime), DifferenceTemporalZonedDateTime("since", this, e, t);
                }
            },
            {
                key: "round",
                value: function round(e) {
                    if (CheckReceiver(this, IsTemporalZonedDateTime), void 0 === e) throw new TypeError("options parameter is required");
                    var n = "string" == typeof e ? CreateOnePropObject("smallestUnit", e) : GetOptionsObject(e), r = GetTemporalRoundingIncrementOption(n), a = GetRoundingModeOption(n, "halfExpand"), o = GetTemporalUnitValuedOption(n, "smallestUnit", "time", We, [
                        "day"
                    ]), i = {
                        day: 1,
                        hour: 24,
                        minute: 60,
                        second: 60,
                        millisecond: 1e3,
                        microsecond: 1e3,
                        nanosecond: 1e3
                    }[o];
                    if (ValidateTemporalRoundingIncrement(r, i, 1 === i), "nanosecond" === o && 1 === r) return CreateTemporalZonedDateTime(GetSlot(this, v), GetSlot(this, _), GetSlot(this, T));
                    var u, s = GetSlot(this, _), l = GetSlot(this, v), c = dateTime(this);
                    if ("day" === o) {
                        var d = c.isoDate, m = BalanceISODate(d.year, d.month, d.day + 1), h = GetStartOfDay(s, d), f = GetStartOfDay(s, m), p = t.subtract(f, h);
                        u = te.fromEpochNsDiff(l, h).round(p, a).addToEpochNs(h);
                    } else {
                        var D = RoundISODateTime(c, r, o, a), g = GetOffsetNanosecondsFor(s, l);
                        u = InterpretISODateTimeOffset(D.isoDate, D.time, "option", g, s, "compatible", "prefer", !1);
                    }
                    return CreateTemporalZonedDateTime(u, s, GetSlot(this, T));
                }
            },
            {
                key: "equals",
                value: function equals(e) {
                    CheckReceiver(this, IsTemporalZonedDateTime);
                    var n = ToTemporalZonedDateTime(e), r = GetSlot(this, v), a = GetSlot(n, v);
                    return !!t.equal(t.BigInt(r), t.BigInt(a)) && !!TimeZoneEquals(GetSlot(this, _), GetSlot(n, _)) && CalendarEquals(GetSlot(this, T), GetSlot(n, T));
                }
            },
            {
                key: "toString",
                value: function toString() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0;
                    CheckReceiver(this, IsTemporalZonedDateTime);
                    var t = GetOptionsObject(e), n = GetTemporalShowCalendarNameOption(t), r = GetTemporalFractionalSecondDigitsOption(t), a = function GetTemporalShowOffsetOption(e) {
                        return GetOption(e, "offset", [
                            "auto",
                            "never"
                        ], "auto");
                    }(t), o = GetRoundingModeOption(t, "trunc"), i = GetTemporalUnitValuedOption(t, "smallestUnit", "time", void 0);
                    if ("hour" === i) throw new RangeError('smallestUnit must be a time unit other than "hour"');
                    var u = function GetTemporalShowTimeZoneNameOption(e) {
                        return GetOption(e, "timeZoneName", [
                            "auto",
                            "never",
                            "critical"
                        ], "auto");
                    }(t), s = ToSecondsStringPrecisionRecord(i, r);
                    return TemporalZonedDateTimeToString(this, s.precision, n, u, a, {
                        unit: s.unit,
                        increment: s.increment,
                        roundingMode: o
                    });
                }
            },
            {
                key: "toLocaleString",
                value: function toLocaleString() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    CheckReceiver(this, IsTemporalZonedDateTime);
                    var n = GetOptionsObject(t), r = Object.create(null);
                    if (function CopyDataProperties(e, t, n, r) {
                        if (null != t) for(var a = Reflect.ownKeys(t), o = function _loop() {
                            var o = a[i];
                            if (n.some(function(e) {
                                return Object.is(e, o);
                            })) return "continue";
                            if (Object.prototype.propertyIsEnumerable.call(t, o)) {
                                var u = t[o];
                                if (r && r.some(function(e) {
                                    return Object.is(e, u);
                                })) return "continue";
                                e[o] = u;
                            }
                        }, i = 0; i < a.length; i++)o();
                    }(r, n, [
                        "timeZone"
                    ]), void 0 !== n.timeZone) throw new TypeError("ZonedDateTime toLocaleString does not accept a timeZone option");
                    if (void 0 === r.year && void 0 === r.month && void 0 === r.day && void 0 === r.era && void 0 === r.weekday && void 0 === r.dateStyle && void 0 === r.hour && void 0 === r.minute && void 0 === r.second && void 0 === r.fractionalSecondDigits && void 0 === r.timeStyle && void 0 === r.dayPeriod && void 0 === r.timeZoneName && (r.timeZoneName = "short"), r.timeZone = GetSlot(this, _), IsOffsetTimeZoneIdentifier(r.timeZone)) throw new RangeError("toLocaleString does not currently support offset time zones");
                    var a = new Lt(e, r), o = en.call(a).calendar, i = GetSlot(this, T);
                    if ("iso8601" !== i && "iso8601" !== o && !CalendarEquals(o, i)) throw new RangeError("cannot format ZonedDateTime with calendar ".concat(i) + " in locale with calendar ".concat(o));
                    return a.format(CreateTemporalInstant(GetSlot(this, v)));
                }
            },
            {
                key: "toJSON",
                value: function toJSON() {
                    return CheckReceiver(this, IsTemporalZonedDateTime), TemporalZonedDateTimeToString(this, "auto");
                }
            },
            {
                key: "valueOf",
                value: function valueOf() {
                    ValueOfThrows("ZonedDateTime");
                }
            },
            {
                key: "startOfDay",
                value: function startOfDay() {
                    CheckReceiver(this, IsTemporalZonedDateTime);
                    var e = GetSlot(this, _);
                    return CreateTemporalZonedDateTime(GetStartOfDay(e, dateTime(this).isoDate), e, GetSlot(this, T));
                }
            },
            {
                key: "getTimeZoneTransition",
                value: function getTimeZoneTransition(e) {
                    CheckReceiver(this, IsTemporalZonedDateTime);
                    var t = GetSlot(this, _);
                    if (void 0 === e) throw new TypeError("options parameter is required");
                    var n = function GetDirectionOption(e) {
                        return GetOption(e, "direction", [
                            "next",
                            "previous"
                        ], We);
                    }("string" == typeof e ? CreateOnePropObject("direction", e) : GetOptionsObject(e));
                    if (void 0 === n) throw new TypeError("direction option is required");
                    if (IsOffsetTimeZoneIdentifier(t) || "UTC" === t) return null;
                    var r = GetSlot(this, v), a = "next" === n ? GetNamedTimeZoneNextTransition(t, r) : GetNamedTimeZonePreviousTransition(t, r);
                    return null === a ? null : CreateTemporalZonedDateTime(a, t, GetSlot(this, T));
                }
            },
            {
                key: "toInstant",
                value: function toInstant() {
                    return CheckReceiver(this, IsTemporalZonedDateTime), CreateTemporalInstant(GetSlot(this, v));
                }
            },
            {
                key: "toPlainDate",
                value: function toPlainDate() {
                    return CheckReceiver(this, IsTemporalZonedDateTime), CreateTemporalDate(dateTime(this).isoDate, GetSlot(this, T));
                }
            },
            {
                key: "toPlainTime",
                value: function toPlainTime() {
                    return CheckReceiver(this, IsTemporalZonedDateTime), CreateTemporalTime(dateTime(this).time);
                }
            },
            {
                key: "toPlainDateTime",
                value: function toPlainDateTime() {
                    return CheckReceiver(this, IsTemporalZonedDateTime), CreateTemporalDateTime(dateTime(this), GetSlot(this, T));
                }
            }
        ], [
            {
                key: "from",
                value: function from(e) {
                    return ToTemporalZonedDateTime(e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0);
                }
            },
            {
                key: "compare",
                value: function compare(e, n) {
                    var r = ToTemporalZonedDateTime(e), a = ToTemporalZonedDateTime(n), o = GetSlot(r, v), i = GetSlot(a, v);
                    return t.lessThan(t.BigInt(o), t.BigInt(i)) ? -1 : t.greaterThan(t.BigInt(o), t.BigInt(i)) ? 1 : 0;
                }
            }
        ]), ZonedDateTime;
    }();
    function dateTime(e) {
        return GetISODateTimeFor(GetSlot(e, _), GetSlot(e, v));
    }
    function getCalendarProperty(e, t) {
        CheckReceiver(e, IsTemporalZonedDateTime);
        var n = dateTime(e).isoDate;
        return calendarImplForObj(e).isoToDate(n, _defineProperty({}, t, !0))[t];
    }
    function getTimeProperty(e, t) {
        return CheckReceiver(e, IsTemporalZonedDateTime), dateTime(e).time[t];
    }
    MakeIntrinsicClass(tn, "Temporal.ZonedDateTime");
    for(var nn = Object.freeze({
        __proto__: null,
        Duration: $t,
        Instant: Wt,
        Now: Kt,
        PlainDate: zt,
        PlainDateTime: qt,
        PlainMonthDay: Vt,
        PlainTime: Xt,
        PlainYearMonth: Qt,
        ZonedDateTime: tn
    }), rn = function() {
        function LegacyDateImpl() {
            _classCallCheck(this, LegacyDateImpl);
        }
        return _createClass(LegacyDateImpl, [
            {
                key: "toTemporalInstant",
                value: function toTemporalInstant() {
                    return CreateTemporalInstant(epochMsToNs(Date.prototype.valueOf.call(this)));
                }
            }
        ]), LegacyDateImpl;
    }().prototype.toTemporalInstant, an = 0, on = [
        Wt,
        zt,
        qt,
        $t,
        Vt,
        Xt,
        Qt,
        tn
    ]; an < on.length; an++){
        var un = on[an], sn = Object.getOwnPropertyDescriptor(un, "prototype");
        (sn.configurable || sn.enumerable || sn.writable) && (sn.configurable = !1, sn.enumerable = !1, sn.writable = !1, Object.defineProperty(un, "prototype", sn));
    }
    e.Intl = Ht, e.Temporal = nn, e.toTemporalInstant = rn;
});



if (!globalThis.Temporal) globalThis.Temporal = $1ec499c2dc139e6f$exports.Temporal;
if (!globalThis.Intl) globalThis.Intl = $1ec499c2dc139e6f$exports.Intl;
function $e328e9d5f3d6b66a$export$2e2bcd8739ae039({ Hz: Hz = 200 }) {
    const expected = Temporal.Duration.from({
        microseconds: Math.trunc(1000000 / Hz)
    });
    const [running, setRunning] = (0, $acw62.useState)(false);
    const [startTime, setStartTime] = (0, $acw62.useState)(undefined);
    const [endTime, setEndTime] = (0, $acw62.useState)(undefined);
    const [totalDuration, setTotalDuration] = (0, $acw62.useState)(new Temporal.Duration());
    const [pausedDuration, setPausedDuration] = (0, $acw62.useState)(new Temporal.Duration());
    const [elapsedDuration, setElapsedDuration] = (0, $acw62.useState)(new Temporal.Duration());
    const intervalRef = (0, $acw62.useRef)(-1);
    const format = (duration)=>{
        return new Intl.DurationFormat("en-NZ", {
            style: "digital",
            hours: "2-digit"
        }).formatToParts(duration.round({
            largestUnit: "hours",
            smallestUnit: "milliseconds"
        }));
    };
    const onStart = ()=>{
        const initial = Temporal.Now.instant();
        setEndTime(initial);
        if (!startTime) setStartTime(initial);
        if (endTime) setPausedDuration((paused)=>paused.add(initial.since(endTime)));
        setRunning(true);
        intervalRef.current = setInterval(()=>{
            const instant = Temporal.Now.instant();
            setEndTime(instant);
        }, expected.total("milliseconds"));
    };
    const onStop = ()=>{
        setEndTime(Temporal.Now.instant());
        clearInterval(intervalRef.current);
        intervalRef.current = -1;
        setRunning(false);
    };
    const onReset = ()=>{
        setStartTime(!running ? undefined : Temporal.Now.instant());
        setEndTime(undefined);
        setTotalDuration(new Temporal.Duration());
        setPausedDuration(new Temporal.Duration());
    };
    (0, $acw62.useEffect)(()=>{
        setTotalDuration(endTime?.since(startTime ?? endTime, {
            largestUnit: "hours",
            smallestUnit: "millisecond"
        }) ?? new Temporal.Duration());
    }, [
        endTime,
        startTime
    ]);
    (0, $acw62.useEffect)(()=>setElapsedDuration(totalDuration.subtract(pausedDuration)), [
        totalDuration,
        pausedDuration
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "Timer",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("time", {
                    dateTime: elapsedDuration?.toJSON(),
                    children: [
                        format(elapsedDuration).map((part, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                "data-unit": part.unit,
                                "data-type": part.type,
                                "data-value": part.value,
                                children: part.type === "integer" ? part.value.padStart(2, "0") : part.type === "fraction" ? part.value.padStart(3, "0") : part.value
                            }, i)),
                        elapsedDuration.milliseconds ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    "data-unit": "second",
                                    "data-type": "decimal",
                                    "data-value": ".",
                                    children: "."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    "data-unit": "second",
                                    "data-type": "fraction",
                                    "data-value": "000",
                                    children: "000"
                                })
                            ]
                        })
                    ]
                }),
                running ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    title: "Stop",
                    onClick: onStop,
                    children: "\u23F9"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    title: "Start",
                    onClick: onStart,
                    children: "\u23F5"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    title: "Reset",
                    onClick: onReset,
                    children: "\u21BA"
                })
            ]
        })
    });
}


const $ad2bcec7a0192558$var$WebTimer = (0, $b8cd6b83d6b11fb7$export$2e2bcd8739ae039)((0, $e328e9d5f3d6b66a$export$2e2bcd8739ae039), {
    props: {
        Hz: "number"
    }
});
if (!customElements.get("web-timer")) customElements.define("web-timer", $ad2bcec7a0192558$var$WebTimer);


//# sourceMappingURL=timer-web.84e87dd2.js.map
